import { c as dn } from "./index-DZf_NV3o.js";
function ia(wt, Lt) {
  for (var We = 0; We < Lt.length; We++) {
    const $ = Lt[We];
    if (typeof $ != "string" && !Array.isArray($)) {
      for (const de in $)
        if (de !== "default" && !(de in wt)) {
          const dt = Object.getOwnPropertyDescriptor($, de);
          dt && Object.defineProperty(wt, de, dt.get ? dt : {
            enumerable: !0,
            get: () => $[de]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(wt, Symbol.toStringTag, { value: "Module" }));
}
var un = { exports: {} };
(function(wt, Lt) {
  (function(We, $) {
    $(Lt);
  })(dn, function(We) {
    var $, de, dt = Object.defineProperty, Co = Object.defineProperties, Ro = Object.getOwnPropertyDescriptors, xt = Object.getOwnPropertySymbols, pn = Object.prototype.hasOwnProperty, hn = Object.prototype.propertyIsEnumerable, mi = (t, e, i) => e in t ? dt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i, z = (t, e) => {
      for (var i in e || (e = {}))
        pn.call(e, i) && mi(t, i, e[i]);
      if (xt)
        for (var i of xt(e))
          hn.call(e, i) && mi(t, i, e[i]);
      return t;
    }, Te = (t, e) => Co(t, Ro(e)), Fe = (t, e) => {
      var i = {};
      for (var n in t)
        pn.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
      if (t != null && xt)
        for (var n of xt(t))
          e.indexOf(n) < 0 && hn.call(t, n) && (i[n] = t[n]);
      return i;
    }, T = (t, e, i) => (mi(t, typeof e != "symbol" ? e + "" : e, i), i), ue = (t, e, i) => new Promise((n, s) => {
      var o = (r) => {
        try {
          a(i.next(r));
        } catch (c) {
          s(c);
        }
      }, l = (r) => {
        try {
          a(i.throw(r));
        } catch (c) {
          s(c);
        }
      }, a = (r) => r.done ? n(r.value) : Promise.resolve(r.value).then(o, l);
      a((i = i.apply(t, e)).next());
    });
    function vo(t, e) {
      for (var i = 0; i < e.length; i++) {
        const n = e[i];
        if (typeof n != "string" && !Array.isArray(n)) {
          for (const s in n)
            if (s !== "default" && !(s in t)) {
              const o = Object.getOwnPropertyDescriptor(n, s);
              o && Object.defineProperty(t, s, o.get ? o : { enumerable: !0, get: () => n[s] });
            }
        }
      }
      return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
    }
    function Jt(t, e, i, n) {
      return new (i || (i = Promise))(function(s, o) {
        function l(c) {
          try {
            r(n.next(c));
          } catch (d) {
            o(d);
          }
        }
        function a(c) {
          try {
            r(n.throw(c));
          } catch (d) {
            o(d);
          }
        }
        function r(c) {
          var d;
          c.done ? s(c.value) : (d = c.value, d instanceof i ? d : new i(function(u) {
            u(d);
          })).then(l, a);
        }
        r((n = n.apply(t, e || [])).next());
      });
    }
    function ut(t) {
      const e = t == null ? void 0 : t.host;
      return (e == null ? void 0 : e.shadowRoot) === t;
    }
    function pt(t) {
      return Object.prototype.toString.call(t) === "[object ShadowRoot]";
    }
    function Kt(t) {
      try {
        const i = t.rules || t.cssRules;
        return i ? ((e = Array.from(i, mn).join("")).includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), e) : null;
      } catch (i) {
        return null;
      }
      var e;
    }
    function mn(t) {
      let e;
      if (function(i) {
        return "styleSheet" in i;
      }(t))
        try {
          e = Kt(t.styleSheet) || function(i) {
            const { cssText: n } = i;
            if (n.split('"').length < 3)
              return n;
            const s = ["@import", `url(${JSON.stringify(i.href)})`];
            return i.layerName === "" ? s.push("layer") : i.layerName && s.push(`layer(${i.layerName})`), i.supportsText && s.push(`supports(${i.supportsText})`), i.media.length && s.push(i.media.mediaText), s.join(" ") + ";";
          }(t);
        } catch (i) {
        }
      else if (function(i) {
        return "selectorText" in i;
      }(t) && t.selectorText.includes(":"))
        return function(i) {
          const n = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
          return i.replace(n, "$1\\$2");
        }(t.cssText);
      return e || t.cssText;
    }
    (de = $ || ($ = {}))[de.Document = 0] = "Document", de[de.DocumentType = 1] = "DocumentType", de[de.Element = 2] = "Element", de[de.Text = 3] = "Text", de[de.CDATA = 4] = "CDATA", de[de.Comment = 5] = "Comment";
    class bn {
      constructor() {
        this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
      }
      getId(e) {
        var i;
        if (!e)
          return -1;
        const n = (i = this.getMeta(e)) === null || i === void 0 ? void 0 : i.id;
        return n != null ? n : -1;
      }
      getNode(e) {
        return this.idNodeMap.get(e) || null;
      }
      getIds() {
        return Array.from(this.idNodeMap.keys());
      }
      getMeta(e) {
        return this.nodeMetaMap.get(e) || null;
      }
      removeNodeFromMap(e) {
        const i = this.getId(e);
        this.idNodeMap.delete(i), e.childNodes && e.childNodes.forEach((n) => this.removeNodeFromMap(n));
      }
      has(e) {
        return this.idNodeMap.has(e);
      }
      hasNode(e) {
        return this.nodeMetaMap.has(e);
      }
      add(e, i) {
        const n = i.id;
        this.idNodeMap.set(n, e), this.nodeMetaMap.set(e, i);
      }
      replace(e, i) {
        const n = this.getNode(e);
        if (n) {
          const s = this.nodeMetaMap.get(n);
          s && this.nodeMetaMap.set(i, s);
        }
        this.idNodeMap.set(e, i);
      }
      reset() {
        this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
      }
    }
    function _e(t) {
      return t.toLowerCase();
    }
    const Zn = "__rrweb_original__";
    function bi(t) {
      const e = t.type;
      return t.hasAttribute("data-rr-is-password") ? "password" : e ? _e(e) : null;
    }
    function yn(t, e) {
      var i;
      let n;
      try {
        n = new URL(t, e != null ? e : window.location.href);
      } catch (o) {
        return null;
      }
      const s = n.pathname.match(/\.([0-9a-z]+)(?:$)/i);
      return (i = s == null ? void 0 : s[1]) !== null && i !== void 0 ? i : null;
    }
    function Zi(t) {
      return t = ((t = t.replace(/[^ -~]+/g, "")) == null ? void 0 : t.split(" ").map((e) => Math.random().toString(20).substr(2, e.length)).join(" ")) || "";
    }
    function yi(t) {
      return t === "img" || t === "video" || t === "audio" || t === "source";
    }
    const ko = [new RegExp("[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*"), new RegExp("[0-9]{9,16}"), new RegExp("[0-9]{3}-?[0-9]{2}-?[0-9]{4}"), new RegExp("[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}"), new RegExp("[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}"), new RegExp("[0-9]{1,5}.?[0-9]{0,3}s[a-zA-Z]{2,30}s[a-zA-Z]{2,15}"), new RegExp("(?:[0-9]{1,3}.){3}[0-9]{1,3}")];
    function gn(t) {
      return !!t && ko.some((e) => e.test(t));
    }
    const In = ({ maskInputOptions: t, tagName: e, type: i, overwriteRecord: n }) => {
      const s = i && i.toLowerCase();
      return !(n === "true" || !t[e.toLowerCase()] && (!s || !t[s]));
    };
    function gi({ element: t, maskInputOptions: e, tagName: i, type: n, value: s, overwriteRecord: o, maskInputFn: l }) {
      let a = s || "";
      return In({ maskInputOptions: e, tagName: i, type: n, overwriteRecord: o }) && (a = l ? l(a, t) : "*".repeat(a.length)), a;
    }
    let To = 1;
    const No = new RegExp("[^a-z0-9-_:]"), ht = -2;
    function Sn() {
      return To++;
    }
    let qe, Vn;
    const wo = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Lo = /^(?:[a-z+]+:)?\/\//i, xo = /^www\..*/i, Jo = /^(data:)([^,]*),(.*)/i;
    function Yt(t, e) {
      return (t || "").replace(wo, (i, n, s, o, l, a) => {
        const r = s || l || a, c = n || o || "";
        if (!r)
          return i;
        if (Lo.test(r) || xo.test(r))
          return `url(${c}${r}${c})`;
        if (Jo.test(r))
          return `url(${c}${r}${c})`;
        if (r[0] === "/")
          return `url(${c}${function(p) {
            let m = "";
            return m = p.indexOf("//") > -1 ? p.split("/").slice(0, 3).join("/") : p.split("/")[0], m = m.split("?")[0], m;
          }(e) + r}${c})`;
        const d = e.split("/"), u = r.split("/");
        d.pop();
        for (const p of u)
          p !== "." && (p === ".." ? d.pop() : d.push(p));
        return `url(${c}${d.join("/")}${c})`;
      });
    }
    const Ko = /^[^ \t\n\r\u000c]+/, Yo = /^[, \t\n\r\u000c]+/;
    function mt(t, e) {
      if (!e || e.trim() === "")
        return e;
      const i = t.createElement("a");
      return i.href = e, i.href;
    }
    function Uo(t) {
      return !!(t.tagName === "svg" || t.ownerSVGElement);
    }
    function Ii() {
      const t = document.createElement("a");
      return t.href = "", t.href;
    }
    function Xn(t, e, i, n) {
      return n && (i === "src" || i === "href" && (e !== "use" || n[0] !== "#") || i === "xlink:href" && n[0] !== "#" ? mt(t, n) : i !== "background" || e !== "table" && e !== "td" && e !== "th" ? i === "srcset" ? function(s, o) {
        if (o.trim() === "")
          return o;
        let l = 0;
        function a(c) {
          let d;
          const u = c.exec(o.substring(l));
          return u ? (d = u[0], l += d.length, d) : "";
        }
        const r = [];
        for (; a(Yo), !(l >= o.length); ) {
          let c = a(Ko);
          if (c.slice(-1) === ",")
            c = mt(s, c.substring(0, c.length - 1)), r.push(c);
          else {
            let d = "";
            c = mt(s, c);
            let u = !1;
            for (; ; ) {
              const p = o.charAt(l);
              if (p === "") {
                r.push((c + d).trim());
                break;
              }
              if (u)
                p === ")" && (u = !1);
              else {
                if (p === ",") {
                  l += 1, r.push((c + d).trim());
                  break;
                }
                p === "(" && (u = !0);
              }
              d += p, l += 1;
            }
          }
        }
        return r.join(", ");
      }(t, n) : i === "style" ? Yt(n, Ii()) : e === "object" && i === "data" ? mt(t, n) : n : mt(t, n));
    }
    function Gn(t, e, i) {
      return (t === "video" || t === "audio") && e === "autoplay";
    }
    function Wn(t, e, i) {
      try {
        if (typeof e == "string") {
          if (t.classList.contains(e))
            return !0;
        } else
          for (let n = t.classList.length; n--; ) {
            const s = t.classList[n];
            if (e.test(s))
              return !0;
          }
        if (i)
          return t.matches(i);
      } catch (n) {
      }
      return !1;
    }
    function Ut(t, e, i) {
      if (!t)
        return !1;
      if (t.nodeType !== t.ELEMENT_NODE)
        return !!i && Ut(t.parentNode, e, i);
      for (let n = t.classList.length; n--; ) {
        const s = t.classList[n];
        if (e.test(s))
          return !0;
      }
      return !!i && Ut(t.parentNode, e, i);
    }
    function fn(t, e, i, n) {
      try {
        const s = t.nodeType === t.ELEMENT_NODE ? t : t.parentElement;
        if (s === null)
          return !1;
        if (typeof e == "string") {
          if (n) {
            if (s.closest(`.${e}`))
              return !0;
          } else if (s.classList.contains(e))
            return !0;
        } else if (Ut(s, e, n))
          return !0;
        if (i) {
          if (n) {
            if (s.closest(i))
              return !0;
          } else if (s.matches(i))
            return !0;
        }
      } catch (s) {
      }
      return !1;
    }
    function Fo(t, e) {
      const { doc: i, mirror: n, blockClass: s, blockSelector: o, needsMask: l, inlineStylesheet: a, maskInputOptions: r = {}, maskTextClass: c, maskTextFn: d, maskInputFn: u, dataURLOptions: p = {}, inlineImages: m, recordCanvas: I, keepIframeSrcFn: y, newlyAddedElement: W = !1, privacySetting: Z } = e, g = function(b, S) {
        if (!S.hasNode(b))
          return;
        const f = S.getId(b);
        return f === 1 ? void 0 : f;
      }(i, n);
      switch (t.nodeType) {
        case t.DOCUMENT_NODE:
          return t.compatMode !== "CSS1Compat" ? { type: $.Document, childNodes: [], compatMode: t.compatMode } : { type: $.Document, childNodes: [] };
        case t.DOCUMENT_TYPE_NODE:
          return { type: $.DocumentType, name: t.name, publicId: t.publicId, systemId: t.systemId, rootId: g };
        case t.ELEMENT_NODE:
          return function(b, S) {
            const { doc: f, blockClass: w, blockSelector: K, inlineStylesheet: Y, maskInputOptions: L = {}, maskInputFn: N, maskTextClass: x, dataURLOptions: k = {}, inlineImages: h, recordCanvas: V, keepIframeSrcFn: v, newlyAddedElement: C = !1, privacySetting: G, rootId: R } = S;
            let U = Wn(b, w, K);
            const q = Wn(b, x, null), ee = G === "strict";
            let P = function(F) {
              if (F instanceof HTMLFormElement)
                return "form";
              const B = _e(F.tagName);
              return No.test(B) ? "div" : B;
            }(b), M = {};
            const Se = b.attributes.length;
            for (let F = 0; F < Se; F++) {
              const B = b.attributes[F];
              Gn(P, B.name) || (M[B.name] = Xn(f, P, _e(B.name), B.value));
            }
            if (P === "link" && Y) {
              const F = Array.from(f.styleSheets).find((ce) => ce.href === b.href);
              let B = null;
              F && (B = Kt(F)), B && (delete M.rel, delete M.href, M._cssText = Yt(B, F.href));
            }
            if (P === "style" && b.sheet && !(b.innerText || b.textContent || "").trim().length) {
              const F = Kt(b.sheet);
              F && (M._cssText = Yt(F, Ii()));
            }
            if (P === "input" || P === "textarea" || P === "select") {
              const F = b.value, B = b.checked;
              M.type !== "radio" && M.type !== "checkbox" && M.type !== "submit" && M.type !== "button" && F ? M.value = gi({ element: b, type: bi(b), tagName: P, value: F, overwriteRecord: b.getAttribute("data-hl-record"), maskInputOptions: L, maskInputFn: N }) : B && (M.checked = B);
            }
            if (P === "option" && (b.selected && !L.select ? M.selected = !0 : delete M.selected), P === "canvas" && V) {
              if (b.__context === "2d")
                (function(F) {
                  const B = F.getContext("2d");
                  if (!B)
                    return !0;
                  for (let ce = 0; ce < F.width; ce += 50)
                    for (let xe = 0; xe < F.height; xe += 50) {
                      const ct = B.getImageData, Tt = Zn in ct ? ct[Zn] : ct;
                      if (new Uint32Array(Tt.call(B, ce, xe, Math.min(50, F.width - ce), Math.min(50, F.height - xe)).data.buffer).some((di) => di !== 0))
                        return !1;
                    }
                  return !0;
                })(b) || (M.rr_dataURL = b.toDataURL(k.type, k.quality));
              else if (!("__context" in b)) {
                const F = b.toDataURL(k.type, k.quality), B = document.createElement("canvas");
                B.width = b.width, B.height = b.height, F !== B.toDataURL(k.type, k.quality) && (M.rr_dataURL = F);
              }
            }
            if (P === "img" && h && !U && !q && !ee) {
              qe || (qe = f.createElement("canvas"), Vn = qe.getContext("2d"));
              const F = b, B = F.crossOrigin;
              F.crossOrigin = "anonymous";
              const ce = () => {
                F.removeEventListener("load", ce);
                try {
                  qe.width = F.naturalWidth, qe.height = F.naturalHeight, Vn.drawImage(F, 0, 0), M.rr_dataURL = qe.toDataURL(k.type, k.quality);
                } catch (xe) {
                  console.warn(`Cannot inline img src=${F.currentSrc}! Error: ${xe}`);
                }
                B ? M.crossOrigin = B : F.removeAttribute("crossorigin");
              };
              F.complete && F.naturalWidth !== 0 ? ce() : F.addEventListener("load", ce);
            }
            if (P !== "audio" && P !== "video" || (M.rr_mediaState = b.paused ? "paused" : "played", M.rr_mediaCurrentTime = b.currentTime), C || (b.scrollLeft && (M.rr_scrollLeft = b.scrollLeft), b.scrollTop && (M.rr_scrollTop = b.scrollTop)), U || q || ee && yi(P)) {
              const { width: F, height: B } = b.getBoundingClientRect();
              M = { class: M.class, rr_width: `${F}px`, rr_height: `${B}px` };
            }
            ee && yi(P) && (U = !0), P !== "iframe" || v(M.src) || (b.contentDocument || (M.rr_src = M.src), delete M.src);
            let Ge;
            try {
              customElements.get(P) && (Ge = !0);
            } catch (F) {
            }
            if (h && P === "video") {
              const F = b;
              if (F.src === "" || F.src.indexOf("blob:") !== -1) {
                const { width: B, height: ce } = b.getBoundingClientRect();
                M = { rr_width: `${B}px`, rr_height: `${ce}px`, rr_inlined_video: !0 }, P = "canvas";
              }
            }
            return { type: $.Element, tagName: P, attributes: M, childNodes: [], isSVG: Uo(b) || void 0, needBlock: U, needMask: q, rootId: R, isCustom: Ge };
          }(t, { doc: i, blockClass: s, blockSelector: o, inlineStylesheet: a, maskInputOptions: r, maskInputFn: u, maskTextClass: c, dataURLOptions: p, inlineImages: m, recordCanvas: I, keepIframeSrcFn: y, newlyAddedElement: W, privacySetting: Z, rootId: g });
        case t.TEXT_NODE:
          return function(b, S) {
            var f, w;
            const { needsMask: K, maskTextFn: Y, privacySetting: L, rootId: N } = S, x = b.parentNode && b.parentNode.tagName;
            let k = b.textContent;
            const h = x === "STYLE" || void 0, V = x === "SCRIPT" || void 0;
            let v = !1;
            if (h && k) {
              try {
                b.nextSibling || b.previousSibling || !((f = b.parentNode.sheet) === null || f === void 0) && f.cssRules && (k = Kt(b.parentNode.sheet));
              } catch (U) {
                console.warn(`Cannot get CSS styles from text's parentNode. Error: ${U}`, b);
              }
              k = Yt(k, Ii()), v = !0;
            }
            V ? (k = "SCRIPT_PLACEHOLDER", v = !0) : x === "NOSCRIPT" && (k = "", v = !0), !h && !V && k && K && (k = Y ? Y(k, b.parentElement) : k.replace(/[\S]/g, "*"));
            const C = L === "strict", G = (w = b.parentElement) === null || w === void 0 ? void 0 : w.getAttribute("data-hl-record"), R = L === "default" && gn(k);
            return (C || R) && !G && !v && x && !(/* @__PURE__ */ new Set(["HEAD", "TITLE", "STYLE", "SCRIPT", "HTML", "BODY", "NOSCRIPT"])).has(x) && k && (k = Zi(k)), { type: $.Text, textContent: k || "", isStyle: h, rootId: N };
          }(t, { needsMask: l, maskTextFn: d, privacySetting: Z, rootId: g });
        case t.CDATA_SECTION_NODE:
          return { type: $.CDATA, textContent: "", rootId: g };
        case t.COMMENT_NODE:
          return { type: $.Comment, textContent: t.textContent || "", rootId: g };
        default:
          return !1;
      }
    }
    function ie(t) {
      return t == null ? "" : t.toLowerCase();
    }
    function $e(t, e) {
      const { doc: i, mirror: n, blockClass: s, blockSelector: o, maskTextClass: l, maskTextSelector: a, skipChild: r = !1, inlineStylesheet: c = !0, maskInputOptions: d = {}, maskTextFn: u, maskInputFn: p, slimDOMOptions: m, dataURLOptions: I = {}, inlineImages: y = !1, recordCanvas: W = !1, onSerialize: Z, onIframeLoad: g, iframeLoadTimeout: b = 5e3, onStylesheetLoad: S, stylesheetLoadTimeout: f = 5e3, keepIframeSrcFn: w = () => !1, newlyAddedElement: K = !1, privacySetting: Y } = e;
      let { needsMask: L } = e, { preserveWhiteSpace: N = !0 } = e;
      !L && t.childNodes && (L = fn(t, l, a, L === void 0));
      const x = Fo(t, { doc: i, mirror: n, blockClass: s, blockSelector: o, needsMask: L, inlineStylesheet: c, maskInputOptions: d, maskTextClass: l, maskTextFn: u, maskInputFn: p, dataURLOptions: I, inlineImages: y, recordCanvas: W, keepIframeSrcFn: w, newlyAddedElement: K, privacySetting: Y });
      if (!x)
        return console.warn(t, "not serialized"), null;
      let k;
      k = n.hasNode(t) ? n.getId(t) : !function(G, R) {
        return !!(R.comment && G.type === $.Comment || G.type === $.Element && (R.script && (G.tagName === "script" || G.tagName === "link" && (G.attributes.rel === "preload" || G.attributes.rel === "modulepreload") && G.attributes.as === "script" || G.tagName === "link" && G.attributes.rel === "prefetch" && typeof G.attributes.href == "string" && yn(G.attributes.href) === "js") || R.headFavicon && (G.tagName === "link" && G.attributes.rel === "shortcut icon" || G.tagName === "meta" && (ie(G.attributes.name).match(/^msapplication-tile(image|color)$/) || ie(G.attributes.name) === "application-name" || ie(G.attributes.rel) === "icon" || ie(G.attributes.rel) === "apple-touch-icon" || ie(G.attributes.rel) === "shortcut icon")) || G.tagName === "meta" && (R.headMetaDescKeywords && ie(G.attributes.name).match(/^description|keywords$/) || R.headMetaSocial && (ie(G.attributes.property).match(/^(og|twitter|fb):/) || ie(G.attributes.name).match(/^(og|twitter):/) || ie(G.attributes.name) === "pinterest") || R.headMetaRobots && (ie(G.attributes.name) === "robots" || ie(G.attributes.name) === "googlebot" || ie(G.attributes.name) === "bingbot") || R.headMetaHttpEquiv && G.attributes["http-equiv"] !== void 0 || R.headMetaAuthorship && (ie(G.attributes.name) === "author" || ie(G.attributes.name) === "generator" || ie(G.attributes.name) === "framework" || ie(G.attributes.name) === "publisher" || ie(G.attributes.name) === "progid" || ie(G.attributes.property).match(/^article:/) || ie(G.attributes.property).match(/^product:/)) || R.headMetaVerification && (ie(G.attributes.name) === "google-site-verification" || ie(G.attributes.name) === "yandex-verification" || ie(G.attributes.name) === "csrf-token" || ie(G.attributes.name) === "p:domain_verify" || ie(G.attributes.name) === "verify-v1" || ie(G.attributes.name) === "verification" || ie(G.attributes.name) === "shopify-checkout-api-token"))));
      }(x, m) && (N || x.type !== $.Text || x.isStyle || x.textContent.replace(/^\s+|\s+$/gm, "").length) ? Sn() : ht;
      const h = Object.assign(x, { id: k });
      if (n.add(t, h), k === ht)
        return null;
      Z && Z(t);
      let V = !r, v = Y, C = Y === "strict";
      if (h.type === $.Element) {
        if (V = V && !h.needBlock, C || (C = !!h.needBlock || !!h.needMask), v = C ? "strict" : v, C && yi(h.tagName)) {
          const R = t.cloneNode();
          R.src = "", n.add(R, h);
        }
        delete h.needBlock, delete h.needMask;
        const G = t.shadowRoot;
        G && pt(G) && (h.isShadowHost = !0);
      }
      if ((h.type === $.Document || h.type === $.Element) && V) {
        m.headWhitespace && h.type === $.Element && h.tagName === "head" && (N = !1);
        const G = { doc: i, mirror: n, blockClass: s, blockSelector: o, needsMask: L, maskTextClass: l, maskTextSelector: a, skipChild: r, inlineStylesheet: c, maskInputOptions: d, maskTextFn: u, maskInputFn: p, slimDOMOptions: m, dataURLOptions: I, inlineImages: y, recordCanvas: W, preserveWhiteSpace: N, onSerialize: Z, onIframeLoad: g, iframeLoadTimeout: b, onStylesheetLoad: S, stylesheetLoadTimeout: f, keepIframeSrcFn: w, privacySetting: v };
        if (!(h.type === $.Element && h.tagName === "textarea" && h.attributes.value !== void 0))
          for (const R of Array.from(t.childNodes)) {
            const U = $e(R, G);
            U && h.childNodes.push(U);
          }
        if (function(R) {
          return R.nodeType === R.ELEMENT_NODE;
        }(t) && t.shadowRoot)
          for (const R of Array.from(t.shadowRoot.childNodes)) {
            const U = $e(R, G);
            U && (pt(t.shadowRoot) && (U.isShadow = !0), h.childNodes.push(U));
          }
      }
      return t.parentNode && ut(t.parentNode) && pt(t.parentNode) && (h.isShadow = !0), h.type === $.Element && h.tagName === "iframe" && function(G, R, U) {
        const q = G.contentWindow;
        if (!q)
          return;
        let ee, P = !1;
        try {
          ee = q.document.readyState;
        } catch (Se) {
          return;
        }
        if (ee !== "complete") {
          const Se = setTimeout(() => {
            P || (R(), P = !0);
          }, U);
          return void G.addEventListener("load", () => {
            clearTimeout(Se), P = !0, R();
          });
        }
        const M = "about:blank";
        if (q.location.href !== M || G.src === M || G.src === "")
          return setTimeout(R, 0), G.addEventListener("load", R);
        G.addEventListener("load", R);
      }(t, () => {
        const G = t.contentDocument;
        if (G && g) {
          const R = $e(G, { doc: G, mirror: n, blockClass: s, blockSelector: o, needsMask: L, maskTextClass: l, maskTextSelector: a, skipChild: !1, inlineStylesheet: c, maskInputOptions: d, maskTextFn: u, maskInputFn: p, slimDOMOptions: m, dataURLOptions: I, inlineImages: y, recordCanvas: W, preserveWhiteSpace: N, onSerialize: Z, onIframeLoad: g, iframeLoadTimeout: b, onStylesheetLoad: S, stylesheetLoadTimeout: f, keepIframeSrcFn: w, privacySetting: Y });
          R && g(t, R);
        }
      }, b), h.type === $.Element && h.tagName === "link" && typeof h.attributes.rel == "string" && (h.attributes.rel === "stylesheet" || h.attributes.rel === "preload" && typeof h.attributes.href == "string" && yn(h.attributes.href) === "css") && function(G, R, U) {
        let q, ee = !1;
        try {
          q = G.sheet;
        } catch (M) {
          return;
        }
        if (q)
          return;
        const P = setTimeout(() => {
          ee || (R(), ee = !0);
        }, U);
        G.addEventListener("load", () => {
          clearTimeout(P), ee = !0, R();
        });
      }(t, () => {
        if (S) {
          const G = $e(t, { doc: i, mirror: n, blockClass: s, blockSelector: o, needsMask: L, maskTextClass: l, maskTextSelector: a, skipChild: !1, inlineStylesheet: c, maskInputOptions: d, maskTextFn: u, maskInputFn: p, slimDOMOptions: m, dataURLOptions: I, inlineImages: y, recordCanvas: W, preserveWhiteSpace: N, onSerialize: Z, onIframeLoad: g, iframeLoadTimeout: b, onStylesheetLoad: S, stylesheetLoadTimeout: f, keepIframeSrcFn: w, privacySetting: Y });
          G && S(t, G);
        }
      }, f), h;
    }
    function be(t, e, i = document) {
      const n = { capture: !0 };
      return i.addEventListener(t, e, n), () => i.removeEventListener(t, e, n);
    }
    const et = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
    let Cn = { map: {}, getId: () => (console.error(et), -1), getNode: () => (console.error(et), null), removeNodeFromMap() {
      console.error(et);
    }, has: () => (console.error(et), !1), reset() {
      console.error(et);
    } };
    function bt(t, e, i = {}) {
      let n = null, s = 0;
      return function(...o) {
        const l = Date.now();
        s || i.leading !== !1 || (s = l);
        const a = e - (l - s), r = this;
        a <= 0 || a > e ? (n && (clearTimeout(n), n = null), s = l, t.apply(r, o)) : n || i.trailing === !1 || (n = setTimeout(() => {
          s = i.leading === !1 ? 0 : Date.now(), n = null, t.apply(r, o);
        }, a));
      };
    }
    function Ft(t, e, i, n, s = window) {
      const o = s.Object.getOwnPropertyDescriptor(t, e);
      return s.Object.defineProperty(t, e, n ? i : { set(l) {
        setTimeout(() => {
          i.set.call(this, l);
        }, 0), o && o.set && o.set.call(this, l);
      } }), () => Ft(t, e, o || {}, !0);
    }
    function tt(t, e, i) {
      try {
        if (!(e in t))
          return () => {
          };
        const n = t[e], s = i(n);
        return typeof s == "function" && (s.prototype = s.prototype || {}, Object.defineProperties(s, { __rrweb_original__: { enumerable: !1, value: n } })), t[e] = s, () => {
          t[e] = n;
        };
      } catch (n) {
        return () => {
        };
      }
    }
    typeof window != "undefined" && window.Proxy && window.Reflect && (Cn = new Proxy(Cn, { get: (t, e, i) => (e === "map" && console.error(et), Reflect.get(t, e, i)) }));
    let Ht = Date.now;
    function Rn(t) {
      var e, i, n, s, o, l;
      const a = t.document;
      return { left: a.scrollingElement ? a.scrollingElement.scrollLeft : t.pageXOffset !== void 0 ? t.pageXOffset : (a == null ? void 0 : a.documentElement.scrollLeft) || ((i = (e = a == null ? void 0 : a.body) === null || e === void 0 ? void 0 : e.parentElement) === null || i === void 0 ? void 0 : i.scrollLeft) || ((n = a == null ? void 0 : a.body) === null || n === void 0 ? void 0 : n.scrollLeft) || 0, top: a.scrollingElement ? a.scrollingElement.scrollTop : t.pageYOffset !== void 0 ? t.pageYOffset : (a == null ? void 0 : a.documentElement.scrollTop) || ((o = (s = a == null ? void 0 : a.body) === null || s === void 0 ? void 0 : s.parentElement) === null || o === void 0 ? void 0 : o.scrollTop) || ((l = a == null ? void 0 : a.body) === null || l === void 0 ? void 0 : l.scrollTop) || 0 };
    }
    function vn() {
      return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
    }
    function kn() {
      return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
    }
    function Tn(t) {
      return t ? t.nodeType === t.ELEMENT_NODE ? t : t.parentElement : null;
    }
    /[1-9][0-9]{12}/.test(Date.now().toString()) || (Ht = () => (/* @__PURE__ */ new Date()).getTime());
    const Ho = (t) => {
      try {
        if (t instanceof HTMLElement)
          return t.tagName === "CANVAS";
      } catch (e) {
        return !1;
      }
      return !1;
    };
    function me(t, e, i, n) {
      if (!t)
        return !1;
      const s = Tn(t);
      if (!s)
        return !1;
      try {
        if (typeof e == "string") {
          if (s.classList.contains(e) || n && s.closest("." + e) !== null)
            return !0;
        } else if (Ut(s, e, n))
          return !0;
      } catch (o) {
      }
      return !!(i && (s.matches(i) || n && s.closest(i) !== null));
    }
    function Si(t, e) {
      return e.getId(t) === ht;
    }
    function Nn(t, e) {
      if (ut(t))
        return !1;
      const i = e.getId(t);
      return !e.has(i) || (!t.parentNode || t.parentNode.nodeType !== t.DOCUMENT_NODE) && (!t.parentNode || Nn(t.parentNode, e));
    }
    function Vi(t) {
      return !!t.changedTouches;
    }
    function wn(t, e) {
      return !!(t.nodeName === "IFRAME" && e.getMeta(t));
    }
    function Ln(t, e) {
      return !!(t.nodeName === "LINK" && t.nodeType === t.ELEMENT_NODE && t.getAttribute && t.getAttribute("rel") === "stylesheet" && e.getMeta(t));
    }
    function Xi(t) {
      return !!(t != null && t.shadowRoot);
    }
    class Eo {
      constructor() {
        this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
      }
      getId(e) {
        var i;
        return (i = this.styleIDMap.get(e)) !== null && i !== void 0 ? i : -1;
      }
      has(e) {
        return this.styleIDMap.has(e);
      }
      add(e, i) {
        if (this.has(e))
          return this.getId(e);
        let n;
        return n = i === void 0 ? this.id++ : i, this.styleIDMap.set(e, n), this.idStyleMap.set(n, e), n;
      }
      getStyle(e) {
        return this.idStyleMap.get(e) || null;
      }
      reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
      }
      generateId() {
        return this.id++;
      }
    }
    function xn(t) {
      var e, i;
      let n = null;
      return ((i = (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t)) === null || i === void 0 ? void 0 : i.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && t.getRootNode().host && (n = t.getRootNode().host), n;
    }
    function Mo(t) {
      const e = t.ownerDocument;
      if (!e)
        return !1;
      const i = function(n) {
        let s, o = n;
        for (; s = xn(o); )
          o = s;
        return o;
      }(t);
      return e.contains(i);
    }
    function Jn(t) {
      const e = t.ownerDocument;
      return !!e && (e.contains(t) || Mo(t));
    }
    var j = ((t) => (t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))(j || {}), D = ((t) => (t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))(D || {}), ge = ((t) => (t[t.MouseUp = 0] = "MouseUp", t[t.MouseDown = 1] = "MouseDown", t[t.Click = 2] = "Click", t[t.ContextMenu = 3] = "ContextMenu", t[t.DblClick = 4] = "DblClick", t[t.Focus = 5] = "Focus", t[t.Blur = 6] = "Blur", t[t.TouchStart = 7] = "TouchStart", t[t.TouchMove_Departed = 8] = "TouchMove_Departed", t[t.TouchEnd = 9] = "TouchEnd", t[t.TouchCancel = 10] = "TouchCancel", t))(ge || {}), He = ((t) => (t[t.Mouse = 0] = "Mouse", t[t.Pen = 1] = "Pen", t[t.Touch = 2] = "Touch", t))(He || {}), it = ((t) => (t[t["2D"] = 0] = "2D", t[t.WebGL = 1] = "WebGL", t[t.WebGL2 = 2] = "WebGL2", t))(it || {});
    function Kn(t) {
      return "__ln" in t;
    }
    class Oo {
      constructor() {
        this.length = 0, this.head = null, this.tail = null;
      }
      get(e) {
        if (e >= this.length)
          throw new Error("Position outside of list range");
        let i = this.head;
        for (let n = 0; n < e; n++)
          i = (i == null ? void 0 : i.next) || null;
        return i;
      }
      addNode(e) {
        const i = { value: e, previous: null, next: null };
        if (e.__ln = i, e.previousSibling && Kn(e.previousSibling)) {
          const n = e.previousSibling.__ln.next;
          i.next = n, i.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = i, n && (n.previous = i);
        } else if (e.nextSibling && Kn(e.nextSibling) && e.nextSibling.__ln.previous) {
          const n = e.nextSibling.__ln.previous;
          i.previous = n, i.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = i, n && (n.next = i);
        } else
          this.head && (this.head.previous = i), i.next = this.head, this.head = i;
        i.next === null && (this.tail = i), this.length++;
      }
      removeNode(e) {
        const i = e.__ln;
        this.head && (i.previous ? (i.previous.next = i.next, i.next ? i.next.previous = i.previous : this.tail = i.previous) : (this.head = i.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
      }
    }
    const Yn = (t, e) => `${t}@${e}`;
    class zo {
      constructor() {
        this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (e) => {
          e.forEach(this.processMutation), this.emit();
        }, this.emit = () => {
          if (this.frozen || this.locked)
            return;
          const e = [], i = /* @__PURE__ */ new Set(), n = new Oo(), s = (r) => {
            let c = r, d = ht;
            for (; d === ht; )
              c = c && c.nextSibling, d = c && this.mirror.getId(c);
            return d;
          }, o = (r) => {
            if (!r.parentNode || !Jn(r) || r.parentNode.tagName === "TEXTAREA")
              return;
            const c = ut(r.parentNode) ? this.mirror.getId(xn(r)) : this.mirror.getId(r.parentNode), d = s(r);
            if (c === -1 || d === -1)
              return n.addNode(r);
            const u = $e(r, { doc: this.doc, mirror: this.mirror, blockClass: this.blockClass, blockSelector: this.blockSelector, maskTextClass: this.maskTextClass, maskTextSelector: this.maskTextSelector, skipChild: !0, newlyAddedElement: !0, inlineStylesheet: this.inlineStylesheet, maskInputOptions: this.maskInputOptions, maskTextFn: this.maskTextFn, maskInputFn: this.maskInputFn, slimDOMOptions: this.slimDOMOptions, dataURLOptions: this.dataURLOptions, recordCanvas: this.recordCanvas, inlineImages: this.inlineImages, privacySetting: this.privacySetting, onSerialize: (p) => {
              wn(p, this.mirror) && this.iframeManager.addIframe(p), Ln(p, this.mirror) && this.stylesheetManager.trackLinkElement(p), Xi(r) && this.shadowDomManager.addShadowRoot(r.shadowRoot, this.doc);
            }, onIframeLoad: (p, m) => {
              this.iframeManager.attachIframe(p, m), this.shadowDomManager.observeAttachShadow(p);
            }, onStylesheetLoad: (p, m) => {
              this.stylesheetManager.attachLinkElement(p, m);
            } });
            u && (e.push({ parentId: c, nextId: d, node: u }), i.add(u.id));
          };
          for (; this.mapRemoves.length; )
            this.mirror.removeNodeFromMap(this.mapRemoves.shift());
          for (const r of this.movedSet)
            Un(this.removes, r, this.mirror) && !this.movedSet.has(r.parentNode) || o(r);
          for (const r of this.addedSet)
            Hn(this.droppedSet, r) || Un(this.removes, r, this.mirror) ? Hn(this.movedSet, r) ? o(r) : this.droppedSet.add(r) : o(r);
          let l = null;
          for (; n.length; ) {
            let r = null;
            if (l) {
              const c = this.mirror.getId(l.value.parentNode), d = s(l.value);
              c !== -1 && d !== -1 && (r = l);
            }
            if (!r) {
              let c = n.tail;
              for (; c; ) {
                const d = c;
                if (c = c.previous, d) {
                  const u = this.mirror.getId(d.value.parentNode);
                  if (s(d.value) === -1)
                    continue;
                  if (u !== -1) {
                    r = d;
                    break;
                  }
                  {
                    const p = d.value;
                    if (p.parentNode && p.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                      const m = p.parentNode.host;
                      if (this.mirror.getId(m) !== -1) {
                        r = d;
                        break;
                      }
                    }
                  }
                }
              }
            }
            if (!r) {
              for (; n.head; )
                n.removeNode(n.head.value);
              break;
            }
            l = r.previous, n.removeNode(r.value), o(r.value);
          }
          const a = { texts: this.texts.map((r) => {
            var c, d;
            const u = r.node;
            u.parentNode && u.parentNode.tagName === "TEXTAREA" && this.genTextAreaValueMutation(u.parentNode);
            let p = r.value;
            const m = this.privacySetting === "strict", I = this.privacySetting === "default" && gn(p), y = (d = (c = r.node) === null || c === void 0 ? void 0 : c.parentElement) === null || d === void 0 ? void 0 : d.getAttribute("data-hl-record");
            return (m || I) && !y && p && (p = Zi(p)), { id: this.mirror.getId(u), value: p };
          }).filter((r) => !i.has(r.id)).filter((r) => this.mirror.has(r.id)), attributes: this.attributes.map((r) => {
            const { attributes: c } = r;
            if (typeof c.style == "string") {
              const d = JSON.stringify(r.styleDiff), u = JSON.stringify(r._unchangedStyles);
              d.length < c.style.length && (d + u).split("var(").length === c.style.split("var(").length && (c.style = r.styleDiff);
            }
            return { id: this.mirror.getId(r.node), attributes: c };
          }).filter((r) => !i.has(r.id)).filter((r) => this.mirror.has(r.id)), removes: this.removes, adds: e };
          (a.texts.length || a.attributes.length || a.removes.length || a.adds.length) && (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(a));
        }, this.genTextAreaValueMutation = (e) => {
          let i = this.attributeMap.get(e);
          i || (i = { node: e, attributes: {}, styleDiff: {}, _unchangedStyles: {} }, this.attributes.push(i), this.attributeMap.set(e, i)), i.attributes.value = Array.from(e.childNodes, (n) => n.textContent || "").join("");
        }, this.processMutation = (e) => {
          if (!Si(e.target, this.mirror))
            switch (e.type) {
              case "characterData": {
                const i = e.target.textContent;
                me(e.target, this.blockClass, this.blockSelector, !1) || i === e.oldValue || this.texts.push({ value: fn(e.target, this.maskTextClass, this.maskTextSelector, !0) && i ? this.maskTextFn ? this.maskTextFn(i, Tn(e.target)) : i.replace(/[\S]/g, "*") : i, node: e.target });
                break;
              }
              case "attributes": {
                const i = e.target;
                let n = e.attributeName, s = e.target.getAttribute(n);
                if (n === "value") {
                  const l = bi(i);
                  s = gi({ element: i, maskInputOptions: this.maskInputOptions, tagName: i.tagName, type: l, value: s, overwriteRecord: i.getAttribute("data-hl-record"), maskInputFn: this.maskInputFn });
                }
                if (me(e.target, this.blockClass, this.blockSelector, !1) || s === e.oldValue)
                  return;
                let o = this.attributeMap.get(e.target);
                if (i.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(s)) {
                  if (i.contentDocument)
                    return;
                  n = "rr_src";
                }
                if (o || (o = { node: e.target, attributes: {}, styleDiff: {}, _unchangedStyles: {} }, this.attributes.push(o), this.attributeMap.set(e.target, o)), n === "type" && i.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && i.setAttribute("data-rr-is-password", "true"), !Gn(i.tagName, n)) {
                  if (e.target.tagName === "INPUT") {
                    const l = e.target;
                    if (l.type === "password") {
                      o.attributes.value = "*".repeat(l.value.length);
                      break;
                    }
                  }
                  if (o.attributes[n] = Xn(this.doc, _e(i.tagName), _e(n), s), n === "style") {
                    if (!this.unattachedDoc)
                      try {
                        this.unattachedDoc = document.implementation.createHTMLDocument();
                      } catch (a) {
                        this.unattachedDoc = this.doc;
                      }
                    const l = this.unattachedDoc.createElement("span");
                    e.oldValue && l.setAttribute("style", e.oldValue);
                    for (const a of Array.from(i.style)) {
                      const r = i.style.getPropertyValue(a), c = i.style.getPropertyPriority(a);
                      r !== l.style.getPropertyValue(a) || c !== l.style.getPropertyPriority(a) ? o.styleDiff[a] = c === "" ? r : [r, c] : o._unchangedStyles[a] = [r, c];
                    }
                    for (const a of Array.from(l.style))
                      i.style.getPropertyValue(a) === "" && (o.styleDiff[a] = !1);
                  }
                }
                break;
              }
              case "childList":
                if (me(e.target, this.blockClass, this.blockSelector, !0))
                  return;
                if (e.target.tagName === "TEXTAREA")
                  return void this.genTextAreaValueMutation(e.target);
                e.addedNodes.forEach((i) => this.genAdds(i, e.target)), e.removedNodes.forEach((i) => {
                  const n = this.mirror.getId(i), s = ut(e.target) ? this.mirror.getId(e.target.host) : this.mirror.getId(e.target);
                  me(e.target, this.blockClass, this.blockSelector, !1) || Si(i, this.mirror) || !function(o, l) {
                    return l.getId(o) !== -1;
                  }(i, this.mirror) || (this.addedSet.has(i) ? (Gi(this.addedSet, i), this.droppedSet.add(i)) : this.addedSet.has(e.target) && n === -1 || Nn(e.target, this.mirror) || (this.movedSet.has(i) && this.movedMap[Yn(n, s)] ? Gi(this.movedSet, i) : this.removes.push({ parentId: s, id: n, isShadow: !(!ut(e.target) || !pt(e.target)) || void 0 })), this.mapRemoves.push(i));
                });
            }
        }, this.genAdds = (e, i) => {
          if (!this.processedNodeManager.inOtherBuffer(e, this) && !this.addedSet.has(e) && !this.movedSet.has(e)) {
            if (this.mirror.hasNode(e)) {
              if (Si(e, this.mirror))
                return;
              this.movedSet.add(e);
              let n = null;
              i && this.mirror.hasNode(i) && (n = this.mirror.getId(i)), n && n !== -1 && (this.movedMap[Yn(this.mirror.getId(e), n)] = !0);
            } else
              this.addedSet.add(e), this.droppedSet.delete(e);
            me(e, this.blockClass, this.blockSelector, !1) || (e.childNodes.forEach((n) => this.genAdds(n)), Xi(e) && e.shadowRoot.childNodes.forEach((n) => {
              this.processedNodeManager.add(n, this), this.genAdds(n, e);
            }));
          }
        };
      }
      init(e) {
        ["mutationCb", "blockClass", "blockSelector", "maskTextClass", "maskTextSelector", "inlineStylesheet", "maskInputOptions", "maskTextFn", "maskInputFn", "keepIframeSrcFn", "recordCanvas", "inlineImages", "privacySetting", "slimDOMOptions", "dataURLOptions", "doc", "mirror", "iframeManager", "stylesheetManager", "shadowDomManager", "canvasManager", "processedNodeManager"].forEach((i) => {
          this[i] = e[i];
        });
      }
      freeze() {
        this.frozen = !0, this.canvasManager.freeze();
      }
      unfreeze() {
        this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
      }
      isFrozen() {
        return this.frozen;
      }
      lock() {
        this.locked = !0, this.canvasManager.lock();
      }
      unlock() {
        this.locked = !1, this.canvasManager.unlock(), this.emit();
      }
      reset() {
        this.shadowDomManager.reset(), this.canvasManager.reset();
      }
    }
    function Gi(t, e) {
      t.delete(e), e.childNodes.forEach((i) => Gi(t, i));
    }
    function Un(t, e, i) {
      return t.length !== 0 && Fn(t, e, i);
    }
    function Fn(t, e, i) {
      const { parentNode: n } = e;
      if (!n)
        return !1;
      const s = i.getId(n);
      return !!t.some((o) => o.id === s) || Fn(t, n, i);
    }
    function Hn(t, e) {
      return t.size !== 0 && En(t, e);
    }
    function En(t, e) {
      const { parentNode: i } = e;
      return !!i && (!!t.has(i) || En(t, i));
    }
    let Zt;
    const Q = (t) => Zt ? (...e) => {
      try {
        return t(...e);
      } catch (i) {
        if (Zt && Zt(i) === !0)
          return;
        throw i;
      }
    } : t, Oe = [];
    function yt(t) {
      try {
        if ("composedPath" in t) {
          const e = t.composedPath();
          if (e.length)
            return e[0];
        } else if ("path" in t && t.path.length)
          return t.path[0];
      } catch (e) {
      }
      return t && t.target;
    }
    function Mn(t, e) {
      var i, n;
      const s = new zo();
      Oe.push(s), s.init(t);
      let o = window.MutationObserver || window.__rrMutationObserver;
      const l = (n = (i = window == null ? void 0 : window.Zone) === null || i === void 0 ? void 0 : i.__symbol__) === null || n === void 0 ? void 0 : n.call(i, "MutationObserver");
      l && window[l] && (o = window[l]);
      const a = new o(Q(s.processMutations.bind(s)));
      return a.observe(e, { attributes: !0, attributeOldValue: !0, characterData: !0, characterDataOldValue: !0, childList: !0, subtree: !0 }), a;
    }
    function Bo({ mouseInteractionCb: t, doc: e, mirror: i, blockClass: n, blockSelector: s, sampling: o }) {
      if (o.mouseInteraction === !1)
        return () => {
        };
      const l = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, a = [];
      let r = null;
      return Object.keys(ge).filter((c) => Number.isNaN(Number(c)) && !c.endsWith("_Departed") && l[c] !== !1).forEach((c) => {
        let d = _e(c);
        const u = /* @__PURE__ */ ((p) => (m) => {
          const I = yt(m);
          if (me(I, n, s, !0) || Ho(I))
            return;
          let y = null, W = p;
          if ("pointerType" in m) {
            switch (m.pointerType) {
              case "mouse":
                y = He.Mouse;
                break;
              case "touch":
                y = He.Touch;
                break;
              case "pen":
                y = He.Pen;
            }
            y === He.Touch && (ge[p] === ge.MouseDown ? W = "TouchStart" : ge[p] === ge.MouseUp && (W = "TouchEnd"));
          } else
            Vi(m) && (y = He.Touch);
          y !== null ? (r = y, (W.startsWith("Touch") && y === He.Touch || W.startsWith("Mouse") && y === He.Mouse) && (y = null)) : ge[p] === ge.Click && (y = r, r = null);
          const Z = Vi(m) ? m.changedTouches[0] : m;
          if (!Z)
            return;
          const g = i.getId(I), { clientX: b, clientY: S } = Z;
          Q(t)(Object.assign({ type: ge[W], id: g, x: b, y: S }, y !== null && { pointerType: y }));
        })(c);
        if (window.PointerEvent)
          switch (ge[c]) {
            case ge.MouseDown:
            case ge.MouseUp:
              d = d.replace("mouse", "pointer");
              break;
            case ge.TouchStart:
            case ge.TouchEnd:
              return;
          }
        a.push(be(d, u, e));
      }), Q(() => {
        a.forEach((c) => c());
      });
    }
    function On({ scrollCb: t, doc: e, mirror: i, blockClass: n, blockSelector: s, sampling: o }) {
      return be("scroll", Q(bt(Q((l) => {
        const a = yt(l);
        if (!a || me(a, n, s, !0))
          return;
        const r = i.getId(a);
        if (a === e && e.defaultView) {
          const c = Rn(e.defaultView);
          t({ id: r, x: c.left, y: c.top });
        } else
          t({ id: r, x: a.scrollLeft, y: a.scrollTop });
      }), o.scroll || 100)), e);
    }
    const Po = ["INPUT", "TEXTAREA", "SELECT"], zn = /* @__PURE__ */ new WeakMap();
    function Et(t) {
      return function(e, i) {
        if (Mt("CSSGroupingRule") && e.parentRule instanceof CSSGroupingRule || Mt("CSSMediaRule") && e.parentRule instanceof CSSMediaRule || Mt("CSSSupportsRule") && e.parentRule instanceof CSSSupportsRule || Mt("CSSConditionRule") && e.parentRule instanceof CSSConditionRule) {
          const n = Array.from(e.parentRule.cssRules).indexOf(e);
          i.unshift(n);
        } else if (e.parentStyleSheet) {
          const n = Array.from(e.parentStyleSheet.cssRules).indexOf(e);
          i.unshift(n);
        }
        return i;
      }(t, []);
    }
    function Ee(t, e, i) {
      let n, s;
      return t ? (t.ownerNode ? n = e.getId(t.ownerNode) : s = i.getId(t), { styleId: s, id: n }) : {};
    }
    function Bn({ mirror: t, stylesheetManager: e }, i) {
      var n, s, o;
      let l = null;
      l = i.nodeName === "#document" ? t.getId(i) : t.getId(i.host);
      const a = i.nodeName === "#document" ? (n = i.defaultView) === null || n === void 0 ? void 0 : n.Document : (o = (s = i.ownerDocument) === null || s === void 0 ? void 0 : s.defaultView) === null || o === void 0 ? void 0 : o.ShadowRoot, r = a != null && a.prototype ? Object.getOwnPropertyDescriptor(a == null ? void 0 : a.prototype, "adoptedStyleSheets") : void 0;
      return l !== null && l !== -1 && a && r ? (Object.defineProperty(i, "adoptedStyleSheets", { configurable: r.configurable, enumerable: r.enumerable, get() {
        var c;
        return (c = r.get) === null || c === void 0 ? void 0 : c.call(this);
      }, set(c) {
        var d;
        const u = (d = r.set) === null || d === void 0 ? void 0 : d.call(this, c);
        if (l !== null && l !== -1)
          try {
            e.adoptStyleSheets(c, l);
          } catch (p) {
          }
        return u;
      } }), Q(() => {
        Object.defineProperty(i, "adoptedStyleSheets", { configurable: r.configurable, enumerable: r.enumerable, get: r.get, set: r.set });
      })) : () => {
      };
    }
    function Ao(t, e = {}) {
      const i = t.doc.defaultView;
      if (!i)
        return () => {
        };
      let n;
      (function(Z, g) {
        const { mutationCb: b, mousemoveCb: S, mouseInteractionCb: f, scrollCb: w, viewportResizeCb: K, inputCb: Y, mediaInteractionCb: L, styleSheetRuleCb: N, styleDeclarationCb: x, canvasMutationCb: k, fontCb: h, selectionCb: V, customElementCb: v } = Z;
        Z.mutationCb = (...C) => {
          g.mutation && g.mutation(...C), b(...C);
        }, Z.mousemoveCb = (...C) => {
          g.mousemove && g.mousemove(...C), S(...C);
        }, Z.mouseInteractionCb = (...C) => {
          g.mouseInteraction && g.mouseInteraction(...C), f(...C);
        }, Z.scrollCb = (...C) => {
          g.scroll && g.scroll(...C), w(...C);
        }, Z.viewportResizeCb = (...C) => {
          g.viewportResize && g.viewportResize(...C), K(...C);
        }, Z.inputCb = (...C) => {
          g.input && g.input(...C), Y(...C);
        }, Z.mediaInteractionCb = (...C) => {
          g.mediaInteaction && g.mediaInteaction(...C), L(...C);
        }, Z.styleSheetRuleCb = (...C) => {
          g.styleSheetRule && g.styleSheetRule(...C), N(...C);
        }, Z.styleDeclarationCb = (...C) => {
          g.styleDeclaration && g.styleDeclaration(...C), x(...C);
        }, Z.canvasMutationCb = (...C) => {
          g.canvasMutation && g.canvasMutation(...C), k(...C);
        }, Z.fontCb = (...C) => {
          g.font && g.font(...C), h(...C);
        }, Z.selectionCb = (...C) => {
          g.selection && g.selection(...C), V(...C);
        }, Z.customElementCb = (...C) => {
          g.customElement && g.customElement(...C), v(...C);
        };
      })(t, e), t.recordDOM && (n = Mn(t, t.doc));
      const s = function({ mousemoveCb: Z, sampling: g, doc: b, mirror: S }) {
        if (g.mousemove === !1)
          return () => {
          };
        const f = typeof g.mousemove == "number" ? g.mousemove : 50, w = typeof g.mousemoveCallback == "number" ? g.mousemoveCallback : 500;
        let K, Y = [];
        const L = bt(Q((k) => {
          const h = Date.now() - K;
          Z(Y.map((V) => (V.timeOffset -= h, V)), k), Y = [], K = null;
        }), w), N = Q(bt(Q((k) => {
          const h = yt(k), { clientX: V, clientY: v } = Vi(k) ? k.changedTouches[0] : k;
          K || (K = Ht()), Y.push({ x: V, y: v, id: S.getId(h), timeOffset: Ht() - K }), L(typeof DragEvent != "undefined" && k instanceof DragEvent ? D.Drag : k instanceof MouseEvent ? D.MouseMove : D.TouchMove);
        }), f, { trailing: !1 })), x = [be("mousemove", N, b), be("touchmove", N, b), be("drag", N, b)];
        return Q(() => {
          x.forEach((k) => k());
        });
      }(t), o = Bo(t), l = On(t), a = function({ viewportResizeCb: Z }, { win: g }) {
        let b = -1, S = -1;
        return be("resize", Q(bt(Q(() => {
          const f = vn(), w = kn();
          b === f && S === w || (Z({ width: Number(w), height: Number(f) }), b = f, S = w);
        }), 200)), g);
      }(t, { win: i }), r = function({ inputCb: Z, doc: g, mirror: b, blockClass: S, blockSelector: f, ignoreClass: w, ignoreSelector: K, maskInputOptions: Y, maskInputFn: L, sampling: N, userTriggeredOnInput: x }) {
        function k(R) {
          let U = yt(R);
          const q = R.isTrusted, ee = U && U.tagName;
          if (U && ee === "OPTION" && (U = U.parentElement), !U || !ee || Po.indexOf(ee) < 0 || me(U, S, f, !0) || U.classList.contains(w) || K && U.matches(K))
            return;
          let P = U.value, M = !1;
          const Se = bi(U) || "", Ge = U.getAttribute("data-hl-record");
          Se === "radio" || Se === "checkbox" ? M = U.checked : In({ maskInputOptions: Y, type: Se, tagName: ee, overwriteRecord: Ge }) && (P = gi({ element: U, maskInputOptions: Y, tagName: ee, type: Se, value: P, overwriteRecord: Ge, maskInputFn: L })), h(U, x ? { text: P, isChecked: M, userTriggered: q } : { text: P, isChecked: M });
          const F = U.name;
          Se === "radio" && F && M && g.querySelectorAll(`input[type="radio"][name="${F}"]`).forEach((B) => {
            if (B !== U) {
              const ce = B.value;
              h(B, x ? { text: ce, isChecked: !M, userTriggered: !1 } : { text: ce, isChecked: !M });
            }
          });
        }
        function h(R, U) {
          const q = zn.get(R);
          if (!q || q.text !== U.text || q.isChecked !== U.isChecked) {
            zn.set(R, U);
            const ee = b.getId(R);
            Q(Z)(Object.assign(Object.assign({}, U), { id: ee }));
          }
        }
        const V = (N.input === "last" ? ["change"] : ["input", "change"]).map((R) => be(R, Q(k), g)), v = g.defaultView;
        if (!v)
          return () => {
            V.forEach((R) => R());
          };
        const C = v.Object.getOwnPropertyDescriptor(v.HTMLInputElement.prototype, "value"), G = [[v.HTMLInputElement.prototype, "value"], [v.HTMLInputElement.prototype, "checked"], [v.HTMLSelectElement.prototype, "value"], [v.HTMLTextAreaElement.prototype, "value"], [v.HTMLSelectElement.prototype, "selectedIndex"], [v.HTMLOptionElement.prototype, "selected"]];
        return C && C.set && V.push(...G.map((R) => Ft(R[0], R[1], { set() {
          Q(k)({ target: this, isTrusted: !1 });
        } }, !1, v))), Q(() => {
          V.forEach((R) => R());
        });
      }(t), c = function({ mediaInteractionCb: Z, blockClass: g, blockSelector: b, mirror: S, sampling: f, doc: w }) {
        const K = Q((L) => bt(Q((N) => {
          const x = yt(N);
          if (!x || me(x, g, b, !0))
            return;
          const { currentTime: k, volume: h, muted: V, playbackRate: v } = x;
          Z({ type: L, id: S.getId(x), currentTime: k, volume: h, muted: V, playbackRate: v });
        }), f.media || 500)), Y = [be("play", K(0), w), be("pause", K(1), w), be("seeked", K(2), w), be("volumechange", K(3), w), be("ratechange", K(4), w)];
        return Q(() => {
          Y.forEach((L) => L());
        });
      }(t);
      let d = () => {
      }, u = () => {
      }, p = () => {
      }, m = () => {
      };
      t.recordDOM && (d = function({ styleSheetRuleCb: Z, mirror: g, stylesheetManager: b }, { win: S }) {
        if (!S.CSSStyleSheet || !S.CSSStyleSheet.prototype)
          return () => {
          };
        const f = S.CSSStyleSheet.prototype.insertRule;
        S.CSSStyleSheet.prototype.insertRule = new Proxy(f, { apply: Q((x, k, h) => {
          const [V, v] = h, { id: C, styleId: G } = Ee(k, g, b.styleMirror);
          return (C && C !== -1 || G && G !== -1) && Z({ id: C, styleId: G, adds: [{ rule: V, index: v }] }), x.apply(k, h);
        }) });
        const w = S.CSSStyleSheet.prototype.deleteRule;
        let K, Y;
        S.CSSStyleSheet.prototype.deleteRule = new Proxy(w, { apply: Q((x, k, h) => {
          const [V] = h, { id: v, styleId: C } = Ee(k, g, b.styleMirror);
          return (v && v !== -1 || C && C !== -1) && Z({ id: v, styleId: C, removes: [{ index: V }] }), x.apply(k, h);
        }) }), S.CSSStyleSheet.prototype.replace && (K = S.CSSStyleSheet.prototype.replace, S.CSSStyleSheet.prototype.replace = new Proxy(K, { apply: Q((x, k, h) => {
          const [V] = h, { id: v, styleId: C } = Ee(k, g, b.styleMirror);
          return (v && v !== -1 || C && C !== -1) && Z({ id: v, styleId: C, replace: V }), x.apply(k, h);
        }) })), S.CSSStyleSheet.prototype.replaceSync && (Y = S.CSSStyleSheet.prototype.replaceSync, S.CSSStyleSheet.prototype.replaceSync = new Proxy(Y, { apply: Q((x, k, h) => {
          const [V] = h, { id: v, styleId: C } = Ee(k, g, b.styleMirror);
          return (v && v !== -1 || C && C !== -1) && Z({ id: v, styleId: C, replaceSync: V }), x.apply(k, h);
        }) }));
        const L = {};
        Ot("CSSGroupingRule") ? L.CSSGroupingRule = S.CSSGroupingRule : (Ot("CSSMediaRule") && (L.CSSMediaRule = S.CSSMediaRule), Ot("CSSConditionRule") && (L.CSSConditionRule = S.CSSConditionRule), Ot("CSSSupportsRule") && (L.CSSSupportsRule = S.CSSSupportsRule));
        const N = {};
        return Object.entries(L).forEach(([x, k]) => {
          N[x] = { insertRule: k.prototype.insertRule, deleteRule: k.prototype.deleteRule }, k.prototype.insertRule = new Proxy(N[x].insertRule, { apply: Q((h, V, v) => {
            const [C, G] = v, { id: R, styleId: U } = Ee(V.parentStyleSheet, g, b.styleMirror);
            return (R && R !== -1 || U && U !== -1) && Z({ id: R, styleId: U, adds: [{ rule: C, index: [...Et(V), G || 0] }] }), h.apply(V, v);
          }) }), k.prototype.deleteRule = new Proxy(N[x].deleteRule, { apply: Q((h, V, v) => {
            const [C] = v, { id: G, styleId: R } = Ee(V.parentStyleSheet, g, b.styleMirror);
            return (G && G !== -1 || R && R !== -1) && Z({ id: G, styleId: R, removes: [{ index: [...Et(V), C] }] }), h.apply(V, v);
          }) });
        }), Q(() => {
          S.CSSStyleSheet.prototype.insertRule = f, S.CSSStyleSheet.prototype.deleteRule = w, K && (S.CSSStyleSheet.prototype.replace = K), Y && (S.CSSStyleSheet.prototype.replaceSync = Y), Object.entries(L).forEach(([x, k]) => {
            k.prototype.insertRule = N[x].insertRule, k.prototype.deleteRule = N[x].deleteRule;
          });
        });
      }(t, { win: i }), u = Bn(t, t.doc), p = function({ styleDeclarationCb: Z, mirror: g, ignoreCSSAttributes: b, stylesheetManager: S }, { win: f }) {
        const w = f.CSSStyleDeclaration.prototype.setProperty;
        f.CSSStyleDeclaration.prototype.setProperty = new Proxy(w, { apply: Q((Y, L, N) => {
          var x;
          const [k, h, V] = N;
          if (b.has(k))
            return w.apply(L, [k, h, V]);
          const { id: v, styleId: C } = Ee((x = L.parentRule) === null || x === void 0 ? void 0 : x.parentStyleSheet, g, S.styleMirror);
          return (v && v !== -1 || C && C !== -1) && Z({ id: v, styleId: C, set: { property: k, value: h, priority: V }, index: Et(L.parentRule) }), Y.apply(L, N);
        }) });
        const K = f.CSSStyleDeclaration.prototype.removeProperty;
        return f.CSSStyleDeclaration.prototype.removeProperty = new Proxy(K, { apply: Q((Y, L, N) => {
          var x;
          const [k] = N;
          if (b.has(k))
            return K.apply(L, [k]);
          const { id: h, styleId: V } = Ee((x = L.parentRule) === null || x === void 0 ? void 0 : x.parentStyleSheet, g, S.styleMirror);
          return (h && h !== -1 || V && V !== -1) && Z({ id: h, styleId: V, remove: { property: k }, index: Et(L.parentRule) }), Y.apply(L, N);
        }) }), Q(() => {
          f.CSSStyleDeclaration.prototype.setProperty = w, f.CSSStyleDeclaration.prototype.removeProperty = K;
        });
      }(t, { win: i }), t.collectFonts && (m = function({ fontCb: Z, doc: g }) {
        const b = g.defaultView;
        if (!b)
          return () => {
          };
        const S = [], f = /* @__PURE__ */ new WeakMap(), w = b.FontFace;
        b.FontFace = function(Y, L, N) {
          const x = new w(Y, L, N);
          return f.set(x, { family: Y, buffer: typeof L != "string", descriptors: N, fontSource: typeof L == "string" ? L : JSON.stringify(Array.from(new Uint8Array(L))) }), x;
        };
        const K = tt(g.fonts, "add", function(Y) {
          return function(L) {
            return setTimeout(Q(() => {
              const N = f.get(L);
              N && (Z(N), f.delete(L));
            }), 0), Y.apply(this, [L]);
          };
        });
        return S.push(() => {
          b.FontFace = w;
        }), S.push(K), Q(() => {
          S.forEach((Y) => Y());
        });
      }(t)));
      const I = function(Z) {
        const { doc: g, mirror: b, blockClass: S, blockSelector: f, selectionCb: w } = Z;
        let K = !0;
        const Y = Q(() => {
          const L = g.getSelection();
          if (!L || K && (L != null && L.isCollapsed))
            return;
          K = L.isCollapsed || !1;
          const N = [], x = L.rangeCount || 0;
          for (let k = 0; k < x; k++) {
            const h = L.getRangeAt(k), { startContainer: V, startOffset: v, endContainer: C, endOffset: G } = h;
            me(V, S, f, !0) || me(C, S, f, !0) || N.push({ start: b.getId(V), startOffset: v, end: b.getId(C), endOffset: G });
          }
          w({ ranges: N });
        });
        return Y(), be("selectionchange", Y);
      }(t), y = function({ doc: Z, customElementCb: g }) {
        const b = Z.defaultView;
        return b && b.customElements ? tt(b.customElements, "define", function(S) {
          return function(f, w, K) {
            try {
              g({ define: { name: f } });
            } catch (Y) {
              console.warn(`Custom element callback failed for ${f}`);
            }
            return S.apply(this, [f, w, K]);
          };
        }) : () => {
        };
      }(t), W = [];
      for (const Z of t.plugins)
        W.push(Z.observer(Z.callback, i, Z.options));
      return Q(() => {
        Oe.forEach((Z) => Z.reset()), n == null || n.disconnect(), s(), o(), l(), a(), r(), c(), d(), u(), p(), m(), I(), y(), W.forEach((Z) => Z());
      });
    }
    function Mt(t) {
      return window[t] !== void 0;
    }
    function Ot(t) {
      return !!(window[t] !== void 0 && window[t].prototype && "insertRule" in window[t].prototype && "deleteRule" in window[t].prototype);
    }
    class Pn {
      constructor(e) {
        this.generateIdFn = e, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      }
      getId(e, i, n, s) {
        const o = n || this.getIdToRemoteIdMap(e), l = s || this.getRemoteIdToIdMap(e);
        let a = o.get(i);
        return a || (a = this.generateIdFn(), o.set(i, a), l.set(a, i)), a;
      }
      getIds(e, i) {
        const n = this.getIdToRemoteIdMap(e), s = this.getRemoteIdToIdMap(e);
        return i.map((o) => this.getId(e, o, n, s));
      }
      getRemoteId(e, i, n) {
        const s = n || this.getRemoteIdToIdMap(e);
        return typeof i != "number" ? i : s.get(i) || -1;
      }
      getRemoteIds(e, i) {
        const n = this.getRemoteIdToIdMap(e);
        return i.map((s) => this.getRemoteId(e, s, n));
      }
      reset(e) {
        if (!e)
          return this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), void (this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap());
        this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
      }
      getIdToRemoteIdMap(e) {
        let i = this.iframeIdToRemoteIdMap.get(e);
        return i || (i = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, i)), i;
      }
      getRemoteIdToIdMap(e) {
        let i = this.iframeRemoteIdToIdMap.get(e);
        return i || (i = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, i)), i;
      }
    }
    class Do {
      constructor(e) {
        this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new Pn(Sn), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Pn(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
      }
      addIframe(e) {
        this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
      }
      addLoadListener(e) {
        this.loadListener = e;
      }
      attachIframe(e, i) {
        var n;
        this.mutationCb({ adds: [{ parentId: this.mirror.getId(e), nextId: null, node: i }], removes: [], texts: [], attributes: [], isAttachIframe: !0 }), (n = this.loadListener) === null || n === void 0 || n.call(this, e), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(e.contentDocument.adoptedStyleSheets, this.mirror.getId(e.contentDocument));
      }
      handleMessage(e) {
        const i = e;
        if (i.data.type !== "rrweb" || i.origin !== i.data.origin)
          return;
        const n = e.source;
        if (!n)
          return;
        const s = this.crossOriginIframeMap.get(n);
        if (!s)
          return;
        const o = this.transformCrossOriginEvent(s, i.data.event);
        o && this.wrappedEmit(o, i.data.isCheckout);
      }
      transformCrossOriginEvent(e, i) {
        var n;
        switch (i.type) {
          case j.FullSnapshot: {
            this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(i.data.node, e);
            const s = i.data.node.id;
            return this.crossOriginIframeRootIdMap.set(e, s), this.patchRootIdOnNode(i.data.node, s), { timestamp: i.timestamp, type: j.IncrementalSnapshot, data: { source: D.Mutation, adds: [{ parentId: this.mirror.getId(e), nextId: null, node: i.data.node }], removes: [], texts: [], attributes: [], isAttachIframe: !0 } };
          }
          case j.Meta:
          case j.Load:
          case j.DomContentLoaded:
            return !1;
          case j.Plugin:
            return i;
          case j.Custom:
            return this.replaceIds(i.data.payload, e, ["id", "parentId", "previousId", "nextId"]), i;
          case j.IncrementalSnapshot:
            switch (i.data.source) {
              case D.Mutation:
                return i.data.adds.forEach((s) => {
                  this.replaceIds(s, e, ["parentId", "nextId", "previousId"]), this.replaceIdOnNode(s.node, e);
                  const o = this.crossOriginIframeRootIdMap.get(e);
                  o && this.patchRootIdOnNode(s.node, o);
                }), i.data.removes.forEach((s) => {
                  this.replaceIds(s, e, ["parentId", "id"]);
                }), i.data.attributes.forEach((s) => {
                  this.replaceIds(s, e, ["id"]);
                }), i.data.texts.forEach((s) => {
                  this.replaceIds(s, e, ["id"]);
                }), i;
              case D.Drag:
              case D.TouchMove:
              case D.MouseMove:
                return i.data.positions.forEach((s) => {
                  this.replaceIds(s, e, ["id"]);
                }), i;
              case D.ViewportResize:
                return !1;
              case D.MediaInteraction:
              case D.MouseInteraction:
              case D.Scroll:
              case D.CanvasMutation:
              case D.Input:
                return this.replaceIds(i.data, e, ["id"]), i;
              case D.StyleSheetRule:
              case D.StyleDeclaration:
                return this.replaceIds(i.data, e, ["id"]), this.replaceStyleIds(i.data, e, ["styleId"]), i;
              case D.Font:
                return i;
              case D.Selection:
                return i.data.ranges.forEach((s) => {
                  this.replaceIds(s, e, ["start", "end"]);
                }), i;
              case D.AdoptedStyleSheet:
                return this.replaceIds(i.data, e, ["id"]), this.replaceStyleIds(i.data, e, ["styleIds"]), (n = i.data.styles) === null || n === void 0 || n.forEach((s) => {
                  this.replaceStyleIds(s, e, ["styleId"]);
                }), i;
            }
        }
        return !1;
      }
      replace(e, i, n, s) {
        for (const o of s)
          (Array.isArray(i[o]) || typeof i[o] == "number") && (Array.isArray(i[o]) ? i[o] = e.getIds(n, i[o]) : i[o] = e.getId(n, i[o]));
        return i;
      }
      replaceIds(e, i, n) {
        return this.replace(this.crossOriginIframeMirror, e, i, n);
      }
      replaceStyleIds(e, i, n) {
        return this.replace(this.crossOriginIframeStyleMirror, e, i, n);
      }
      replaceIdOnNode(e, i) {
        this.replaceIds(e, i, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((n) => {
          this.replaceIdOnNode(n, i);
        });
      }
      patchRootIdOnNode(e, i) {
        e.type === $.Document || e.rootId || (e.rootId = i), "childNodes" in e && e.childNodes.forEach((n) => {
          this.patchRootIdOnNode(n, i);
        });
      }
    }
    class Qo {
      constructor(e) {
        this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
      }
      init() {
        this.reset(), this.patchAttachShadow(Element, document);
      }
      addShadowRoot(e, i) {
        if (!pt(e) || this.shadowDoms.has(e))
          return;
        this.shadowDoms.add(e);
        const n = Mn(Object.assign(Object.assign({}, this.bypassOptions), { doc: i, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), e);
        this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(On(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: e, mirror: this.mirror }))), setTimeout(() => {
          e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(e.adoptedStyleSheets, this.mirror.getId(e.host)), this.restoreHandlers.push(Bn({ mirror: this.mirror, stylesheetManager: this.bypassOptions.stylesheetManager }, e));
        }, 0);
      }
      observeAttachShadow(e) {
        e.contentWindow && e.contentDocument && this.patchAttachShadow(e.contentWindow.Element, e.contentDocument);
      }
      patchAttachShadow(e, i) {
        const n = this;
        this.restoreHandlers.push(tt(e.prototype, "attachShadow", function(s) {
          return function(o) {
            const l = s.call(this, o);
            return this.shadowRoot && Jn(this) && n.addShadowRoot(this.shadowRoot, i), l;
          };
        }));
      }
      reset() {
        this.restoreHandlers.forEach((e) => {
          try {
            e();
          } catch (i) {
          }
        }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
      }
    }
    for (var gt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", jo = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256), zt = 0; zt < 64; zt++)
      jo[gt.charCodeAt(zt)] = zt;
    const An = /* @__PURE__ */ new Map(), Dn = (t, e, i) => {
      if (!t || !jn(t, e) && typeof t != "object")
        return;
      const n = function(o, l) {
        let a = An.get(o);
        return a || (a = /* @__PURE__ */ new Map(), An.set(o, a)), a.has(l) || a.set(l, []), a.get(l);
      }(i, t.constructor.name);
      let s = n.indexOf(t);
      return s === -1 && (s = n.length, n.push(t)), s;
    };
    function Bt(t, e, i) {
      if (t instanceof Array)
        return t.map((n) => Bt(n, e, i));
      if (t === null)
        return t;
      if (t instanceof Float32Array || t instanceof Float64Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Uint8Array || t instanceof Uint16Array || t instanceof Int16Array || t instanceof Int8Array || t instanceof Uint8ClampedArray)
        return { rr_type: t.constructor.name, args: [Object.values(t)] };
      if (t instanceof ArrayBuffer)
        return { rr_type: t.constructor.name, base64: function(n) {
          var s, o = new Uint8Array(n), l = o.length, a = "";
          for (s = 0; s < l; s += 3)
            a += gt[o[s] >> 2], a += gt[(3 & o[s]) << 4 | o[s + 1] >> 4], a += gt[(15 & o[s + 1]) << 2 | o[s + 2] >> 6], a += gt[63 & o[s + 2]];
          return l % 3 == 2 ? a = a.substring(0, a.length - 1) + "=" : l % 3 == 1 && (a = a.substring(0, a.length - 2) + "=="), a;
        }(t) };
      if (t instanceof DataView)
        return { rr_type: t.constructor.name, args: [Bt(t.buffer, e, i), t.byteOffset, t.byteLength] };
      if (t instanceof HTMLImageElement) {
        const n = t.constructor.name, { src: s } = t;
        return { rr_type: n, src: s };
      }
      return t instanceof HTMLCanvasElement ? { rr_type: "HTMLImageElement", src: t.toDataURL() } : t instanceof ImageData ? { rr_type: t.constructor.name, args: [Bt(t.data, e, i), t.width, t.height] } : jn(t, e) || typeof t == "object" ? { rr_type: t.constructor.name, index: Dn(t, e, i) } : t;
    }
    const Qn = (t, e, i) => t.map((n) => Bt(n, e, i)), jn = (t, e) => !!["WebGLActiveInfo", "WebGLBuffer", "WebGLFramebuffer", "WebGLProgram", "WebGLRenderbuffer", "WebGLShader", "WebGLShaderPrecisionFormat", "WebGLTexture", "WebGLUniformLocation", "WebGLVertexArrayObject", "WebGLVertexArrayObjectOES"].filter((n) => typeof e[n] == "function").find((n) => t instanceof e[n]);
    function _n(t, e, i, n) {
      const s = [];
      try {
        const o = tt(t.HTMLCanvasElement.prototype, "getContext", function(l) {
          return function(a, ...r) {
            if (!me(this, e, i, !0)) {
              const c = /* @__PURE__ */ function(d) {
                return d === "experimental-webgl" ? "webgl" : d;
              }(a);
              if ("__context" in this || (this.__context = c), n && ["webgl", "webgl2"].includes(c))
                if (r[0] && typeof r[0] == "object") {
                  const d = r[0];
                  d.preserveDrawingBuffer || (d.preserveDrawingBuffer = !0);
                } else
                  r.splice(0, 1, { preserveDrawingBuffer: !0 });
            }
            return l.apply(this, [a, ...r]);
          };
        });
        s.push(o);
      } catch (o) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
      }
      return () => {
        s.forEach((o) => o());
      };
    }
    function qn(t, e, i, n, s, o, l) {
      const a = [], r = Object.getOwnPropertyNames(t);
      for (const c of r)
        if (!["isContextLost", "canvas", "drawingBufferWidth", "drawingBufferHeight"].includes(c))
          try {
            if (typeof t[c] != "function")
              continue;
            const d = tt(t, c, function(u) {
              return function(...p) {
                const m = u.apply(this, p);
                if (Dn(m, l, this), "tagName" in this.canvas && !me(this.canvas, n, s, !0)) {
                  const I = Qn(p, l, this), y = { type: e, property: c, args: I };
                  i(this.canvas, y);
                }
                return m;
              };
            });
            a.push(d);
          } catch (d) {
            const u = Ft(t, c, { set(p) {
              i(this.canvas, { type: e, property: c, args: [p], setter: !0 });
            } });
            a.push(u);
          }
      return a;
    }
    function _o(t, e, i) {
      var n = e === void 0 ? null : e, s = function(r, c) {
        var d = atob(r);
        if (c) {
          for (var u = new Uint8Array(d.length), p = 0, m = d.length; p < m; ++p)
            u[p] = d.charCodeAt(p);
          return String.fromCharCode.apply(null, new Uint16Array(u.buffer));
        }
        return d;
      }(t, i !== void 0 && i), o = s.indexOf(`
`, 10) + 1, l = s.substring(o) + (n ? "//# sourceMappingURL=" + n : ""), a = new Blob([l], { type: "application/javascript" });
      return URL.createObjectURL(a);
    }
    var $n, es, ts, Wi, qo = ($n = "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", es = null, ts = !1, function(t) {
      return Wi = Wi || _o($n, es, ts), new Worker(Wi, t);
    });
    class $o {
      reset() {
        this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
      }
      freeze() {
        this.frozen = !0;
      }
      unfreeze() {
        this.frozen = !1;
      }
      lock() {
        this.locked = !0;
      }
      unlock() {
        this.locked = !1;
      }
      constructor(e) {
        this.pendingCanvasMutations = /* @__PURE__ */ new Map(), this.rafStamps = { latestId: 0, invokeId: null }, this.snapshotInProgressMap = /* @__PURE__ */ new Map(), this.lastSnapshotTime = /* @__PURE__ */ new Map(), this.frozen = !1, this.locked = !1, this.processMutation = (d, u) => {
          !(this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId) && this.rafStamps.invokeId || (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(d) || this.pendingCanvasMutations.set(d, []), this.pendingCanvasMutations.get(d).push(u);
        };
        const { sampling: i, win: n, blockClass: s, blockSelector: o, recordCanvas: l, recordVideos: a, initialSnapshotDelay: r, dataURLOptions: c } = e;
        this.mutationCb = e.mutationCb, this.mirror = e.mirror, this.logger = e.logger, this.worker = new qo(), this.worker.onmessage = (d) => {
          const { id: u } = d.data;
          if (this.snapshotInProgressMap.set(u, !1), !("base64" in d.data))
            return void this.debug(null, "canvas worker received empty message", { data: d.data, status: d.data.status });
          const { base64: p, type: m, dx: I, dy: y, dw: W, dh: Z } = d.data;
          this.mutationCb({ id: u, type: it["2D"], commands: [{ property: "clearRect", args: [I, y, W, Z] }, { property: "drawImage", args: [{ rr_type: "ImageBitmap", args: [{ rr_type: "Blob", data: [{ rr_type: "ArrayBuffer", base64: p }], type: m }] }, I, y, W, Z] }] });
        }, this.options = e, l && i === "all" ? (this.debug(null, "initializing canvas mutation observer", { sampling: i }), this.initCanvasMutationObserver(n, s, o)) : l && typeof i == "number" && (this.debug(null, "initializing canvas fps observer", { sampling: i }), this.initCanvasFPSObserver(a, i, n, s, o, { initialSnapshotDelay: r, dataURLOptions: c }, e.resizeFactor, e.maxSnapshotDimension));
      }
      debug(e, ...i) {
        if (!this.logger)
          return;
        const n = this.mirror.getId(e);
        let s = "[highlight-canvas-manager]";
        e && (s = `[highlight-canvas] [id:${n}]`, e.tagName.toLowerCase() === "canvas" && (s += ` [ctx:${e.__context}]`)), this.logger.debug(s, e, ...i);
      }
      snapshot(e) {
        var i;
        return Jt(this, void 0, void 0, function* () {
          this.debug(e, "starting snapshotting");
          const n = this.mirror.getId(e);
          if (this.snapshotInProgressMap.get(n))
            this.debug(e, "snapshotting already in progress for", n);
          else if (e.width !== 0 && e.height !== 0) {
            this.snapshotInProgressMap.set(n, !0);
            try {
              if (this.options.clearWebGLBuffer !== !1 && ["webgl", "webgl2"].includes(e.__context)) {
                const r = e.getContext(e.__context);
                ((i = r == null ? void 0 : r.getContextAttributes()) === null || i === void 0 ? void 0 : i.preserveDrawingBuffer) === !1 && (r.clear(r.COLOR_BUFFER_BIT), this.debug(e, "cleared webgl canvas to load it into memory", { attributes: r == null ? void 0 : r.getContextAttributes() }));
              }
              if (e.width === 0 || e.height === 0)
                return void this.debug(e, "not yet ready", { width: e.width, height: e.height });
              let s = this.options.resizeFactor || 1;
              if (this.options.maxSnapshotDimension) {
                const r = Math.max(e.width, e.height);
                s = Math.min(s, this.options.maxSnapshotDimension / r);
              }
              const o = e.width * s, l = e.height * s, a = yield createImageBitmap(e, { resizeWidth: o, resizeHeight: l });
              this.debug(e, "created image bitmap", { width: a.width, height: a.height }), this.worker.postMessage({ id: n, bitmap: a, width: o, height: l, dx: 0, dy: 0, dw: e.width, dh: e.height, dataURLOptions: this.options.dataURLOptions, logDebug: !!this.logger }, [a]), this.debug(e, "sent message");
            } catch (s) {
              this.debug(e, "failed to snapshot", s);
            } finally {
              this.snapshotInProgressMap.set(n, !1);
            }
          } else
            this.debug(e, "not yet ready", { width: e.width, height: e.height });
        });
      }
      initCanvasFPSObserver(e, i, n, s, o, l, a, r) {
        const c = _n(n, s, o, !0), d = 1e3 / i;
        let u, p = 0;
        const m = /* @__PURE__ */ new Map(), I = (Z) => {
          const g = [];
          return n.document.querySelectorAll("canvas").forEach((b) => {
            if (!me(b, s, o, !0)) {
              this.debug(b, "discovered canvas"), g.push(b);
              const S = this.mirror.getId(b);
              m.has(S) || m.set(S, Z);
            }
          }), g;
        }, y = (Z) => {
          const g = [];
          return e && n.document.querySelectorAll("video").forEach((b) => {
            if ((b.src === "" || b.src.indexOf("blob:") !== -1) && !me(b, s, o, !0)) {
              g.push(b);
              const S = this.mirror.getId(b);
              m.has(S) || m.set(S, Z);
            }
          }), g;
        }, W = (Z) => Jt(this, void 0, void 0, function* () {
          if (p && Z - p < d)
            return void (u = requestAnimationFrame(W));
          p = Z;
          const g = (S) => {
            const f = this.mirror.getId(S), w = m.get(f), K = !l.initialSnapshotDelay || Z - w > l.initialSnapshotDelay;
            return this.debug(S, { delay: l.initialSnapshotDelay, delta: Z - w, hadLoadingTime: K }), K;
          }, b = [];
          b.push(...I(Z).filter(g).map((S) => this.snapshot(S))), b.push(...y(Z).filter(g).map((S) => Jt(this, void 0, void 0, function* () {
            this.debug(S, "starting video snapshotting");
            const f = this.mirror.getId(S);
            if (this.snapshotInProgressMap.get(f))
              this.debug(S, "video snapshotting already in progress for", f);
            else {
              this.snapshotInProgressMap.set(f, !0);
              try {
                const { width: w, height: K } = S.getBoundingClientRect(), { actualWidth: Y, actualHeight: L } = { actualWidth: S.videoWidth, actualHeight: S.videoHeight }, N = Math.max(Y, L);
                let x = a || 1;
                r && (x = Math.min(x, r / N));
                const k = Y * x, h = L * x, V = yield createImageBitmap(S, { resizeWidth: k, resizeHeight: h }), v = Math.max(w, K) / N, C = Y * v, G = L * v, R = (w - C) / 2, U = (K - G) / 2;
                this.debug(S, "created image bitmap", { actualWidth: Y, actualHeight: L, boxWidth: w, boxHeight: K, outputWidth: C, outputHeight: G, resizeWidth: k, resizeHeight: h, scale: x, outputScale: v, offsetX: R, offsetY: U }), this.worker.postMessage({ id: f, bitmap: V, width: k, height: h, dx: R, dy: U, dw: C, dh: G, dataURLOptions: l.dataURLOptions, logDebug: !!this.logger }, [V]), this.debug(S, "send message");
              } catch (w) {
                this.debug(S, "failed to snapshot", w);
              } finally {
                this.snapshotInProgressMap.set(f, !1);
              }
            }
          }))), yield Promise.all(b).catch(console.error), u = requestAnimationFrame(W);
        });
        u = requestAnimationFrame(W), this.resetObservers = () => {
          c(), u && cancelAnimationFrame(u);
        };
      }
      initCanvasMutationObserver(e, i, n) {
        this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
        const s = _n(e, i, n, !1), o = function(a, r, c, d) {
          const u = [], p = Object.getOwnPropertyNames(r.CanvasRenderingContext2D.prototype);
          for (const m of p)
            try {
              if (typeof r.CanvasRenderingContext2D.prototype[m] != "function")
                continue;
              const I = tt(r.CanvasRenderingContext2D.prototype, m, function(y) {
                return function(...W) {
                  return me(this.canvas, c, d, !0) || setTimeout(() => {
                    const Z = Qn(W, r, this);
                    a(this.canvas, { type: it["2D"], property: m, args: Z });
                  }, 0), y.apply(this, W);
                };
              });
              u.push(I);
            } catch (I) {
              const y = Ft(r.CanvasRenderingContext2D.prototype, m, { set(W) {
                a(this.canvas, { type: it["2D"], property: m, args: [W], setter: !0 });
              } });
              u.push(y);
            }
          return () => {
            u.forEach((m) => m());
          };
        }(this.processMutation.bind(this), e, i, n), l = function(a, r, c, d, u) {
          const p = [];
          return p.push(...qn(r.WebGLRenderingContext.prototype, it.WebGL, a, c, d, 0, r)), r.WebGL2RenderingContext !== void 0 && p.push(...qn(r.WebGL2RenderingContext.prototype, it.WebGL2, a, c, d, 0, r)), () => {
            p.forEach((m) => m());
          };
        }(this.processMutation.bind(this), e, i, n);
        this.resetObservers = () => {
          s(), o(), l();
        };
      }
      startPendingCanvasMutationFlusher() {
        requestAnimationFrame(() => this.flushPendingCanvasMutations());
      }
      startRAFTimestamping() {
        const e = (i) => {
          this.rafStamps.latestId = i, requestAnimationFrame(e);
        };
        requestAnimationFrame(e);
      }
      flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((e, i) => {
          const n = this.mirror.getId(i);
          this.flushPendingCanvasMutationFor(i, n);
        }), requestAnimationFrame(() => this.flushPendingCanvasMutations());
      }
      flushPendingCanvasMutationFor(e, i) {
        if (this.frozen || this.locked)
          return;
        const n = this.pendingCanvasMutations.get(e);
        if (!n || i === -1)
          return;
        const s = n.map((l) => function(a, r) {
          var c = {};
          for (var d in a)
            Object.prototype.hasOwnProperty.call(a, d) && r.indexOf(d) < 0 && (c[d] = a[d]);
          if (a != null && typeof Object.getOwnPropertySymbols == "function") {
            var u = 0;
            for (d = Object.getOwnPropertySymbols(a); u < d.length; u++)
              r.indexOf(d[u]) < 0 && Object.prototype.propertyIsEnumerable.call(a, d[u]) && (c[d[u]] = a[d[u]]);
          }
          return c;
        }(l, ["type"])), { type: o } = n[0];
        this.mutationCb({ id: i, type: o, commands: s }), this.pendingCanvasMutations.delete(e);
      }
    }
    class el {
      constructor(e) {
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new Eo(), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
      }
      attachLinkElement(e, i) {
        "_cssText" in i.attributes && this.mutationCb({ adds: [], removes: [], texts: [], attributes: [{ id: i.id, attributes: i.attributes }] }), this.trackLinkElement(e);
      }
      trackLinkElement(e) {
        this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
      }
      adoptStyleSheets(e, i) {
        if (e.length === 0)
          return;
        const n = { id: i, styleIds: [] }, s = [];
        for (const o of e) {
          let l;
          this.styleMirror.has(o) ? l = this.styleMirror.getId(o) : (l = this.styleMirror.add(o), s.push({ styleId: l, rules: Array.from(o.rules || CSSRule, (a, r) => ({ rule: mn(a), index: r })) })), n.styleIds.push(l);
        }
        s.length > 0 && (n.styles = s), this.adoptedStyleSheetCb(n);
      }
      reset() {
        this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
      }
      trackStylesheetInLinkElement(e) {
      }
    }
    class tl {
      constructor() {
        this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
      }
      periodicallyClear() {
        requestAnimationFrame(() => {
          this.clear(), this.loop && this.periodicallyClear();
        });
      }
      inOtherBuffer(e, i) {
        const n = this.nodeMap.get(e);
        return n && Array.from(n).some((s) => s !== i);
      }
      add(e, i) {
        this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(i));
      }
      clear() {
        this.nodeMap = /* @__PURE__ */ new WeakMap();
      }
      destroy() {
        this.loop = !1;
      }
    }
    function oe(t) {
      return Object.assign(Object.assign({}, t), { timestamp: Ht() });
    }
    let ne, Pt, It, At = !1;
    const Re = new bn();
    function Je(t = {}) {
      var e, i, n, s, o, l, a, r;
      const { emit: c, checkoutEveryNms: d, checkoutEveryNth: u, blockClass: p = "highlight-block", blockSelector: m = null, ignoreClass: I = "highlight-ignore", ignoreSelector: y = null, maskTextClass: W = "highlight-mask", maskTextSelector: Z = null, inlineStylesheet: g = !0, maskAllInputs: b, maskInputOptions: S, slimDOMOptions: f, maskInputFn: w, maskTextFn: K = Zi, hooks: Y, packFn: L, sampling: N = {}, mousemoveWait: x, recordDOM: k = !0, recordCanvas: h = !1, recordCrossOriginIframes: V = !1, recordAfter: v = t.recordAfter === "DOMContentLoaded" ? t.recordAfter : "load", userTriggeredOnInput: C = !1, collectFonts: G = !1, inlineImages: R = !1, plugins: U, keepIframeSrcFn: q = () => !1, privacySetting: ee = "default", ignoreCSSAttributes: P = /* @__PURE__ */ new Set([]), errorHandler: M, logger: Se } = t, Ge = Object.assign(Object.assign({}, t.dataURLOptions), (i = (e = t.sampling) === null || e === void 0 ? void 0 : e.canvas) === null || i === void 0 ? void 0 : i.dataURLOptions);
      Zt = M;
      const F = !V || window.parent === window;
      let B = !1;
      if (!F)
        try {
          window.parent.document && (B = !1);
        } catch (E) {
          B = !0;
        }
      if (F && !c)
        throw new Error("emit function is required");
      x !== void 0 && N.mousemove === void 0 && (N.mousemove = x), Re.reset();
      const ce = b === !0 ? { color: !0, date: !0, "datetime-local": !0, email: !0, month: !0, number: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0, textarea: !0, select: !0, password: !0 } : S !== void 0 ? S : { password: !0 }, xe = f === !0 || f === "all" ? { script: !0, comment: !0, headFavicon: !0, headWhitespace: !0, headMetaSocial: !0, headMetaRobots: !0, headMetaHttpEquiv: !0, headMetaVerification: !0, headMetaAuthorship: f === "all", headMetaDescKeywords: f === "all" } : f || {};
      let ct;
      (function(E = window) {
        "NodeList" in E && !E.NodeList.prototype.forEach && (E.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in E && !E.DOMTokenList.prototype.forEach && (E.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...Ve) => {
          let _ = Ve[0];
          if (!(0 in Ve))
            throw new TypeError("1 argument is required");
          do
            if (this === _)
              return !0;
          while (_ = _ && _.parentNode);
          return !1;
        });
      })();
      let Tt = 0;
      const di = (E) => {
        for (const Ve of U || [])
          Ve.eventProcessor && (E = Ve.eventProcessor(E));
        return L && !B && (E = L(E)), E;
      };
      ne = (E, Ve) => {
        var _;
        if (!(!((_ = Oe[0]) === null || _ === void 0) && _.isFrozen()) || E.type === j.FullSnapshot || E.type === j.IncrementalSnapshot && E.data.source === D.Mutation || Oe.forEach((he) => he.unfreeze()), F)
          c == null || c(di(E), Ve);
        else if (B) {
          const he = { type: "rrweb", event: di(E), origin: window.location.origin, isCheckout: Ve };
          window.parent.postMessage(he, "*");
        }
        if (E.type === j.FullSnapshot)
          ct = E, Tt = 0;
        else if (E.type === j.IncrementalSnapshot) {
          if (E.data.source === D.Mutation && E.data.isAttachIframe)
            return;
          Tt++;
          const he = u && Tt >= u, Ue = d && E.timestamp - ct.timestamp > d;
          (he || Ue) && Pt(!0);
        }
      };
      const ui = (E) => {
        ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.Mutation }, E) }));
      }, Wo = (E) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.Scroll }, E) })), fo = (E) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.CanvasMutation }, E) })), Qe = new el({ mutationCb: ui, adoptedStyleSheetCb: (E) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.AdoptedStyleSheet }, E) })) }), je = new Do({ mirror: Re, mutationCb: ui, stylesheetManager: Qe, recordCrossOriginIframes: V, wrappedEmit: ne });
      for (const E of U || [])
        E.getMirror && E.getMirror({ nodeMirror: Re, crossOriginIframeMirror: je.crossOriginIframeMirror, crossOriginIframeStyleMirror: je.crossOriginIframeStyleMirror });
      const an = new tl();
      It = new $o({ recordCanvas: h, recordVideos: R, mutationCb: fo, win: window, blockClass: p, blockSelector: m, mirror: Re, sampling: (n = N == null ? void 0 : N.canvas) === null || n === void 0 ? void 0 : n.fps, samplingManual: (s = N == null ? void 0 : N.canvas) === null || s === void 0 ? void 0 : s.fpsManual, clearWebGLBuffer: (o = N == null ? void 0 : N.canvas) === null || o === void 0 ? void 0 : o.clearWebGLBuffer, initialSnapshotDelay: (l = N == null ? void 0 : N.canvas) === null || l === void 0 ? void 0 : l.initialSnapshotDelay, dataURLOptions: Ge, resizeFactor: (a = N == null ? void 0 : N.canvas) === null || a === void 0 ? void 0 : a.resizeFactor, maxSnapshotDimension: (r = N == null ? void 0 : N.canvas) === null || r === void 0 ? void 0 : r.maxSnapshotDimension, logger: Se });
      const pi = new Qo({ mutationCb: ui, scrollCb: Wo, bypassOptions: { blockClass: p, blockSelector: m, maskTextClass: W, maskTextSelector: Z, inlineStylesheet: g, maskInputOptions: ce, dataURLOptions: Ge, maskTextFn: K, maskInputFn: w, recordCanvas: h, inlineImages: R, privacySetting: ee, sampling: N, slimDOMOptions: xe, iframeManager: je, stylesheetManager: Qe, canvasManager: It, keepIframeSrcFn: q, processedNodeManager: an }, mirror: Re });
      Pt = (E = !1) => {
        if (!k)
          return;
        ne(oe({ type: j.Meta, data: { href: window.location.href, width: kn(), height: vn() } }), E), Qe.reset(), pi.init(), Oe.forEach((_) => _.lock());
        const Ve = function(_, he) {
          const { mirror: Ue = new bn(), blockClass: te = "highlight-block", blockSelector: Nt = null, maskTextClass: Hr = "highlight-mask", maskTextSelector: Er = null, inlineStylesheet: Mr = !0, inlineImages: Or = !1, recordCanvas: zr = !1, maskAllInputs: cn = !1, maskTextFn: Br, maskInputFn: Pr, slimDOM: hi = !1, dataURLOptions: Ar, preserveWhiteSpace: Dr, onSerialize: Qr, onIframeLoad: jr, iframeLoadTimeout: _r, onStylesheetLoad: qr, stylesheetLoadTimeout: $r, keepIframeSrcFn: ea = () => !1, privacySetting: ta = "default" } = he || {};
          return $e(_, { doc: _, mirror: Ue, blockClass: te, blockSelector: Nt, maskTextClass: Hr, maskTextSelector: Er, skipChild: !1, inlineStylesheet: Mr, maskInputOptions: cn === !0 ? { color: !0, date: !0, "datetime-local": !0, email: !0, month: !0, number: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0, textarea: !0, select: !0, password: !0 } : cn === !1 ? { password: !0 } : cn, maskTextFn: Br, maskInputFn: Pr, slimDOMOptions: hi || hi === "all" ? { script: !0, comment: !0, headFavicon: !0, headWhitespace: !0, headMetaDescKeywords: hi === "all", headMetaSocial: !0, headMetaRobots: !0, headMetaHttpEquiv: !0, headMetaAuthorship: !0, headMetaVerification: !0 } : hi || {}, dataURLOptions: Ar, inlineImages: Or, recordCanvas: zr, preserveWhiteSpace: Dr, onSerialize: Qr, onIframeLoad: jr, iframeLoadTimeout: _r, onStylesheetLoad: qr, stylesheetLoadTimeout: $r, keepIframeSrcFn: ea, newlyAddedElement: !1, privacySetting: ta });
        }(document, { mirror: Re, blockClass: p, blockSelector: m, maskTextClass: W, maskTextSelector: Z, inlineStylesheet: g, maskAllInputs: ce, maskTextFn: K, slimDOM: xe, dataURLOptions: Ge, recordCanvas: h, inlineImages: R, privacySetting: ee, onSerialize: (_) => {
          wn(_, Re) && je.addIframe(_), Ln(_, Re) && Qe.trackLinkElement(_), Xi(_) && pi.addShadowRoot(_.shadowRoot, document);
        }, onIframeLoad: (_, he) => {
          je.attachIframe(_, he), pi.observeAttachShadow(_);
        }, onStylesheetLoad: (_, he) => {
          Qe.attachLinkElement(_, he);
        }, keepIframeSrcFn: q });
        if (!Ve)
          return console.warn("Failed to snapshot the document");
        ne(oe({ type: j.FullSnapshot, data: { node: Ve, initialOffset: Rn(window) } }), E), Oe.forEach((_) => _.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Qe.adoptStyleSheets(document.adoptedStyleSheets, Re.getId(document));
      };
      try {
        const E = [], Ve = (he) => {
          var Ue;
          return Q(Ao)({ mutationCb: ui, mousemoveCb: (te, Nt) => ne(oe({ type: j.IncrementalSnapshot, data: { source: Nt, positions: te } })), mouseInteractionCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.MouseInteraction }, te) })), scrollCb: Wo, viewportResizeCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.ViewportResize }, te) })), inputCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.Input }, te) })), mediaInteractionCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.MediaInteraction }, te) })), styleSheetRuleCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.StyleSheetRule }, te) })), styleDeclarationCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.StyleDeclaration }, te) })), canvasMutationCb: fo, fontCb: (te) => ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.Font }, te) })), selectionCb: (te) => {
            ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.Selection }, te) }));
          }, customElementCb: (te) => {
            ne(oe({ type: j.IncrementalSnapshot, data: Object.assign({ source: D.CustomElement }, te) }));
          }, blockClass: p, ignoreClass: I, ignoreSelector: y, maskTextClass: W, maskTextSelector: Z, maskInputOptions: ce, inlineStylesheet: g, sampling: N, recordDOM: k, recordCanvas: h, inlineImages: R, userTriggeredOnInput: C, collectFonts: G, doc: he, maskInputFn: w, maskTextFn: K, keepIframeSrcFn: q, blockSelector: m, slimDOMOptions: xe, dataURLOptions: Ge, mirror: Re, iframeManager: je, stylesheetManager: Qe, shadowDomManager: pi, processedNodeManager: an, canvasManager: It, ignoreCSSAttributes: P, privacySetting: ee, plugins: ((Ue = U == null ? void 0 : U.filter((te) => te.observer)) === null || Ue === void 0 ? void 0 : Ue.map((te) => ({ observer: te.observer, options: te.options, callback: (Nt) => ne(oe({ type: j.Plugin, data: { plugin: te.name, payload: Nt } })) }))) || [] }, Y);
        };
        je.addLoadListener((he) => {
          try {
            E.push(Ve(he.contentDocument));
          } catch (Ue) {
            console.warn(Ue);
          }
        });
        const _ = () => {
          Pt(), E.push(Ve(document)), At = !0;
        };
        return document.readyState === "interactive" || document.readyState === "complete" ? _() : (E.push(be("DOMContentLoaded", () => {
          ne(oe({ type: j.DomContentLoaded, data: {} })), v === "DOMContentLoaded" && _();
        })), E.push(be("load", () => {
          ne(oe({ type: j.Load, data: {} })), v === "load" && _();
        }, window))), () => {
          E.forEach((he) => he()), an.destroy(), At = !1, Zt = void 0;
        };
      } catch (E) {
        console.warn(E);
      }
    }
    Je.addCustomEvent = (t, e) => {
      At && ne(oe({ type: j.Custom, data: { tag: t, payload: e } }));
    }, Je.freezePage = () => {
      Oe.forEach((t) => t.freeze());
    }, Je.takeFullSnapshot = (t) => {
      if (!At)
        throw new Error("please take full snapshot after start recording");
      Pt(t);
    }, Je.snapshotCanvas = (t) => Jt(void 0, void 0, void 0, function* () {
      if (!It)
        throw new Error("canvas manager is not initialized");
      yield It.snapshot(t);
    }), Je.mirror = Re;
    const { addCustomEvent: is } = Je, ns = { key: "_sid" }, il = (t) => {
      const e = t ? Object.assign({}, ns, t) : ns;
      let i = 0;
      return { name: "rrweb/sequential-id@1", eventProcessor: (n) => (Object.assign(n, { [e.key]: ++i }), n), options: e };
    };
    function nl(t) {
      if (!t || !t.outerHTML)
        return "";
      let e = "";
      for (; t.parentElement; ) {
        let i = t.localName;
        if (!i)
          break;
        i = i.toLowerCase();
        let n = t.parentElement, s = [];
        if (n.children && n.children.length > 0)
          for (let o = 0; o < n.children.length; o++) {
            let l = n.children[o];
            l.localName && l.localName.toLowerCase && l.localName.toLowerCase() === i && s.push(l);
          }
        s.length > 1 && (i += ":eq(" + s.indexOf(t) + ")"), e = i + (e ? ">" + e : ""), t = n;
      }
      return e;
    }
    function fi(t) {
      return Object.prototype.toString.call(t) === "[object Object]";
    }
    function ss(t, e) {
      if (e === 0)
        return !0;
      const i = Object.keys(t);
      for (const n of i)
        if (fi(t[n]) && ss(t[n], e - 1))
          return !0;
      return !1;
    }
    function Ci(t, e) {
      const i = { numOfKeysLimit: 50, depthOfLimit: 4 };
      Object.assign(i, e);
      const n = [], s = [];
      return JSON.stringify(t, function(o, l) {
        if (n.length > 0) {
          const a = n.indexOf(this);
          ~a ? n.splice(a + 1) : n.push(this), ~a ? s.splice(a, 1 / 0, o) : s.push(o), ~n.indexOf(l) && (l = n[0] === l ? "[Circular ~]" : "[Circular ~." + s.slice(0, n.indexOf(l)).join(".") + "]");
        } else
          n.push(l);
        if (l == null)
          return l;
        if (function(a) {
          return fi(a) && Object.keys(a).length > i.numOfKeysLimit || typeof a == "function" ? !0 : a instanceof Event && a.isTrusted === !1 ? Object.keys(a).length === 1 : !!(fi(a) && ss(a, i.depthOfLimit));
        }(l))
          return function(a) {
            let r = a.toString();
            return i.stringLengthLimit && r.length > i.stringLengthLimit && (r = `${r.slice(0, i.stringLengthLimit)}...`), r;
          }(l);
        if (l instanceof Event) {
          const a = {};
          for (const r in l) {
            const c = l[r];
            Array.isArray(c) ? a[r] = nl(c.length ? c[0] : null) : a[r] = c;
          }
          return a;
        }
        return l instanceof Node ? l instanceof HTMLElement ? l ? l.outerHTML : "" : l.nodeName : l instanceof Error ? l.name + ": " + l.message : l;
      });
    }
    var sl = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof dn != "undefined" ? dn : typeof self != "undefined" ? self : {};
    function Ri(t) {
      return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    }
    var os, ze, ls, vi, rs, as = { exports: {} }, cs = { exports: {} };
    function ol() {
      return os || (os = 1, cs.exports = function() {
        function t(m) {
          return !isNaN(parseFloat(m)) && isFinite(m);
        }
        function e(m) {
          return m.charAt(0).toUpperCase() + m.substring(1);
        }
        function i(m) {
          return function() {
            return this[m];
          };
        }
        var n = ["isConstructor", "isEval", "isNative", "isToplevel"], s = ["columnNumber", "lineNumber"], o = ["fileName", "functionName", "source"], l = ["args"], a = ["evalOrigin"], r = n.concat(s, o, l, a);
        function c(m) {
          if (m)
            for (var I = 0; I < r.length; I++)
              m[r[I]] !== void 0 && this["set" + e(r[I])](m[r[I]]);
        }
        c.prototype = { getArgs: function() {
          return this.args;
        }, setArgs: function(m) {
          if (Object.prototype.toString.call(m) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = m;
        }, getEvalOrigin: function() {
          return this.evalOrigin;
        }, setEvalOrigin: function(m) {
          if (m instanceof c)
            this.evalOrigin = m;
          else {
            if (!(m instanceof Object))
              throw new TypeError("Eval Origin must be an Object or StackFrame");
            this.evalOrigin = new c(m);
          }
        }, toString: function() {
          var m = this.getFileName() || "", I = this.getLineNumber() || "", y = this.getColumnNumber() || "", W = this.getFunctionName() || "";
          return this.getIsEval() ? m ? "[eval] (" + m + ":" + I + ":" + y + ")" : "[eval]:" + I + ":" + y : W ? W + " (" + m + ":" + I + ":" + y + ")" : m + ":" + I + ":" + y;
        } }, c.fromString = function(m) {
          var I = m.indexOf("("), y = m.lastIndexOf(")"), W = m.substring(0, I), Z = m.substring(I + 1, y).split(","), g = m.substring(y + 1);
          if (g.indexOf("@") === 0)
            var b = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(g, ""), S = b[1], f = b[2], w = b[3];
          return new c({ functionName: W, args: Z || void 0, fileName: S, lineNumber: f || void 0, columnNumber: w || void 0 });
        };
        for (var d = 0; d < n.length; d++)
          c.prototype["get" + e(n[d])] = i(n[d]), c.prototype["set" + e(n[d])] = /* @__PURE__ */ function(m) {
            return function(I) {
              this[m] = !!I;
            };
          }(n[d]);
        for (var u = 0; u < s.length; u++)
          c.prototype["get" + e(s[u])] = i(s[u]), c.prototype["set" + e(s[u])] = /* @__PURE__ */ function(m) {
            return function(I) {
              if (!t(I))
                throw new TypeError(m + " must be a Number");
              this[m] = Number(I);
            };
          }(s[u]);
        for (var p = 0; p < o.length; p++)
          c.prototype["get" + e(o[p])] = i(o[p]), c.prototype["set" + e(o[p])] = /* @__PURE__ */ function(m) {
            return function(I) {
              this[m] = String(I);
            };
          }(o[p]);
        return c;
      }()), cs.exports;
    }
    as.exports = (ze = ol(), ls = /(^|@)\S+:\d+/, vi = /^\s*at .*(\S+:\d+|\(native\))/m, rs = /^(eval@)?(\[native code])?$/, { parse: function(t) {
      if (t.stacktrace !== void 0 || t["opera#sourceloc"] !== void 0)
        return this.parseOpera(t);
      if (t.stack && t.stack.match(vi))
        return this.parseV8OrIE(t);
      if (t.stack)
        return this.parseFFOrSafari(t);
      throw new Error("Cannot parse given Error object");
    }, extractLocation: function(t) {
      if (t.indexOf(":") === -1)
        return [t];
      var e = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(t.replace(/[()]/g, ""));
      return [e[1], e[2] || void 0, e[3] || void 0];
    }, parseV8OrIE: function(t) {
      return t.stack.split(`
`).filter(function(e) {
        return !!e.match(vi);
      }, this).map(function(e) {
        e.indexOf("(eval ") > -1 && (e = e.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
        var i = e.replace(/^\s+/, "").replace(/\(eval code/g, "("), n = i.match(/ (\((.+):(\d+):(\d+)\)$)/), s = (i = n ? i.replace(n[0], "") : i).split(/\s+/).slice(1), o = this.extractLocation(n ? n[1] : s.pop()), l = s.join(" ") || void 0, a = ["eval", "<anonymous>"].indexOf(o[0]) > -1 ? void 0 : o[0];
        return new ze({ functionName: l, fileName: a, lineNumber: o[1], columnNumber: o[2], source: e });
      }, this);
    }, parseFFOrSafari: function(t) {
      return t.stack.split(`
`).filter(function(e) {
        return !e.match(rs);
      }, this).map(function(e) {
        if (e.indexOf(" > eval") > -1 && (e = e.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), e.indexOf("@") === -1 && e.indexOf(":") === -1)
          return new ze({ functionName: e });
        var i = /((.*".+"[^@]*)?[^@]*)(?:@)/, n = e.match(i), s = n && n[1] ? n[1] : void 0, o = this.extractLocation(e.replace(i, ""));
        return new ze({ functionName: s, fileName: o[0], lineNumber: o[1], columnNumber: o[2], source: e });
      }, this);
    }, parseOpera: function(t) {
      return !t.stacktrace || t.message.indexOf(`
`) > -1 && t.message.split(`
`).length > t.stacktrace.split(`
`).length ? this.parseOpera9(t) : t.stack ? this.parseOpera11(t) : this.parseOpera10(t);
    }, parseOpera9: function(t) {
      for (var e = /Line (\d+).*script (?:in )?(\S+)/i, i = t.message.split(`
`), n = [], s = 2, o = i.length; s < o; s += 2) {
        var l = e.exec(i[s]);
        l && n.push(new ze({ fileName: l[2], lineNumber: l[1], source: i[s] }));
      }
      return n;
    }, parseOpera10: function(t) {
      for (var e = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, i = t.stacktrace.split(`
`), n = [], s = 0, o = i.length; s < o; s += 2) {
        var l = e.exec(i[s]);
        l && n.push(new ze({ functionName: l[3] || void 0, fileName: l[2], lineNumber: l[1], source: i[s] }));
      }
      return n;
    }, parseOpera11: function(t) {
      return t.stack.split(`
`).filter(function(e) {
        return !!e.match(ls) && !e.match(/^Error created at/);
      }, this).map(function(e) {
        var i, n = e.split("@"), s = this.extractLocation(n.pop()), o = n.shift() || "", l = o.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
        o.match(/\(([^)]*)\)/) && (i = o.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
        var a = i === void 0 || i === "[arguments not available]" ? void 0 : i.split(",");
        return new ze({ functionName: l, args: a, fileName: s[0], lineNumber: s[1], columnNumber: s[2], source: e });
      }, this);
    } });
    const St = Ri(as.exports);
    function ll(t, e) {
      const i = e.logger;
      if (!i)
        return () => {
        };
      let n;
      n = typeof i == "string" ? window[i] : i;
      const s = [];
      if (e.level.includes("error") && window) {
        const l = (a) => {
          const { message: r, error: c } = a;
          let d = [];
          c && (d = St.parse(c));
          const u = [Ci(r, e.stringifyOptions)];
          t({ type: "Error", trace: d, time: Date.now(), value: u });
        };
        window.addEventListener("error", l), s.push(() => {
          window && window.removeEventListener("error", l);
        });
      }
      for (const l of e.level)
        s.push(o(n, l));
      return () => {
        s.forEach((l) => l());
      };
      function o(l, a) {
        return l[a] ? function(r, c, d) {
          try {
            if (!(c in r))
              return () => {
              };
            const u = r[c], p = d(u);
            return typeof p == "function" && (p.prototype = p.prototype || {}, Object.defineProperties(p, { __rrweb_original__: { enumerable: !1, value: u } })), r[c] = p, () => {
              r[c] = u;
            };
          } catch (u) {
            return () => {
            };
          }
        }(l, a, (r) => (...c) => {
          r.apply(this, c);
          try {
            const d = St.parse(new Error()), u = e.serializeConsoleAttributes ? c.map((p) => typeof p == "object" ? Ci(p, e.stringifyOptions) : p) : c.filter((p) => typeof p != "object").map((p) => `${p}`);
            t({ type: a, trace: d.slice(1), value: u, attributes: Ci(c.filter((p) => typeof p == "object").reduce((p, m) => z(z({}, p), m), {}), e.stringifyOptions), time: Date.now() });
          } catch (d) {
            r("highlight logger error:", d, ...c);
          }
        }) : () => {
        };
      }
    }
    var ds = { exports: {} };
    (function(t, e) {
      function i(n, s) {
        var o = [], l = [];
        return s == null && (s = function(a, r) {
          return o[0] === r ? "[Circular ~]" : "[Circular ~." + l.slice(0, o.indexOf(r)).join(".") + "]";
        }), function(a, r) {
          if (o.length > 0) {
            var c = o.indexOf(this);
            ~c ? o.splice(c + 1) : o.push(this), ~c ? l.splice(c, 1 / 0, a) : l.push(a), ~o.indexOf(r) && (r = s.call(this, a, r));
          } else
            o.push(r);
          return n == null ? r : n.call(this, a, r);
        };
      }
      (t.exports = function(n, s, o, l) {
        return JSON.stringify(n, i(s, l), o);
      }).getSerialize = i;
    })(ds);
    const Be = Ri(ds.exports);
    function ki(t, e, i, n) {
      var s, o, l, a;
      let r = [];
      try {
        r = St.parse(n != null ? n : e);
      } catch (u) {
        r = St.parse(new Error());
      }
      let c = {};
      e instanceof Error && (e = e.message).cause && (c = { "exception.cause": e.cause });
      const d = al(r);
      t({ event: Be(e), type: "window.onerror", url: window.location.href, source: i != null ? i : "", lineNumber: (s = d[0]) != null && s.lineNumber ? (o = d[0]) == null ? void 0 : o.lineNumber : 0, columnNumber: (l = d[0]) != null && l.columnNumber ? (a = d[0]) == null ? void 0 : a.columnNumber : 0, stackTrace: d, timestamp: (/* @__PURE__ */ new Date()).toISOString(), payload: c ? Be(c) : void 0 });
    }
    const rl = (t, { enablePromisePatch: e }) => {
      if (typeof window == "undefined")
        return () => {
        };
      const i = window.onerror = (l, a, r, c, d) => {
        ki(t, l, a, d);
      }, n = window.onunhandledrejection = (l) => {
        if (l.reason) {
          const a = l.promise;
          a.getStack ? ki(t, l.reason, l.type, a.getStack()) : ki(t, l.reason, l.type);
        }
      }, s = window.Promise, o = class extends s {
        constructor(l) {
          super(l), T(this, "promiseCreationError"), this.promiseCreationError = new Error();
        }
        getStack() {
          return this.promiseCreationError;
        }
        static shouldPatch() {
          const l = window.Zone === void 0;
          return e && l;
        }
      };
      return o.shouldPatch() && (window.Promise = o), () => {
        window.Promise = s, window.onunhandledrejection = n, window.onerror = i;
      };
    }, al = (t) => {
      var e, i;
      if (t.length === 0)
        return t;
      const n = t[0];
      return (e = n.fileName) != null && e.includes("highlight.run") || (i = n.fileName) != null && i.includes("highlight.io") || n.functionName === "new highlightPromise" ? t.slice(1) : t;
    }, cl = ["assert", "count", "countReset", "debug", "dir", "dirxml", "error", "group", "groupCollapsed", "groupEnd", "info", "log", "table", "time", "timeEnd", "timeLog", "trace", "warn"];
    var Vt = ((t) => (t.DeviceMemory = "DeviceMemory", t.ViewportHeight = "ViewportHeight", t.ViewportWidth = "ViewportWidth", t.ViewportArea = "ViewportArea", t))(Vt || {}), Ne = ((t) => (t.Device = "Device", t.WebVital = "WebVital", t.Performance = "Performance", t.Frontend = "Frontend", t.Backend = "Backend", t))(Ne || {});
    const us = ['["\\"Script error.\\""]', '"Script error."', '["\\"Load failed.\\""]', '"Load failed."', '["\\"Network request failed.\\""]', '"Network request failed."', '["\\"Document is not focused.\\""]', '"Document is not focused."', '["\\"Failed to fetch\\""]', '"Failed to fetch"', '[{"isTrusted":true}]', '{"isTrusted":true}', '["{}"]', '"{}"', '[""]', '""', '["\\"\\""]', '""'], ps = ["websocket error", '\\"ResizeObserver loop'], hs = (t, e, i) => {
      const n = dl(e, t.headers, i);
      return Te(z({}, t), { headers: n });
    }, dl = (t, e, i) => {
      var n, s;
      const o = z({}, e);
      return i ? ((n = Object.keys(o)) == null || n.forEach((l) => {
        [...i].includes(l == null ? void 0 : l.toLowerCase()) || (o[l] = "[REDACTED]");
      }), o) : ((s = Object.keys(o)) == null || s.forEach((l) => {
        [...ul, ...t].includes(l == null ? void 0 : l.toLowerCase()) && (o[l] = "[REDACTED]");
      }), o);
    }, ul = ["authorization", "cookie", "proxy-authorization", "token"], pl = ["https://www.googleapis.com/identitytoolkit", "https://securetoken.googleapis.com"];
    var re = ((t) => (t.RECORDING_START_TIME = "highlightRecordingStartTime", t.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", t.SESSION_DATA = "sessionData", t.SESSION_SECURE_ID = "sessionSecureID", t.USER_IDENTIFIER = "highlightIdentifier", t.USER_OBJECT = "highlightUserObject", t.PAYLOAD_ID = "payloadId", t))(re || {});
    let Ti = "localStorage", hl = new class {
      constructor() {
        T(this, "storage", {});
      }
      getItem(t) {
        var e;
        return (e = this.storage[t]) != null ? e : "";
      }
      setItem(t, e) {
        this.storage[t] = e;
      }
      removeItem(t) {
        delete this.storage[t];
      }
    }();
    const Ni = () => {
      try {
        switch (Ti) {
          case "localStorage":
            return window.localStorage;
          case "sessionStorage":
            return window.sessionStorage;
        }
      } catch (t) {
        return hl;
      }
    }, Ie = (t) => Ni().getItem(t), ve = (t, e) => Ni().setItem(t, e), wi = (t) => Ni().removeItem(t), ml = (t) => {
      if (Ti === "sessionStorage")
        return void console.warn("highlight.io cannot use local storage; segment integration will not work");
      const e = window.localStorage.setItem;
      window.localStorage.setItem = function() {
        const [i, n] = arguments;
        t({ keyName: i, keyValue: n }), e.apply(this, [i, n]);
      };
    }, ms = { normal: { bytes: 1e7, time: 24e4 }, canvas: { bytes: 16e6, time: 5e3 } }, bs = () => {
      let t = JSON.parse(Ie(re.SESSION_DATA) || "{}");
      if (t && t.lastPushTime && Date.now() - t.lastPushTime < 9e5)
        return t;
    }, Li = function(t) {
      t !== null ? (ve(re.SESSION_DATA, JSON.stringify(t)), Zs(t.sessionSecureID)) : wi(re.SESSION_DATA);
    }, Zs = function(t) {
      return ve(re.SESSION_SECURE_ID, t);
    };
    var bl = { REACT_APP_COMMIT_SHA: "805580fda0fa3af7d28982f12865e6b5a1e1a9e4", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
    const ys = "X-Highlight-Request", gs = (t) => {
      let e = t;
      return t.startsWith("https://") || t.startsWith("http://") || (e = `${window.location.origin}${e}`), e.replace(/\/+$/, "");
    }, Is = (t, e, i, n) => {
      t.sort((a, r) => a.responseEnd - r.responseEnd);
      const s = t.reduce((a, r) => {
        const c = gs(r.name);
        return r.initiatorType === i ? a[i][c] = [...a[i][c] || [], r] : a.others[c] = [...a.others[c] || [], r], a;
      }, { xmlhttprequest: {}, others: {}, fetch: {} });
      let o = {};
      o = e.reduce((a, r) => {
        const c = gs(r.request.url);
        return a[c] = [...a[c] || [], r], a;
      }, o);
      for (let a in s[i]) {
        const r = s[i][a], c = o[a];
        if (!c)
          continue;
        const d = Math.max(r.length - c.length, 0);
        for (let u = d; u < r.length; u++)
          r[u] && (r[u].requestResponsePair = c[u - d]);
      }
      let l = [];
      for (let a in s)
        for (let r in s[a])
          l = l.concat(s[a][r]);
      return l.sort((a, r) => a.fetchStart - r.fetchStart).reduce((a, r) => {
        let c = r.requestResponsePair;
        return c && (c = ((d, { headersToRedact: u, headersToRecord: p, requestResponseSanitizer: m }) => {
          var I, y;
          let W = d;
          if (m) {
            let f = !0;
            try {
              W.request.body = JSON.parse(W.request.body);
            } catch (K) {
              f = !1;
            }
            let w = !0;
            try {
              W.response.body = JSON.parse(W.response.body);
            } catch (K) {
              w = !1;
            }
            try {
              W = m(W);
            } catch (K) {
            } finally {
              f = f && !!((I = W == null ? void 0 : W.request) != null && I.body), w = w && !!((y = W == null ? void 0 : W.response) != null && y.body), f && (W.request.body = JSON.stringify(W.request.body)), w && (W.response.body = JSON.stringify(W.response.body));
            }
            if (!W)
              return null;
          }
          const Z = W, { request: g, response: b } = Z, S = Fe(Z, ["request", "response"]);
          return z({ request: hs(g, u, p), response: hs(b, u, p) }, S);
        })(r.requestResponsePair, n), !c) || (r.toJSON = function() {
          const d = window.performance.timeOrigin;
          return { initiatorType: this.initiatorType, startTimeAbs: d + this.startTime, connectStartAbs: d + this.connectStart, connectEndAbs: d + this.connectEnd, domainLookupStartAbs: d + this.domainLookupStart, domainLookupEndAbs: d + this.domainLookupEnd, fetchStartAbs: d + this.fetchStart, redirectStartAbs: d + this.redirectStart, redirectEndAbs: d + this.redirectEnd, requestStartAbs: d + this.requestStart, responseStartAbs: d + this.responseStart, responseEndAbs: d + this.responseEnd, secureConnectionStartAbs: d + this.secureConnectionStart, workerStartAbs: d + this.workerStart, name: this.name, transferSize: this.transferSize, encodedBodySize: this.encodedBodySize, decodedBodySize: this.decodedBodySize, nextHopProtocol: this.nextHopProtocol, requestResponsePairs: c };
        }, a.push(r)), a;
      }, []);
    }, xi = (t, e, i) => {
      return s = e, !((n = t).toLocaleLowerCase().includes((o = bl.REACT_APP_PUBLIC_GRAPH_URI) != null ? o : "highlight.io") || n.toLocaleLowerCase().includes("highlight.io") || n.toLocaleLowerCase().includes(s)) || Ji(t, i);
      var n, s, o;
    }, Ji = (t, e) => {
      var i;
      let n = [];
      e === !0 ? (n = ["localhost", /^\//], (i = window == null ? void 0 : window.location) != null && i.host && n.push(window.location.host)) : e instanceof Array && (n = e);
      let s = !1;
      return n.forEach((o) => {
        t.match(o) && (s = !0);
      }), s;
    };
    function Zl(t) {
      for (var e = "", i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = 0; n < t; n++)
        e += i.charAt(Math.floor(62 * Math.random()));
      return e;
    }
    const Ss = () => {
      return [(t = Ie(re.SESSION_SECURE_ID)) != null ? t : "", Zl(10)];
      var t;
    }, Vs = (t, e) => t + "/" + e, yl = (t, e, i, n, s, o) => {
      const l = XMLHttpRequest.prototype, a = l.open, r = l.send, c = l.setRequestHeader;
      return l.open = function(d, u) {
        return this._url = typeof u == "string" ? u : u.toString(), this._method = d, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some((p) => this._url.toLowerCase().includes(p)), a.apply(this, arguments);
      }, l.setRequestHeader = function(d, u) {
        return this._requestHeaders[d] = u, c.apply(this, arguments);
      }, l.send = function(d) {
        if (!xi(this._url, e, i))
          return r.apply(this, arguments);
        const [u, p] = Ss();
        Ji(this._url, i) && this.setRequestHeader(ys, Vs(u, p));
        const m = this._shouldRecordHeaderAndBody, I = { sessionSecureID: u, id: p, url: this._url, verb: this._method, headers: m ? this._requestHeaders : {}, body: void 0 };
        if (m && d) {
          const y = Xs(d, I.url);
          y && (I.body = Pe(y, s, o, I.headers));
        }
        return this.addEventListener("load", function() {
          return ue(this, null, function* () {
            const y = { status: this.status, headers: {}, body: void 0 };
            if (m) {
              const W = this.getAllResponseHeaders().trim().split(/[\r\n]+/), Z = {};
              if (W.forEach(function(g) {
                const b = g.split(": "), S = b.shift();
                Z[S] = b.join(": ");
              }), y.headers = Z, d) {
                const g = Xs(d, I.url);
                g && (I.body = Pe(g, s, o, y.headers));
              }
              if (this.responseType === "" || this.responseType === "text")
                y.body = Pe(this.responseText, s, o, y.headers), y.size = 8 * this.responseText.length;
              else if (this.responseType === "blob") {
                if (this.response instanceof Blob)
                  try {
                    const g = yield this.response.text();
                    y.body = Pe(g, s, o, y.headers), y.size = this.response.size;
                  } catch (g) {
                  }
              } else
                try {
                  y.body = Pe(this.response, s, o, y.headers);
                } catch (g) {
                }
            }
            t({ request: I, response: y, urlBlocked: !m });
          });
        }), this.addEventListener("error", function() {
          return ue(this, null, function* () {
            const y = { status: this.status, headers: void 0, body: void 0 };
            t({ request: I, response: y, urlBlocked: !1 });
          });
        }), r.apply(this, arguments);
      }, () => {
        l.open = a, l.send = r, l.setRequestHeader = c;
      };
    }, Xs = (t, e) => {
      if (typeof t == "string") {
        if (!(e != null && e.includes("localhost")) && !(e != null && e.includes("highlight.run")) || !t.includes("pushPayload"))
          return t;
      } else if (typeof t == "object" || typeof t == "number" || typeof t == "boolean")
        return Be(t);
      return null;
    }, gl = { "application/json": 67108864, "text/plain": 67108864 }, Pe = (t, e, i, n) => {
      var s, o, l;
      let a = 65536;
      if (n) {
        let r = "";
        r = typeof n.get == "function" ? (s = n.get("content-type")) != null ? s : "" : (o = n["content-type"]) != null ? o : "";
        try {
          r = r.split(";")[0];
        } catch (c) {
        }
        a = (l = gl[r]) != null ? l : 65536;
      }
      if (t) {
        if (e)
          try {
            const r = JSON.parse(t);
            Array.isArray(r) ? r.forEach((c) => {
              Object.keys(c).forEach((d) => {
                e.includes(d.toLocaleLowerCase()) && (c[d] = "[REDACTED]");
              });
            }) : Object.keys(r).forEach((c) => {
              e.includes(c.toLocaleLowerCase()) && (r[c] = "[REDACTED]");
            }), t = JSON.stringify(r);
          } catch (r) {
          }
        if (i)
          try {
            const r = JSON.parse(t);
            Object.keys(r).forEach((c) => {
              i.includes(c.toLocaleLowerCase()) || (r[c] = "[REDACTED]");
            }), t = JSON.stringify(r);
          } catch (r) {
          }
      }
      try {
        t = t.slice(0, a);
      } catch (r) {
      }
      return t;
    }, Il = (t, e, i, n, s, o) => {
      const l = window._fetchProxy;
      return window._fetchProxy = function(a, r) {
        const { method: c, url: d } = Sl(a, r);
        if (!xi(d, e, i))
          return l.call(this, a, r);
        const [u, p] = Ss();
        if (Ji(d, i)) {
          r = r || {};
          let W = new Headers(r.headers);
          a instanceof Request && [...a.headers].forEach(([Z, g]) => W.set(Z, g)), W.set(ys, Vs(u, p)), r.headers = Object.fromEntries(W.entries());
        }
        const m = { sessionSecureID: u, id: p, headers: {}, body: void 0, url: d, verb: c }, I = !n.some((W) => d.toLowerCase().includes(W));
        I && (m.headers = Object.fromEntries(new Headers(r == null ? void 0 : r.headers).entries()), m.body = Pe(r == null ? void 0 : r.body, s, o, r == null ? void 0 : r.headers));
        let y = l.call(this, a, r);
        return Vl(y, m, t, I, s, o), y;
      }, () => {
        window._fetchProxy = l;
      };
    }, Sl = (t, e) => {
      const i = e && e.method || typeof t == "object" && "method" in t && t.method || "GET";
      let n;
      return n = typeof t == "object" ? "url" in t && t.url ? t.url : t.toString() : t, { method: i, url: n };
    }, Vl = (t, e, i, n, s, o) => {
      t.then((l) => ue(this, null, function* () {
        let a = { body: void 0, headers: void 0, status: 0, size: 0 }, r = !1, c = !n;
        if ("stack" in l || l instanceof Error)
          a = Te(z({}, a), { body: l.message, status: 0, size: void 0 }), r = !0;
        else if ("status" in l) {
          if (a = Te(z({}, a), { status: l.status }), n) {
            let d;
            try {
              const u = l.clone().body;
              if (u) {
                let p, m = u.getReader(), I = new TextDecoder(), y = "";
                for (; !(p = yield m.read()).done; ) {
                  let W = p.value;
                  y += I.decode(W);
                }
                d = y, d = Pe(d, s, o, l.headers);
              } else
                d = "";
            } catch (u) {
              d = `Unable to clone response: ${u}`;
            }
            a.body = d, a.headers = Object.fromEntries(l.headers.entries()), a.size = 8 * d.length;
          }
          l.type !== "opaque" && l.type !== "opaqueredirect" || (c = !0, a = Te(z({}, a), { body: "CORS blocked request" })), r = !0;
        }
        r && i({ request: e, response: a, urlBlocked: c });
      })).catch(() => {
      });
    }, Xl = ({ xhrCallback: t, fetchCallback: e, webSocketRequestCallback: i, webSocketEventCallback: n, disableWebSocketRecording: s, bodyKeysToRedact: o, backendUrl: l, tracingOrigins: a, urlBlocklist: r, sessionSecureID: c, bodyKeysToRecord: d }) => {
      const u = yl(t, l, a, r, o, d), p = Il(e, l, a, r, o, d), m = s ? () => {
      } : ((I, y, W) => {
        const Z = window._highlightWebSocketRequestCallback;
        window._highlightWebSocketRequestCallback = I;
        const g = window._highlightWebSocketEventCallback;
        return window._highlightWebSocketEventCallback = (b) => {
          const S = b, f = Fe(S, ["message", "size"]), w = W.some((K) => b.name.toLowerCase().includes(K));
          y(w ? f : b);
        }, () => {
          window._highlightWebSocketRequestCallback = Z, window._highlightWebSocketEventCallback = g;
        };
      })(i, n, r);
      return () => {
        u(), p(), m();
      };
    };
    var Gl = { REACT_APP_COMMIT_SHA: "805580fda0fa3af7d28982f12865e6b5a1e1a9e4", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
    class Ke {
      constructor(e) {
        var i, n;
        T(this, "disableConsoleRecording"), T(this, "reportConsoleErrors"), T(this, "enablePromisePatch"), T(this, "consoleMethodsToRecord"), T(this, "listeners"), T(this, "errors"), T(this, "messages"), T(this, "options"), T(this, "hasNetworkRecording", !0), T(this, "_backendUrl"), T(this, "disableNetworkRecording"), T(this, "enableRecordingNetworkContents"), T(this, "xhrNetworkContents"), T(this, "fetchNetworkContents"), T(this, "disableRecordingWebSocketContents"), T(this, "webSocketNetworkContents"), T(this, "webSocketEventContents"), T(this, "tracingOrigins"), T(this, "networkHeadersToRedact"), T(this, "networkBodyKeysToRedact"), T(this, "networkBodyKeysToRecord"), T(this, "networkHeaderKeysToRecord"), T(this, "lastNetworkRequestTimestamp"), T(this, "urlBlocklist"), T(this, "requestResponseSanitizer"), this.options = e, this.disableConsoleRecording = !!e.disableConsoleRecording, this.reportConsoleErrors = (i = e.reportConsoleErrors) != null && i, this.enablePromisePatch = (n = e.enablePromisePatch) == null || n, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [...cl], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
      }
      isListening() {
        return this.listeners.length > 0;
      }
      startListening() {
        if (this.isListening())
          return;
        const e = this;
        this.disableConsoleRecording || this.listeners.push(ll((i) => {
          var n, s, o;
          if (this.reportConsoleErrors && (i.type === "Error" || i.type === "error") && i.value && i.trace) {
            const l = Be(i.value);
            if (us.includes(l) || ps.some((a) => l.includes(a)))
              return;
            e.errors.push({ event: l, type: "console.error", url: window.location.href, source: (n = i.trace[0]) != null && n.fileName ? i.trace[0].fileName : "", lineNumber: (s = i.trace[0]) != null && s.lineNumber ? i.trace[0].lineNumber : 0, columnNumber: (o = i.trace[0]) != null && o.columnNumber ? i.trace[0].columnNumber : 0, stackTrace: i.trace, timestamp: (/* @__PURE__ */ new Date()).toISOString() });
          }
          e.messages.push(i);
        }, { level: this.consoleMethodsToRecord, logger: "console", stringifyOptions: { depthOfLimit: 10, numOfKeysLimit: 100, stringLengthLimit: 1e3 } })), this.listeners.push(rl((i) => {
          us.includes(i.event) || ps.some((n) => i.event.includes(n)) || e.errors.push(i);
        }, { enablePromisePatch: this.enablePromisePatch })), Ke.setupNetworkListener(this, this.options);
      }
      stopListening() {
        this.listeners.forEach((e) => e()), this.listeners = [];
      }
      static setupNetworkListener(e, i) {
        var n, s, o, l, a, r, c, d, u, p, m, I;
        e._backendUrl = (i == null ? void 0 : i.backendUrl) || Gl.REACT_APP_PUBLIC_GRAPH_URI || "https://pub.highlight.run", e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = i.tracingOrigins || [], (i == null ? void 0 : i.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = i == null ? void 0 : i.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = [], e.networkBodyKeysToRecord = []) : typeof (i == null ? void 0 : i.networkRecording) == "boolean" ? (e.disableNetworkRecording = !i.networkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = []) : (((n = i.networkRecording) == null ? void 0 : n.enabled) !== void 0 ? e.disableNetworkRecording = !i.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((s = i.networkRecording) == null ? void 0 : s.recordHeadersAndBody) || !1, e.disableRecordingWebSocketContents = ((o = i.networkRecording) == null ? void 0 : o.disableWebSocketEventRecordings) || !1, e.networkHeadersToRedact = ((a = (l = i.networkRecording) == null ? void 0 : l.networkHeadersToRedact) == null ? void 0 : a.map((y) => y.toLowerCase())) || [], e.networkBodyKeysToRedact = ((c = (r = i.networkRecording) == null ? void 0 : r.networkBodyKeysToRedact) == null ? void 0 : c.map((y) => y.toLowerCase())) || [], e.urlBlocklist = ((u = (d = i.networkRecording) == null ? void 0 : d.urlBlocklist) == null ? void 0 : u.map((y) => y.toLowerCase())) || [], e.urlBlocklist = [...e.urlBlocklist, ...pl], e.requestResponseSanitizer = (p = i.networkRecording) == null ? void 0 : p.requestResponseSanitizer, e.networkHeaderKeysToRecord = (m = i.networkRecording) == null ? void 0 : m.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map((y) => y.toLocaleLowerCase())), e.networkBodyKeysToRecord = (I = i.networkRecording) == null ? void 0 : I.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRedact = [], e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map((y) => y.toLocaleLowerCase()))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && e.listeners.push(Xl({ xhrCallback: (y) => {
          e.xhrNetworkContents.push(y);
        }, fetchCallback: (y) => {
          e.fetchNetworkContents.push(y);
        }, webSocketRequestCallback: (y) => {
          e.webSocketNetworkContents && e.webSocketNetworkContents.push(y);
        }, webSocketEventCallback: (y) => {
          e.webSocketEventContents.push(y);
        }, disableWebSocketRecording: e.disableRecordingWebSocketContents, bodyKeysToRedact: e.networkBodyKeysToRedact, backendUrl: e._backendUrl, tracingOrigins: e.tracingOrigins, urlBlocklist: e.urlBlocklist, sessionSecureID: i.sessionSecureID, bodyKeysToRecord: e.networkBodyKeysToRecord }));
      }
      static getRecordedNetworkResources(e, i) {
        var n, s;
        let o = [], l = [];
        if (!e.disableNetworkRecording) {
          const a = ((n = window == null ? void 0 : window.performance) == null ? void 0 : n.timeOrigin) || 0;
          o = performance.getEntriesByType("resource");
          const r = 2 * (i - a);
          if (o = o.filter((c) => !(c.responseEnd < e.lastNetworkRequestTimestamp) && xi(c.name, e._backendUrl, e.tracingOrigins)).map((c) => Te(z({}, c.toJSON()), { offsetStartTime: c.startTime - r, offsetResponseEnd: c.responseEnd - r, offsetFetchStart: c.fetchStart - r })), e.lastNetworkRequestTimestamp = ((s = o.at(-1)) == null ? void 0 : s.responseEnd) || e.lastNetworkRequestTimestamp, e.enableRecordingNetworkContents) {
            const c = { headersToRedact: e.networkHeadersToRedact, headersToRecord: e.networkHeaderKeysToRecord, requestResponseSanitizer: e.requestResponseSanitizer };
            o = Is(o, e.xhrNetworkContents, "xmlhttprequest", c), o = Is(o, e.fetchNetworkContents, "fetch", c);
          }
        }
        return e.disableRecordingWebSocketContents || (l = e.webSocketNetworkContents || []), [...o, ...l];
      }
      static getRecordedWebSocketEvents(e) {
        let i = [];
        return e.disableNetworkRecording || e.disableRecordingWebSocketContents || (i = e.webSocketEventContents), i;
      }
      static clearRecordedNetworkResources(e) {
        e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], performance.clearResourceTimings());
      }
    }
    const Wl = (t) => {
      t(window.location.href);
      const e = history.pushState;
      history.pushState = /* @__PURE__ */ ((o) => function() {
        var l = o.apply(this, arguments);
        return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange")), l;
      })(history.pushState);
      const i = history.replaceState;
      history.replaceState = /* @__PURE__ */ ((o) => function() {
        var l = o.apply(this, arguments);
        return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange")), l;
      })(history.replaceState);
      const n = () => {
        window.dispatchEvent(new Event("locationchange"));
      };
      window.addEventListener("popstate", n);
      const s = function() {
        t(window.location.href);
      };
      return window.addEventListener("locationchange", s), () => {
        window.removeEventListener("popstate", n), window.removeEventListener("locationchange", s), history.pushState = e, history.replaceState = i;
      };
    }, Ki = JSON;
    function Dt(t, e) {
      if (!t)
        throw new Error(e);
    }
    function fl(t, e) {
      if (!t)
        throw new Error(e != null ? e : "Unexpected invariant triggered.");
    }
    const Cl = /\r\n|[\n\r]/g;
    function Yi(t, e) {
      let i = 0, n = 1;
      for (const s of t.body.matchAll(Cl)) {
        if (typeof s.index == "number" || fl(!1), s.index >= e)
          break;
        i = s.index + s[0].length, n += 1;
      }
      return { line: n, column: e + 1 - i };
    }
    function Gs(t, e) {
      const i = t.locationOffset.column - 1, n = "".padStart(i) + t.body, s = e.line - 1, o = t.locationOffset.line - 1, l = e.line + o, a = e.line === 1 ? i : 0, r = e.column + a, c = `${t.name}:${l}:${r}
`, d = n.split(/\r\n|[\n\r]/g), u = d[s];
      if (u.length > 120) {
        const p = Math.floor(r / 80), m = r % 80, I = [];
        for (let y = 0; y < u.length; y += 80)
          I.push(u.slice(y, y + 80));
        return c + Ws([[`${l} |`, I[0]], ...I.slice(1, p + 1).map((y) => ["|", y]), ["|", "^".padStart(m)], ["|", I[p + 1]]]);
      }
      return c + Ws([[l - 1 + " |", d[s - 1]], [`${l} |`, u], ["|", "^".padStart(r)], [`${l + 1} |`, d[s + 1]]]);
    }
    function Ws(t) {
      const e = t.filter(([n, s]) => s !== void 0), i = Math.max(...e.map(([n]) => n.length));
      return e.map(([n, s]) => n.padStart(i) + (s ? " " + s : "")).join(`
`);
    }
    class Ui extends Error {
      constructor(e, ...i) {
        var n, s, o;
        const { nodes: l, source: a, positions: r, path: c, originalError: d, extensions: u } = function(y) {
          const W = y[0];
          return W == null || "kind" in W || "length" in W ? { nodes: W, source: y[1], positions: y[2], path: y[3], originalError: y[4], extensions: y[5] } : W;
        }(i);
        super(e), this.name = "GraphQLError", this.path = c != null ? c : void 0, this.originalError = d != null ? d : void 0, this.nodes = fs(Array.isArray(l) ? l : l ? [l] : void 0);
        const p = fs((n = this.nodes) === null || n === void 0 ? void 0 : n.map((y) => y.loc).filter((y) => y != null));
        this.source = a != null ? a : p == null || (s = p[0]) === null || s === void 0 ? void 0 : s.source, this.positions = r != null ? r : p == null ? void 0 : p.map((y) => y.start), this.locations = r && a ? r.map((y) => Yi(a, y)) : p == null ? void 0 : p.map((y) => Yi(y.source, y.start));
        const m = typeof (I = d == null ? void 0 : d.extensions) == "object" && I !== null ? d == null ? void 0 : d.extensions : void 0;
        var I;
        this.extensions = (o = u != null ? u : m) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, { message: { writable: !0, enumerable: !0 }, name: { enumerable: !1 }, nodes: { enumerable: !1 }, source: { enumerable: !1 }, positions: { enumerable: !1 }, originalError: { enumerable: !1 } }), d != null && d.stack ? Object.defineProperty(this, "stack", { value: d.stack, writable: !0, configurable: !0 }) : Error.captureStackTrace ? Error.captureStackTrace(this, Ui) : Object.defineProperty(this, "stack", { value: Error().stack, writable: !0, configurable: !0 });
      }
      get [Symbol.toStringTag]() {
        return "GraphQLError";
      }
      toString() {
        let e = this.message;
        if (this.nodes)
          for (const n of this.nodes)
            n.loc && (e += `

` + Gs((i = n.loc).source, Yi(i.source, i.start)));
        else if (this.source && this.locations)
          for (const n of this.locations)
            e += `

` + Gs(this.source, n);
        var i;
        return e;
      }
      toJSON() {
        const e = { message: this.message };
        return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
      }
    }
    function fs(t) {
      return t === void 0 || t.length === 0 ? void 0 : t;
    }
    function pe(t, e, i) {
      return new Ui(`Syntax Error: ${i}`, { source: t, positions: [e] });
    }
    class Rl {
      constructor(e, i, n) {
        this.start = e.start, this.end = i.end, this.startToken = e, this.endToken = i, this.source = n;
      }
      get [Symbol.toStringTag]() {
        return "Location";
      }
      toJSON() {
        return { start: this.start, end: this.end };
      }
    }
    class Cs {
      constructor(e, i, n, s, o, l) {
        this.kind = e, this.start = i, this.end = n, this.line = s, this.column = o, this.value = l, this.prev = null, this.next = null;
      }
      get [Symbol.toStringTag]() {
        return "Token";
      }
      toJSON() {
        return { kind: this.kind, value: this.value, line: this.line, column: this.column };
      }
    }
    const Rs = { Name: [], Document: ["definitions"], OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"], VariableDefinition: ["variable", "type", "defaultValue", "directives"], Variable: ["name"], SelectionSet: ["selections"], Field: ["alias", "name", "arguments", "directives", "selectionSet"], Argument: ["name", "value"], FragmentSpread: ["name", "directives"], InlineFragment: ["typeCondition", "directives", "selectionSet"], FragmentDefinition: ["name", "variableDefinitions", "typeCondition", "directives", "selectionSet"], IntValue: [], FloatValue: [], StringValue: [], BooleanValue: [], NullValue: [], EnumValue: [], ListValue: ["values"], ObjectValue: ["fields"], ObjectField: ["name", "value"], Directive: ["name", "arguments"], NamedType: ["name"], ListType: ["type"], NonNullType: ["type"], SchemaDefinition: ["description", "directives", "operationTypes"], OperationTypeDefinition: ["type"], ScalarTypeDefinition: ["description", "name", "directives"], ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"], FieldDefinition: ["description", "name", "arguments", "type", "directives"], InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"], InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"], UnionTypeDefinition: ["description", "name", "directives", "types"], EnumTypeDefinition: ["description", "name", "directives", "values"], EnumValueDefinition: ["description", "name", "directives"], InputObjectTypeDefinition: ["description", "name", "directives", "fields"], DirectiveDefinition: ["description", "name", "arguments", "locations"], SchemaExtension: ["directives", "operationTypes"], ScalarTypeExtension: ["name", "directives"], ObjectTypeExtension: ["name", "interfaces", "directives", "fields"], InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"], UnionTypeExtension: ["name", "directives", "types"], EnumTypeExtension: ["name", "directives", "values"], InputObjectTypeExtension: ["name", "directives", "fields"] }, vl = new Set(Object.keys(Rs));
    function vs(t) {
      const e = t == null ? void 0 : t.kind;
      return typeof e == "string" && vl.has(e);
    }
    var nt, Fi, Hi, ae, H, O, X, se;
    function Ei(t) {
      return t === 9 || t === 32;
    }
    function Xt(t) {
      return t >= 48 && t <= 57;
    }
    function ks(t) {
      return t >= 97 && t <= 122 || t >= 65 && t <= 90;
    }
    function Ts(t) {
      return ks(t) || t === 95;
    }
    function kl(t) {
      return ks(t) || Xt(t) || t === 95;
    }
    function Tl(t) {
      var e;
      let i = Number.MAX_SAFE_INTEGER, n = null, s = -1;
      for (let l = 0; l < t.length; ++l) {
        var o;
        const a = t[l], r = Nl(a);
        r !== a.length && (n = (o = n) !== null && o !== void 0 ? o : l, s = l, l !== 0 && r < i && (i = r));
      }
      return t.map((l, a) => a === 0 ? l : l.slice(i)).slice((e = n) !== null && e !== void 0 ? e : 0, s + 1);
    }
    function Nl(t) {
      let e = 0;
      for (; e < t.length && Ei(t.charCodeAt(e)); )
        ++e;
      return e;
    }
    (Fi = nt || (nt = {})).QUERY = "query", Fi.MUTATION = "mutation", Fi.SUBSCRIPTION = "subscription", (ae = Hi || (Hi = {})).QUERY = "QUERY", ae.MUTATION = "MUTATION", ae.SUBSCRIPTION = "SUBSCRIPTION", ae.FIELD = "FIELD", ae.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", ae.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", ae.INLINE_FRAGMENT = "INLINE_FRAGMENT", ae.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", ae.SCHEMA = "SCHEMA", ae.SCALAR = "SCALAR", ae.OBJECT = "OBJECT", ae.FIELD_DEFINITION = "FIELD_DEFINITION", ae.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", ae.INTERFACE = "INTERFACE", ae.UNION = "UNION", ae.ENUM = "ENUM", ae.ENUM_VALUE = "ENUM_VALUE", ae.INPUT_OBJECT = "INPUT_OBJECT", ae.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION", (O = H || (H = {})).NAME = "Name", O.DOCUMENT = "Document", O.OPERATION_DEFINITION = "OperationDefinition", O.VARIABLE_DEFINITION = "VariableDefinition", O.SELECTION_SET = "SelectionSet", O.FIELD = "Field", O.ARGUMENT = "Argument", O.FRAGMENT_SPREAD = "FragmentSpread", O.INLINE_FRAGMENT = "InlineFragment", O.FRAGMENT_DEFINITION = "FragmentDefinition", O.VARIABLE = "Variable", O.INT = "IntValue", O.FLOAT = "FloatValue", O.STRING = "StringValue", O.BOOLEAN = "BooleanValue", O.NULL = "NullValue", O.ENUM = "EnumValue", O.LIST = "ListValue", O.OBJECT = "ObjectValue", O.OBJECT_FIELD = "ObjectField", O.DIRECTIVE = "Directive", O.NAMED_TYPE = "NamedType", O.LIST_TYPE = "ListType", O.NON_NULL_TYPE = "NonNullType", O.SCHEMA_DEFINITION = "SchemaDefinition", O.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", O.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", O.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", O.FIELD_DEFINITION = "FieldDefinition", O.INPUT_VALUE_DEFINITION = "InputValueDefinition", O.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", O.UNION_TYPE_DEFINITION = "UnionTypeDefinition", O.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", O.ENUM_VALUE_DEFINITION = "EnumValueDefinition", O.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", O.DIRECTIVE_DEFINITION = "DirectiveDefinition", O.SCHEMA_EXTENSION = "SchemaExtension", O.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", O.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", O.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", O.UNION_TYPE_EXTENSION = "UnionTypeExtension", O.ENUM_TYPE_EXTENSION = "EnumTypeExtension", O.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", (se = X || (X = {})).SOF = "<SOF>", se.EOF = "<EOF>", se.BANG = "!", se.DOLLAR = "$", se.AMP = "&", se.PAREN_L = "(", se.PAREN_R = ")", se.SPREAD = "...", se.COLON = ":", se.EQUALS = "=", se.AT = "@", se.BRACKET_L = "[", se.BRACKET_R = "]", se.BRACE_L = "{", se.PIPE = "|", se.BRACE_R = "}", se.NAME = "Name", se.INT = "Int", se.FLOAT = "Float", se.STRING = "String", se.BLOCK_STRING = "BlockString", se.COMMENT = "Comment";
    class wl {
      constructor(e) {
        const i = new Cs(X.SOF, 0, 0, 0, 0);
        this.source = e, this.lastToken = i, this.token = i, this.line = 1, this.lineStart = 0;
      }
      get [Symbol.toStringTag]() {
        return "Lexer";
      }
      advance() {
        return this.lastToken = this.token, this.token = this.lookahead();
      }
      lookahead() {
        let e = this.token;
        if (e.kind !== X.EOF)
          do
            if (e.next)
              e = e.next;
            else {
              const i = Ll(this, e.end);
              e.next = i, i.prev = e, e = i;
            }
          while (e.kind === X.COMMENT);
        return e;
      }
    }
    function st(t) {
      return t >= 0 && t <= 55295 || t >= 57344 && t <= 1114111;
    }
    function Qt(t, e) {
      return Ns(t.charCodeAt(e)) && ws(t.charCodeAt(e + 1));
    }
    function Ns(t) {
      return t >= 55296 && t <= 56319;
    }
    function ws(t) {
      return t >= 56320 && t <= 57343;
    }
    function Ae(t, e) {
      const i = t.source.body.codePointAt(e);
      if (i === void 0)
        return X.EOF;
      if (i >= 32 && i <= 126) {
        const n = String.fromCodePoint(i);
        return n === '"' ? `'"'` : `"${n}"`;
      }
      return "U+" + i.toString(16).toUpperCase().padStart(4, "0");
    }
    function le(t, e, i, n, s) {
      const o = t.line, l = 1 + i - t.lineStart;
      return new Cs(e, i, n, o, l, s);
    }
    function Ll(t, e) {
      const i = t.source.body, n = i.length;
      let s = e;
      for (; s < n; ) {
        const o = i.charCodeAt(s);
        switch (o) {
          case 65279:
          case 9:
          case 32:
          case 44:
            ++s;
            continue;
          case 10:
            ++s, ++t.line, t.lineStart = s;
            continue;
          case 13:
            i.charCodeAt(s + 1) === 10 ? s += 2 : ++s, ++t.line, t.lineStart = s;
            continue;
          case 35:
            return xl(t, s);
          case 33:
            return le(t, X.BANG, s, s + 1);
          case 36:
            return le(t, X.DOLLAR, s, s + 1);
          case 38:
            return le(t, X.AMP, s, s + 1);
          case 40:
            return le(t, X.PAREN_L, s, s + 1);
          case 41:
            return le(t, X.PAREN_R, s, s + 1);
          case 46:
            if (i.charCodeAt(s + 1) === 46 && i.charCodeAt(s + 2) === 46)
              return le(t, X.SPREAD, s, s + 3);
            break;
          case 58:
            return le(t, X.COLON, s, s + 1);
          case 61:
            return le(t, X.EQUALS, s, s + 1);
          case 64:
            return le(t, X.AT, s, s + 1);
          case 91:
            return le(t, X.BRACKET_L, s, s + 1);
          case 93:
            return le(t, X.BRACKET_R, s, s + 1);
          case 123:
            return le(t, X.BRACE_L, s, s + 1);
          case 124:
            return le(t, X.PIPE, s, s + 1);
          case 125:
            return le(t, X.BRACE_R, s, s + 1);
          case 34:
            return i.charCodeAt(s + 1) === 34 && i.charCodeAt(s + 2) === 34 ? Hl(t, s) : Kl(t, s);
        }
        if (Xt(o) || o === 45)
          return Jl(t, s, o);
        if (Ts(o))
          return El(t, s);
        throw pe(t.source, s, o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : st(o) || Qt(i, s) ? `Unexpected character: ${Ae(t, s)}.` : `Invalid character: ${Ae(t, s)}.`);
      }
      return le(t, X.EOF, n, n);
    }
    function xl(t, e) {
      const i = t.source.body, n = i.length;
      let s = e + 1;
      for (; s < n; ) {
        const o = i.charCodeAt(s);
        if (o === 10 || o === 13)
          break;
        if (st(o))
          ++s;
        else {
          if (!Qt(i, s))
            break;
          s += 2;
        }
      }
      return le(t, X.COMMENT, e, s, i.slice(e + 1, s));
    }
    function Jl(t, e, i) {
      const n = t.source.body;
      let s = e, o = i, l = !1;
      if (o === 45 && (o = n.charCodeAt(++s)), o === 48) {
        if (o = n.charCodeAt(++s), Xt(o))
          throw pe(t.source, s, `Invalid number, unexpected digit after 0: ${Ae(t, s)}.`);
      } else
        s = Mi(t, s, o), o = n.charCodeAt(s);
      if (o === 46 && (l = !0, o = n.charCodeAt(++s), s = Mi(t, s, o), o = n.charCodeAt(s)), o !== 69 && o !== 101 || (l = !0, o = n.charCodeAt(++s), o !== 43 && o !== 45 || (o = n.charCodeAt(++s)), s = Mi(t, s, o), o = n.charCodeAt(s)), o === 46 || Ts(o))
        throw pe(t.source, s, `Invalid number, expected digit but got: ${Ae(t, s)}.`);
      return le(t, l ? X.FLOAT : X.INT, e, s, n.slice(e, s));
    }
    function Mi(t, e, i) {
      if (!Xt(i))
        throw pe(t.source, e, `Invalid number, expected digit but got: ${Ae(t, e)}.`);
      const n = t.source.body;
      let s = e + 1;
      for (; Xt(n.charCodeAt(s)); )
        ++s;
      return s;
    }
    function Kl(t, e) {
      const i = t.source.body, n = i.length;
      let s = e + 1, o = s, l = "";
      for (; s < n; ) {
        const a = i.charCodeAt(s);
        if (a === 34)
          return l += i.slice(o, s), le(t, X.STRING, e, s + 1, l);
        if (a !== 92) {
          if (a === 10 || a === 13)
            break;
          if (st(a))
            ++s;
          else {
            if (!Qt(i, s))
              throw pe(t.source, s, `Invalid character within String: ${Ae(t, s)}.`);
            s += 2;
          }
        } else {
          l += i.slice(o, s);
          const r = i.charCodeAt(s + 1) === 117 ? i.charCodeAt(s + 2) === 123 ? Yl(t, s) : Ul(t, s) : Fl(t, s);
          l += r.value, s += r.size, o = s;
        }
      }
      throw pe(t.source, s, "Unterminated string.");
    }
    function Yl(t, e) {
      const i = t.source.body;
      let n = 0, s = 3;
      for (; s < 12; ) {
        const o = i.charCodeAt(e + s++);
        if (o === 125) {
          if (s < 5 || !st(n))
            break;
          return { value: String.fromCodePoint(n), size: s };
        }
        if (n = n << 4 | Gt(o), n < 0)
          break;
      }
      throw pe(t.source, e, `Invalid Unicode escape sequence: "${i.slice(e, e + s)}".`);
    }
    function Ul(t, e) {
      const i = t.source.body, n = Ls(i, e + 2);
      if (st(n))
        return { value: String.fromCodePoint(n), size: 6 };
      if (Ns(n) && i.charCodeAt(e + 6) === 92 && i.charCodeAt(e + 7) === 117) {
        const s = Ls(i, e + 8);
        if (ws(s))
          return { value: String.fromCodePoint(n, s), size: 12 };
      }
      throw pe(t.source, e, `Invalid Unicode escape sequence: "${i.slice(e, e + 6)}".`);
    }
    function Ls(t, e) {
      return Gt(t.charCodeAt(e)) << 12 | Gt(t.charCodeAt(e + 1)) << 8 | Gt(t.charCodeAt(e + 2)) << 4 | Gt(t.charCodeAt(e + 3));
    }
    function Gt(t) {
      return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
    }
    function Fl(t, e) {
      const i = t.source.body;
      switch (i.charCodeAt(e + 1)) {
        case 34:
          return { value: '"', size: 2 };
        case 92:
          return { value: "\\", size: 2 };
        case 47:
          return { value: "/", size: 2 };
        case 98:
          return { value: "\b", size: 2 };
        case 102:
          return { value: "\f", size: 2 };
        case 110:
          return { value: `
`, size: 2 };
        case 114:
          return { value: "\r", size: 2 };
        case 116:
          return { value: "	", size: 2 };
      }
      throw pe(t.source, e, `Invalid character escape sequence: "${i.slice(e, e + 2)}".`);
    }
    function Hl(t, e) {
      const i = t.source.body, n = i.length;
      let s = t.lineStart, o = e + 3, l = o, a = "";
      const r = [];
      for (; o < n; ) {
        const c = i.charCodeAt(o);
        if (c === 34 && i.charCodeAt(o + 1) === 34 && i.charCodeAt(o + 2) === 34) {
          a += i.slice(l, o), r.push(a);
          const d = le(t, X.BLOCK_STRING, e, o + 3, Tl(r).join(`
`));
          return t.line += r.length - 1, t.lineStart = s, d;
        }
        if (c !== 92 || i.charCodeAt(o + 1) !== 34 || i.charCodeAt(o + 2) !== 34 || i.charCodeAt(o + 3) !== 34)
          if (c !== 10 && c !== 13)
            if (st(c))
              ++o;
            else {
              if (!Qt(i, o))
                throw pe(t.source, o, `Invalid character within String: ${Ae(t, o)}.`);
              o += 2;
            }
          else
            a += i.slice(l, o), r.push(a), c === 13 && i.charCodeAt(o + 1) === 10 ? o += 2 : ++o, a = "", l = o, s = o;
        else
          a += i.slice(l, o), l = o + 1, o += 4;
      }
      throw pe(t.source, o, "Unterminated string.");
    }
    function El(t, e) {
      const i = t.source.body, n = i.length;
      let s = e + 1;
      for (; s < n && kl(i.charCodeAt(s)); )
        ++s;
      return le(t, X.NAME, e, s, i.slice(e, s));
    }
    const Ml = 10, xs = 2;
    function Oi(t) {
      return jt(t, []);
    }
    function jt(t, e) {
      switch (typeof t) {
        case "string":
          return JSON.stringify(t);
        case "function":
          return t.name ? `[function ${t.name}]` : "[function]";
        case "object":
          return function(i, n) {
            if (i === null)
              return "null";
            if (n.includes(i))
              return "[Circular]";
            const s = [...n, i];
            if (function(o) {
              return typeof o.toJSON == "function";
            }(i)) {
              const o = i.toJSON();
              if (o !== i)
                return typeof o == "string" ? o : jt(o, s);
            } else if (Array.isArray(i))
              return function(o, l) {
                if (o.length === 0)
                  return "[]";
                if (l.length > xs)
                  return "[Array]";
                const a = Math.min(Ml, o.length), r = o.length - a, c = [];
                for (let d = 0; d < a; ++d)
                  c.push(jt(o[d], l));
                return r === 1 ? c.push("... 1 more item") : r > 1 && c.push(`... ${r} more items`), "[" + c.join(", ") + "]";
              }(i, s);
            return function(o, l) {
              const a = Object.entries(o);
              return a.length === 0 ? "{}" : l.length > xs ? "[" + function(c) {
                const d = Object.prototype.toString.call(c).replace(/^\[object /, "").replace(/]$/, "");
                if (d === "Object" && typeof c.constructor == "function") {
                  const u = c.constructor.name;
                  if (typeof u == "string" && u !== "")
                    return u;
                }
                return d;
              }(o) + "]" : "{ " + a.map(([c, d]) => c + ": " + jt(d, l)).join(", ") + " }";
            }(i, s);
          }(t, e);
        default:
          return String(t);
      }
    }
    const Ol = globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(t, e) {
      return t instanceof e;
    } : function(t, e) {
      if (t instanceof e)
        return !0;
      if (typeof t == "object" && t !== null) {
        var i;
        const n = e.prototype[Symbol.toStringTag];
        if (n === (Symbol.toStringTag in t ? t[Symbol.toStringTag] : (i = t.constructor) === null || i === void 0 ? void 0 : i.name)) {
          const s = Oi(t);
          throw new Error(`Cannot use ${n} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
      }
      return !1;
    };
    class Js {
      constructor(e, i = "GraphQL request", n = { line: 1, column: 1 }) {
        typeof e == "string" || Dt(!1, `Body must be a string. Received: ${Oi(e)}.`), this.body = e, this.name = i, this.locationOffset = n, this.locationOffset.line > 0 || Dt(!1, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || Dt(!1, "column in locationOffset is 1-indexed and must be positive.");
      }
      get [Symbol.toStringTag]() {
        return "Source";
      }
    }
    function Ks(t, e) {
      return new zl(t, e).parseDocument();
    }
    class zl {
      constructor(e, i = {}) {
        const n = function(s) {
          return Ol(s, Js);
        }(e) ? e : new Js(e);
        this._lexer = new wl(n), this._options = i, this._tokenCounter = 0;
      }
      parseName() {
        const e = this.expectToken(X.NAME);
        return this.node(e, { kind: H.NAME, value: e.value });
      }
      parseDocument() {
        return this.node(this._lexer.token, { kind: H.DOCUMENT, definitions: this.many(X.SOF, this.parseDefinition, X.EOF) });
      }
      parseDefinition() {
        if (this.peek(X.BRACE_L))
          return this.parseOperationDefinition();
        const e = this.peekDescription(), i = e ? this._lexer.lookahead() : this._lexer.token;
        if (i.kind === X.NAME) {
          switch (i.value) {
            case "schema":
              return this.parseSchemaDefinition();
            case "scalar":
              return this.parseScalarTypeDefinition();
            case "type":
              return this.parseObjectTypeDefinition();
            case "interface":
              return this.parseInterfaceTypeDefinition();
            case "union":
              return this.parseUnionTypeDefinition();
            case "enum":
              return this.parseEnumTypeDefinition();
            case "input":
              return this.parseInputObjectTypeDefinition();
            case "directive":
              return this.parseDirectiveDefinition();
          }
          if (e)
            throw pe(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
          switch (i.value) {
            case "query":
            case "mutation":
            case "subscription":
              return this.parseOperationDefinition();
            case "fragment":
              return this.parseFragmentDefinition();
            case "extend":
              return this.parseTypeSystemExtension();
          }
        }
        throw this.unexpected(i);
      }
      parseOperationDefinition() {
        const e = this._lexer.token;
        if (this.peek(X.BRACE_L))
          return this.node(e, { kind: H.OPERATION_DEFINITION, operation: nt.QUERY, name: void 0, variableDefinitions: [], directives: [], selectionSet: this.parseSelectionSet() });
        const i = this.parseOperationType();
        let n;
        return this.peek(X.NAME) && (n = this.parseName()), this.node(e, { kind: H.OPERATION_DEFINITION, operation: i, name: n, variableDefinitions: this.parseVariableDefinitions(), directives: this.parseDirectives(!1), selectionSet: this.parseSelectionSet() });
      }
      parseOperationType() {
        const e = this.expectToken(X.NAME);
        switch (e.value) {
          case "query":
            return nt.QUERY;
          case "mutation":
            return nt.MUTATION;
          case "subscription":
            return nt.SUBSCRIPTION;
        }
        throw this.unexpected(e);
      }
      parseVariableDefinitions() {
        return this.optionalMany(X.PAREN_L, this.parseVariableDefinition, X.PAREN_R);
      }
      parseVariableDefinition() {
        return this.node(this._lexer.token, { kind: H.VARIABLE_DEFINITION, variable: this.parseVariable(), type: (this.expectToken(X.COLON), this.parseTypeReference()), defaultValue: this.expectOptionalToken(X.EQUALS) ? this.parseConstValueLiteral() : void 0, directives: this.parseConstDirectives() });
      }
      parseVariable() {
        const e = this._lexer.token;
        return this.expectToken(X.DOLLAR), this.node(e, { kind: H.VARIABLE, name: this.parseName() });
      }
      parseSelectionSet() {
        return this.node(this._lexer.token, { kind: H.SELECTION_SET, selections: this.many(X.BRACE_L, this.parseSelection, X.BRACE_R) });
      }
      parseSelection() {
        return this.peek(X.SPREAD) ? this.parseFragment() : this.parseField();
      }
      parseField() {
        const e = this._lexer.token, i = this.parseName();
        let n, s;
        return this.expectOptionalToken(X.COLON) ? (n = i, s = this.parseName()) : s = i, this.node(e, { kind: H.FIELD, alias: n, name: s, arguments: this.parseArguments(!1), directives: this.parseDirectives(!1), selectionSet: this.peek(X.BRACE_L) ? this.parseSelectionSet() : void 0 });
      }
      parseArguments(e) {
        const i = e ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany(X.PAREN_L, i, X.PAREN_R);
      }
      parseArgument(e = !1) {
        const i = this._lexer.token, n = this.parseName();
        return this.expectToken(X.COLON), this.node(i, { kind: H.ARGUMENT, name: n, value: this.parseValueLiteral(e) });
      }
      parseConstArgument() {
        return this.parseArgument(!0);
      }
      parseFragment() {
        const e = this._lexer.token;
        this.expectToken(X.SPREAD);
        const i = this.expectOptionalKeyword("on");
        return !i && this.peek(X.NAME) ? this.node(e, { kind: H.FRAGMENT_SPREAD, name: this.parseFragmentName(), directives: this.parseDirectives(!1) }) : this.node(e, { kind: H.INLINE_FRAGMENT, typeCondition: i ? this.parseNamedType() : void 0, directives: this.parseDirectives(!1), selectionSet: this.parseSelectionSet() });
      }
      parseFragmentDefinition() {
        const e = this._lexer.token;
        return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, { kind: H.FRAGMENT_DEFINITION, name: this.parseFragmentName(), variableDefinitions: this.parseVariableDefinitions(), typeCondition: (this.expectKeyword("on"), this.parseNamedType()), directives: this.parseDirectives(!1), selectionSet: this.parseSelectionSet() }) : this.node(e, { kind: H.FRAGMENT_DEFINITION, name: this.parseFragmentName(), typeCondition: (this.expectKeyword("on"), this.parseNamedType()), directives: this.parseDirectives(!1), selectionSet: this.parseSelectionSet() });
      }
      parseFragmentName() {
        if (this._lexer.token.value === "on")
          throw this.unexpected();
        return this.parseName();
      }
      parseValueLiteral(e) {
        const i = this._lexer.token;
        switch (i.kind) {
          case X.BRACKET_L:
            return this.parseList(e);
          case X.BRACE_L:
            return this.parseObject(e);
          case X.INT:
            return this.advanceLexer(), this.node(i, { kind: H.INT, value: i.value });
          case X.FLOAT:
            return this.advanceLexer(), this.node(i, { kind: H.FLOAT, value: i.value });
          case X.STRING:
          case X.BLOCK_STRING:
            return this.parseStringLiteral();
          case X.NAME:
            switch (this.advanceLexer(), i.value) {
              case "true":
                return this.node(i, { kind: H.BOOLEAN, value: !0 });
              case "false":
                return this.node(i, { kind: H.BOOLEAN, value: !1 });
              case "null":
                return this.node(i, { kind: H.NULL });
              default:
                return this.node(i, { kind: H.ENUM, value: i.value });
            }
          case X.DOLLAR:
            if (e) {
              if (this.expectToken(X.DOLLAR), this._lexer.token.kind === X.NAME) {
                const n = this._lexer.token.value;
                throw pe(this._lexer.source, i.start, `Unexpected variable "$${n}" in constant value.`);
              }
              throw this.unexpected(i);
            }
            return this.parseVariable();
          default:
            throw this.unexpected();
        }
      }
      parseConstValueLiteral() {
        return this.parseValueLiteral(!0);
      }
      parseStringLiteral() {
        const e = this._lexer.token;
        return this.advanceLexer(), this.node(e, { kind: H.STRING, value: e.value, block: e.kind === X.BLOCK_STRING });
      }
      parseList(e) {
        return this.node(this._lexer.token, { kind: H.LIST, values: this.any(X.BRACKET_L, () => this.parseValueLiteral(e), X.BRACKET_R) });
      }
      parseObject(e) {
        return this.node(this._lexer.token, { kind: H.OBJECT, fields: this.any(X.BRACE_L, () => this.parseObjectField(e), X.BRACE_R) });
      }
      parseObjectField(e) {
        const i = this._lexer.token, n = this.parseName();
        return this.expectToken(X.COLON), this.node(i, { kind: H.OBJECT_FIELD, name: n, value: this.parseValueLiteral(e) });
      }
      parseDirectives(e) {
        const i = [];
        for (; this.peek(X.AT); )
          i.push(this.parseDirective(e));
        return i;
      }
      parseConstDirectives() {
        return this.parseDirectives(!0);
      }
      parseDirective(e) {
        const i = this._lexer.token;
        return this.expectToken(X.AT), this.node(i, { kind: H.DIRECTIVE, name: this.parseName(), arguments: this.parseArguments(e) });
      }
      parseTypeReference() {
        const e = this._lexer.token;
        let i;
        if (this.expectOptionalToken(X.BRACKET_L)) {
          const n = this.parseTypeReference();
          this.expectToken(X.BRACKET_R), i = this.node(e, { kind: H.LIST_TYPE, type: n });
        } else
          i = this.parseNamedType();
        return this.expectOptionalToken(X.BANG) ? this.node(e, { kind: H.NON_NULL_TYPE, type: i }) : i;
      }
      parseNamedType() {
        return this.node(this._lexer.token, { kind: H.NAMED_TYPE, name: this.parseName() });
      }
      peekDescription() {
        return this.peek(X.STRING) || this.peek(X.BLOCK_STRING);
      }
      parseDescription() {
        if (this.peekDescription())
          return this.parseStringLiteral();
      }
      parseSchemaDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("schema");
        const n = this.parseConstDirectives(), s = this.many(X.BRACE_L, this.parseOperationTypeDefinition, X.BRACE_R);
        return this.node(e, { kind: H.SCHEMA_DEFINITION, description: i, directives: n, operationTypes: s });
      }
      parseOperationTypeDefinition() {
        const e = this._lexer.token, i = this.parseOperationType();
        this.expectToken(X.COLON);
        const n = this.parseNamedType();
        return this.node(e, { kind: H.OPERATION_TYPE_DEFINITION, operation: i, type: n });
      }
      parseScalarTypeDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("scalar");
        const n = this.parseName(), s = this.parseConstDirectives();
        return this.node(e, { kind: H.SCALAR_TYPE_DEFINITION, description: i, name: n, directives: s });
      }
      parseObjectTypeDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("type");
        const n = this.parseName(), s = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), l = this.parseFieldsDefinition();
        return this.node(e, { kind: H.OBJECT_TYPE_DEFINITION, description: i, name: n, interfaces: s, directives: o, fields: l });
      }
      parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany(X.AMP, this.parseNamedType) : [];
      }
      parseFieldsDefinition() {
        return this.optionalMany(X.BRACE_L, this.parseFieldDefinition, X.BRACE_R);
      }
      parseFieldDefinition() {
        const e = this._lexer.token, i = this.parseDescription(), n = this.parseName(), s = this.parseArgumentDefs();
        this.expectToken(X.COLON);
        const o = this.parseTypeReference(), l = this.parseConstDirectives();
        return this.node(e, { kind: H.FIELD_DEFINITION, description: i, name: n, arguments: s, type: o, directives: l });
      }
      parseArgumentDefs() {
        return this.optionalMany(X.PAREN_L, this.parseInputValueDef, X.PAREN_R);
      }
      parseInputValueDef() {
        const e = this._lexer.token, i = this.parseDescription(), n = this.parseName();
        this.expectToken(X.COLON);
        const s = this.parseTypeReference();
        let o;
        this.expectOptionalToken(X.EQUALS) && (o = this.parseConstValueLiteral());
        const l = this.parseConstDirectives();
        return this.node(e, { kind: H.INPUT_VALUE_DEFINITION, description: i, name: n, type: s, defaultValue: o, directives: l });
      }
      parseInterfaceTypeDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("interface");
        const n = this.parseName(), s = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), l = this.parseFieldsDefinition();
        return this.node(e, { kind: H.INTERFACE_TYPE_DEFINITION, description: i, name: n, interfaces: s, directives: o, fields: l });
      }
      parseUnionTypeDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("union");
        const n = this.parseName(), s = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
        return this.node(e, { kind: H.UNION_TYPE_DEFINITION, description: i, name: n, directives: s, types: o });
      }
      parseUnionMemberTypes() {
        return this.expectOptionalToken(X.EQUALS) ? this.delimitedMany(X.PIPE, this.parseNamedType) : [];
      }
      parseEnumTypeDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("enum");
        const n = this.parseName(), s = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
        return this.node(e, { kind: H.ENUM_TYPE_DEFINITION, description: i, name: n, directives: s, values: o });
      }
      parseEnumValuesDefinition() {
        return this.optionalMany(X.BRACE_L, this.parseEnumValueDefinition, X.BRACE_R);
      }
      parseEnumValueDefinition() {
        const e = this._lexer.token, i = this.parseDescription(), n = this.parseEnumValueName(), s = this.parseConstDirectives();
        return this.node(e, { kind: H.ENUM_VALUE_DEFINITION, description: i, name: n, directives: s });
      }
      parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
          throw pe(this._lexer.source, this._lexer.token.start, `${_t(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
      }
      parseInputObjectTypeDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("input");
        const n = this.parseName(), s = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
        return this.node(e, { kind: H.INPUT_OBJECT_TYPE_DEFINITION, description: i, name: n, directives: s, fields: o });
      }
      parseInputFieldsDefinition() {
        return this.optionalMany(X.BRACE_L, this.parseInputValueDef, X.BRACE_R);
      }
      parseTypeSystemExtension() {
        const e = this._lexer.lookahead();
        if (e.kind === X.NAME)
          switch (e.value) {
            case "schema":
              return this.parseSchemaExtension();
            case "scalar":
              return this.parseScalarTypeExtension();
            case "type":
              return this.parseObjectTypeExtension();
            case "interface":
              return this.parseInterfaceTypeExtension();
            case "union":
              return this.parseUnionTypeExtension();
            case "enum":
              return this.parseEnumTypeExtension();
            case "input":
              return this.parseInputObjectTypeExtension();
          }
        throw this.unexpected(e);
      }
      parseSchemaExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("schema");
        const i = this.parseConstDirectives(), n = this.optionalMany(X.BRACE_L, this.parseOperationTypeDefinition, X.BRACE_R);
        if (i.length === 0 && n.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.SCHEMA_EXTENSION, directives: i, operationTypes: n });
      }
      parseScalarTypeExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("scalar");
        const i = this.parseName(), n = this.parseConstDirectives();
        if (n.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.SCALAR_TYPE_EXTENSION, name: i, directives: n });
      }
      parseObjectTypeExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("type");
        const i = this.parseName(), n = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
        if (n.length === 0 && s.length === 0 && o.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.OBJECT_TYPE_EXTENSION, name: i, interfaces: n, directives: s, fields: o });
      }
      parseInterfaceTypeExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("interface");
        const i = this.parseName(), n = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
        if (n.length === 0 && s.length === 0 && o.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.INTERFACE_TYPE_EXTENSION, name: i, interfaces: n, directives: s, fields: o });
      }
      parseUnionTypeExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("union");
        const i = this.parseName(), n = this.parseConstDirectives(), s = this.parseUnionMemberTypes();
        if (n.length === 0 && s.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.UNION_TYPE_EXTENSION, name: i, directives: n, types: s });
      }
      parseEnumTypeExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("enum");
        const i = this.parseName(), n = this.parseConstDirectives(), s = this.parseEnumValuesDefinition();
        if (n.length === 0 && s.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.ENUM_TYPE_EXTENSION, name: i, directives: n, values: s });
      }
      parseInputObjectTypeExtension() {
        const e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("input");
        const i = this.parseName(), n = this.parseConstDirectives(), s = this.parseInputFieldsDefinition();
        if (n.length === 0 && s.length === 0)
          throw this.unexpected();
        return this.node(e, { kind: H.INPUT_OBJECT_TYPE_EXTENSION, name: i, directives: n, fields: s });
      }
      parseDirectiveDefinition() {
        const e = this._lexer.token, i = this.parseDescription();
        this.expectKeyword("directive"), this.expectToken(X.AT);
        const n = this.parseName(), s = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const l = this.parseDirectiveLocations();
        return this.node(e, { kind: H.DIRECTIVE_DEFINITION, description: i, name: n, arguments: s, repeatable: o, locations: l });
      }
      parseDirectiveLocations() {
        return this.delimitedMany(X.PIPE, this.parseDirectiveLocation);
      }
      parseDirectiveLocation() {
        const e = this._lexer.token, i = this.parseName();
        if (Object.prototype.hasOwnProperty.call(Hi, i.value))
          return i;
        throw this.unexpected(e);
      }
      node(e, i) {
        return this._options.noLocation !== !0 && (i.loc = new Rl(e, this._lexer.lastToken, this._lexer.source)), i;
      }
      peek(e) {
        return this._lexer.token.kind === e;
      }
      expectToken(e) {
        const i = this._lexer.token;
        if (i.kind === e)
          return this.advanceLexer(), i;
        throw pe(this._lexer.source, i.start, `Expected ${Ys(e)}, found ${_t(i)}.`);
      }
      expectOptionalToken(e) {
        return this._lexer.token.kind === e && (this.advanceLexer(), !0);
      }
      expectKeyword(e) {
        const i = this._lexer.token;
        if (i.kind !== X.NAME || i.value !== e)
          throw pe(this._lexer.source, i.start, `Expected "${e}", found ${_t(i)}.`);
        this.advanceLexer();
      }
      expectOptionalKeyword(e) {
        const i = this._lexer.token;
        return i.kind === X.NAME && i.value === e && (this.advanceLexer(), !0);
      }
      unexpected(e) {
        const i = e != null ? e : this._lexer.token;
        return pe(this._lexer.source, i.start, `Unexpected ${_t(i)}.`);
      }
      any(e, i, n) {
        this.expectToken(e);
        const s = [];
        for (; !this.expectOptionalToken(n); )
          s.push(i.call(this));
        return s;
      }
      optionalMany(e, i, n) {
        if (this.expectOptionalToken(e)) {
          const s = [];
          do
            s.push(i.call(this));
          while (!this.expectOptionalToken(n));
          return s;
        }
        return [];
      }
      many(e, i, n) {
        this.expectToken(e);
        const s = [];
        do
          s.push(i.call(this));
        while (!this.expectOptionalToken(n));
        return s;
      }
      delimitedMany(e, i) {
        this.expectOptionalToken(e);
        const n = [];
        do
          n.push(i.call(this));
        while (this.expectOptionalToken(e));
        return n;
      }
      advanceLexer() {
        const { maxTokens: e } = this._options, i = this._lexer.advance();
        if (e !== void 0 && i.kind !== X.EOF && (++this._tokenCounter, this._tokenCounter > e))
          throw pe(this._lexer.source, i.start, `Document contains more that ${e} tokens. Parsing aborted.`);
      }
    }
    function _t(t) {
      const e = t.value;
      return Ys(t.kind) + (e != null ? ` "${e}"` : "");
    }
    function Ys(t) {
      return function(e) {
        return e === X.BANG || e === X.DOLLAR || e === X.AMP || e === X.PAREN_L || e === X.PAREN_R || e === X.SPREAD || e === X.COLON || e === X.EQUALS || e === X.AT || e === X.BRACKET_L || e === X.BRACKET_R || e === X.BRACE_L || e === X.PIPE || e === X.BRACE_R;
      }(t) ? `"${t}"` : t;
    }
    const Bl = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
    function Pl(t) {
      return Al[t.charCodeAt(0)];
    }
    const Al = ["\\u0000", "\\u0001", "\\u0002", "\\u0003", "\\u0004", "\\u0005", "\\u0006", "\\u0007", "\\b", "\\t", "\\n", "\\u000B", "\\f", "\\r", "\\u000E", "\\u000F", "\\u0010", "\\u0011", "\\u0012", "\\u0013", "\\u0014", "\\u0015", "\\u0016", "\\u0017", "\\u0018", "\\u0019", "\\u001A", "\\u001B", "\\u001C", "\\u001D", "\\u001E", "\\u001F", "", "", '\\"', "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "\\\\", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "\\u007F", "\\u0080", "\\u0081", "\\u0082", "\\u0083", "\\u0084", "\\u0085", "\\u0086", "\\u0087", "\\u0088", "\\u0089", "\\u008A", "\\u008B", "\\u008C", "\\u008D", "\\u008E", "\\u008F", "\\u0090", "\\u0091", "\\u0092", "\\u0093", "\\u0094", "\\u0095", "\\u0096", "\\u0097", "\\u0098", "\\u0099", "\\u009A", "\\u009B", "\\u009C", "\\u009D", "\\u009E", "\\u009F"], Dl = Object.freeze({});
    function Ql(t, e) {
      const i = t[e];
      return typeof i == "object" ? i : typeof i == "function" ? { enter: i, leave: void 0 } : { enter: t.enter, leave: t.leave };
    }
    function Us(t) {
      return function(e, i, n = Rs) {
        const s = /* @__PURE__ */ new Map();
        for (const g of Object.values(H))
          s.set(g, Ql(i, g));
        let o, l, a, r = Array.isArray(e), c = [e], d = -1, u = [], p = e;
        const m = [], I = [];
        do {
          d++;
          const g = d === c.length, b = g && u.length !== 0;
          if (g) {
            if (l = I.length === 0 ? void 0 : m[m.length - 1], p = a, a = I.pop(), b)
              if (r) {
                p = p.slice();
                let f = 0;
                for (const [w, K] of u) {
                  const Y = w - f;
                  K === null ? (p.splice(Y, 1), f++) : p[Y] = K;
                }
              } else {
                p = Object.defineProperties({}, Object.getOwnPropertyDescriptors(p));
                for (const [f, w] of u)
                  p[f] = w;
              }
            d = o.index, c = o.keys, u = o.edits, r = o.inArray, o = o.prev;
          } else if (a) {
            if (l = r ? d : c[d], p = a[l], p == null)
              continue;
            m.push(l);
          }
          let S;
          if (!Array.isArray(p)) {
            var y, W;
            vs(p) || Dt(!1, `Invalid AST Node: ${Oi(p)}.`);
            const f = g ? (y = s.get(p.kind)) === null || y === void 0 ? void 0 : y.leave : (W = s.get(p.kind)) === null || W === void 0 ? void 0 : W.enter;
            if (S = f == null ? void 0 : f.call(i, p, l, a, m, I), S === Dl)
              break;
            if (S === !1) {
              if (!g) {
                m.pop();
                continue;
              }
            } else if (S !== void 0 && (u.push([l, S]), !g)) {
              if (!vs(S)) {
                m.pop();
                continue;
              }
              p = S;
            }
          }
          var Z;
          S === void 0 && b && u.push([l, p]), g ? m.pop() : (o = { inArray: r, index: d, keys: c, edits: u, prev: o }, r = Array.isArray(p), c = r ? p : (Z = n[p.kind]) !== null && Z !== void 0 ? Z : [], d = -1, u = [], a && I.push(a), a = p);
        } while (o !== void 0);
        return u.length !== 0 ? u[u.length - 1][1] : e;
      }(t, jl);
    }
    const jl = { Name: { leave: (t) => t.value }, Variable: { leave: (t) => "$" + t.name }, Document: { leave: (t) => J(t.definitions, `

`) }, OperationDefinition: { leave(t) {
      const e = A("(", J(t.variableDefinitions, ", "), ")"), i = J([t.operation, J([t.name, e]), J(t.directives, " ")], " ");
      return (i === "query" ? "" : i + " ") + t.selectionSet;
    } }, VariableDefinition: { leave: ({ variable: t, type: e, defaultValue: i, directives: n }) => t + ": " + e + A(" = ", i) + A(" ", J(n, " ")) }, SelectionSet: { leave: ({ selections: t }) => ke(t) }, Field: { leave({ alias: t, name: e, arguments: i, directives: n, selectionSet: s }) {
      const o = A("", t, ": ") + e;
      let l = o + A("(", J(i, ", "), ")");
      return l.length > 80 && (l = o + A(`(
`, qt(J(i, `
`)), `
)`)), J([l, J(n, " "), s], " ");
    } }, Argument: { leave: ({ name: t, value: e }) => t + ": " + e }, FragmentSpread: { leave: ({ name: t, directives: e }) => "..." + t + A(" ", J(e, " ")) }, InlineFragment: { leave: ({ typeCondition: t, directives: e, selectionSet: i }) => J(["...", A("on ", t), J(e, " "), i], " ") }, FragmentDefinition: { leave: ({ name: t, typeCondition: e, variableDefinitions: i, directives: n, selectionSet: s }) => `fragment ${t}${A("(", J(i, ", "), ")")} on ${e} ${A("", J(n, " "), " ")}` + s }, IntValue: { leave: ({ value: t }) => t }, FloatValue: { leave: ({ value: t }) => t }, StringValue: { leave: ({ value: t, block: e }) => e ? function(i, n) {
      const s = i.replace(/"""/g, '\\"""'), o = s.split(/\r\n|[\n\r]/g), l = o.length === 1, a = o.length > 1 && o.slice(1).every((y) => y.length === 0 || Ei(y.charCodeAt(0))), r = s.endsWith('\\"""'), c = i.endsWith('"') && !r, d = i.endsWith("\\"), u = c || d, p = !(n != null && n.minimize) && (!l || i.length > 70 || u || a || r);
      let m = "";
      const I = l && Ei(i.charCodeAt(0));
      return (p && !I || a) && (m += `
`), m += s, (p || u) && (m += `
`), '"""' + m + '"""';
    }(t) : `"${t.replace(Bl, Pl)}"` }, BooleanValue: { leave: ({ value: t }) => t ? "true" : "false" }, NullValue: { leave: () => "null" }, EnumValue: { leave: ({ value: t }) => t }, ListValue: { leave: ({ values: t }) => "[" + J(t, ", ") + "]" }, ObjectValue: { leave: ({ fields: t }) => "{" + J(t, ", ") + "}" }, ObjectField: { leave: ({ name: t, value: e }) => t + ": " + e }, Directive: { leave: ({ name: t, arguments: e }) => "@" + t + A("(", J(e, ", "), ")") }, NamedType: { leave: ({ name: t }) => t }, ListType: { leave: ({ type: t }) => "[" + t + "]" }, NonNullType: { leave: ({ type: t }) => t + "!" }, SchemaDefinition: { leave: ({ description: t, directives: e, operationTypes: i }) => A("", t, `
`) + J(["schema", J(e, " "), ke(i)], " ") }, OperationTypeDefinition: { leave: ({ operation: t, type: e }) => t + ": " + e }, ScalarTypeDefinition: { leave: ({ description: t, name: e, directives: i }) => A("", t, `
`) + J(["scalar", e, J(i, " ")], " ") }, ObjectTypeDefinition: { leave: ({ description: t, name: e, interfaces: i, directives: n, fields: s }) => A("", t, `
`) + J(["type", e, A("implements ", J(i, " & ")), J(n, " "), ke(s)], " ") }, FieldDefinition: { leave: ({ description: t, name: e, arguments: i, type: n, directives: s }) => A("", t, `
`) + e + (Fs(i) ? A(`(
`, qt(J(i, `
`)), `
)`) : A("(", J(i, ", "), ")")) + ": " + n + A(" ", J(s, " ")) }, InputValueDefinition: { leave: ({ description: t, name: e, type: i, defaultValue: n, directives: s }) => A("", t, `
`) + J([e + ": " + i, A("= ", n), J(s, " ")], " ") }, InterfaceTypeDefinition: { leave: ({ description: t, name: e, interfaces: i, directives: n, fields: s }) => A("", t, `
`) + J(["interface", e, A("implements ", J(i, " & ")), J(n, " "), ke(s)], " ") }, UnionTypeDefinition: { leave: ({ description: t, name: e, directives: i, types: n }) => A("", t, `
`) + J(["union", e, J(i, " "), A("= ", J(n, " | "))], " ") }, EnumTypeDefinition: { leave: ({ description: t, name: e, directives: i, values: n }) => A("", t, `
`) + J(["enum", e, J(i, " "), ke(n)], " ") }, EnumValueDefinition: { leave: ({ description: t, name: e, directives: i }) => A("", t, `
`) + J([e, J(i, " ")], " ") }, InputObjectTypeDefinition: { leave: ({ description: t, name: e, directives: i, fields: n }) => A("", t, `
`) + J(["input", e, J(i, " "), ke(n)], " ") }, DirectiveDefinition: { leave: ({ description: t, name: e, arguments: i, repeatable: n, locations: s }) => A("", t, `
`) + "directive @" + e + (Fs(i) ? A(`(
`, qt(J(i, `
`)), `
)`) : A("(", J(i, ", "), ")")) + (n ? " repeatable" : "") + " on " + J(s, " | ") }, SchemaExtension: { leave: ({ directives: t, operationTypes: e }) => J(["extend schema", J(t, " "), ke(e)], " ") }, ScalarTypeExtension: { leave: ({ name: t, directives: e }) => J(["extend scalar", t, J(e, " ")], " ") }, ObjectTypeExtension: { leave: ({ name: t, interfaces: e, directives: i, fields: n }) => J(["extend type", t, A("implements ", J(e, " & ")), J(i, " "), ke(n)], " ") }, InterfaceTypeExtension: { leave: ({ name: t, interfaces: e, directives: i, fields: n }) => J(["extend interface", t, A("implements ", J(e, " & ")), J(i, " "), ke(n)], " ") }, UnionTypeExtension: { leave: ({ name: t, directives: e, types: i }) => J(["extend union", t, J(e, " "), A("= ", J(i, " | "))], " ") }, EnumTypeExtension: { leave: ({ name: t, directives: e, values: i }) => J(["extend enum", t, J(e, " "), ke(i)], " ") }, InputObjectTypeExtension: { leave: ({ name: t, directives: e, fields: i }) => J(["extend input", t, J(e, " "), ke(i)], " ") } };
    function J(t, e = "") {
      var i;
      return (i = t == null ? void 0 : t.filter((n) => n).join(e)) !== null && i !== void 0 ? i : "";
    }
    function ke(t) {
      return A(`{
`, qt(J(t, `
`)), `
}`);
    }
    function A(t, e, i = "") {
      return e != null && e !== "" ? t + e + i : "";
    }
    function qt(t) {
      return A("  ", t.replace(/\n/g, `
  `));
    }
    function Fs(t) {
      var e;
      return (e = t == null ? void 0 : t.some((i) => i.includes(`
`))) !== null && e !== void 0 && e;
    }
    const Hs = (t) => {
      var e, i;
      let n;
      const s = t.definitions.filter((o) => o.kind === "OperationDefinition");
      return s.length === 1 && (n = (i = (e = s[0]) == null ? void 0 : e.name) == null ? void 0 : i.value), n;
    }, zi = (t) => {
      if (typeof t == "string") {
        let i;
        try {
          const n = Ks(t);
          i = Hs(n);
        } catch (n) {
        }
        return { query: t, operationName: i };
      }
      const e = Hs(t);
      return { query: Us(t), operationName: e };
    };
    class ot extends Error {
      constructor(e, i) {
        super(`${ot.extractMessage(e)}: ${JSON.stringify({ response: e, request: i })}`), Object.setPrototypeOf(this, ot.prototype), this.response = e, this.request = i, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ot);
      }
      static extractMessage(e) {
        var i, n, s;
        return (s = (n = (i = e.errors) == null ? void 0 : i[0]) == null ? void 0 : n.message) != null ? s : `GraphQL Error (Code: ${e.status})`;
      }
    }
    var Bi = { exports: {} };
    (function(t, e) {
      var i, n = typeof self != "undefined" ? self : sl, s = function() {
        function l() {
          this.fetch = !1, this.DOMException = n.DOMException;
        }
        return l.prototype = n, new l();
      }();
      i = s, function(l) {
        var a = "URLSearchParams" in i, r = "Symbol" in i && "iterator" in Symbol, c = "FileReader" in i && "Blob" in i && function() {
          try {
            return new Blob(), !0;
          } catch (h) {
            return !1;
          }
        }(), d = "FormData" in i, u = "ArrayBuffer" in i;
        if (u)
          var p = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], m = ArrayBuffer.isView || function(h) {
            return h && p.indexOf(Object.prototype.toString.call(h)) > -1;
          };
        function I(h) {
          if (typeof h != "string" && (h = String(h)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(h))
            throw new TypeError("Invalid character in header field name");
          return h.toLowerCase();
        }
        function y(h) {
          return typeof h != "string" && (h = String(h)), h;
        }
        function W(h) {
          var V = { next: function() {
            var v = h.shift();
            return { done: v === void 0, value: v };
          } };
          return r && (V[Symbol.iterator] = function() {
            return V;
          }), V;
        }
        function Z(h) {
          this.map = {}, h instanceof Z ? h.forEach(function(V, v) {
            this.append(v, V);
          }, this) : Array.isArray(h) ? h.forEach(function(V) {
            this.append(V[0], V[1]);
          }, this) : h && Object.getOwnPropertyNames(h).forEach(function(V) {
            this.append(V, h[V]);
          }, this);
        }
        function g(h) {
          if (h.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          h.bodyUsed = !0;
        }
        function b(h) {
          return new Promise(function(V, v) {
            h.onload = function() {
              V(h.result);
            }, h.onerror = function() {
              v(h.error);
            };
          });
        }
        function S(h) {
          var V = new FileReader(), v = b(V);
          return V.readAsArrayBuffer(h), v;
        }
        function f(h) {
          if (h.slice)
            return h.slice(0);
          var V = new Uint8Array(h.byteLength);
          return V.set(new Uint8Array(h)), V.buffer;
        }
        function w() {
          return this.bodyUsed = !1, this._initBody = function(h) {
            var V;
            this._bodyInit = h, h ? typeof h == "string" ? this._bodyText = h : c && Blob.prototype.isPrototypeOf(h) ? this._bodyBlob = h : d && FormData.prototype.isPrototypeOf(h) ? this._bodyFormData = h : a && URLSearchParams.prototype.isPrototypeOf(h) ? this._bodyText = h.toString() : u && c && (V = h) && DataView.prototype.isPrototypeOf(V) ? (this._bodyArrayBuffer = f(h.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u && (ArrayBuffer.prototype.isPrototypeOf(h) || m(h)) ? this._bodyArrayBuffer = f(h) : this._bodyText = h = Object.prototype.toString.call(h) : this._bodyText = "", this.headers.get("content-type") || (typeof h == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : a && URLSearchParams.prototype.isPrototypeOf(h) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, c && (this.blob = function() {
            var h = g(this);
            if (h)
              return h;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            return this._bodyArrayBuffer ? g(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(S);
          }), this.text = function() {
            var h, V, v, C = g(this);
            if (C)
              return C;
            if (this._bodyBlob)
              return h = this._bodyBlob, V = new FileReader(), v = b(V), V.readAsText(h), v;
            if (this._bodyArrayBuffer)
              return Promise.resolve(function(G) {
                for (var R = new Uint8Array(G), U = new Array(R.length), q = 0; q < R.length; q++)
                  U[q] = String.fromCharCode(R[q]);
                return U.join("");
              }(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, d && (this.formData = function() {
            return this.text().then(L);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        Z.prototype.append = function(h, V) {
          h = I(h), V = y(V);
          var v = this.map[h];
          this.map[h] = v ? v + ", " + V : V;
        }, Z.prototype.delete = function(h) {
          delete this.map[I(h)];
        }, Z.prototype.get = function(h) {
          return h = I(h), this.has(h) ? this.map[h] : null;
        }, Z.prototype.has = function(h) {
          return this.map.hasOwnProperty(I(h));
        }, Z.prototype.set = function(h, V) {
          this.map[I(h)] = y(V);
        }, Z.prototype.forEach = function(h, V) {
          for (var v in this.map)
            this.map.hasOwnProperty(v) && h.call(V, this.map[v], v, this);
        }, Z.prototype.keys = function() {
          var h = [];
          return this.forEach(function(V, v) {
            h.push(v);
          }), W(h);
        }, Z.prototype.values = function() {
          var h = [];
          return this.forEach(function(V) {
            h.push(V);
          }), W(h);
        }, Z.prototype.entries = function() {
          var h = [];
          return this.forEach(function(V, v) {
            h.push([v, V]);
          }), W(h);
        }, r && (Z.prototype[Symbol.iterator] = Z.prototype.entries);
        var K = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function Y(h, V) {
          var v, C, G = (V = V || {}).body;
          if (h instanceof Y) {
            if (h.bodyUsed)
              throw new TypeError("Already read");
            this.url = h.url, this.credentials = h.credentials, V.headers || (this.headers = new Z(h.headers)), this.method = h.method, this.mode = h.mode, this.signal = h.signal, G || h._bodyInit == null || (G = h._bodyInit, h.bodyUsed = !0);
          } else
            this.url = String(h);
          if (this.credentials = V.credentials || this.credentials || "same-origin", !V.headers && this.headers || (this.headers = new Z(V.headers)), this.method = (v = V.method || this.method || "GET", C = v.toUpperCase(), K.indexOf(C) > -1 ? C : v), this.mode = V.mode || this.mode || null, this.signal = V.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && G)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(G);
        }
        function L(h) {
          var V = new FormData();
          return h.trim().split("&").forEach(function(v) {
            if (v) {
              var C = v.split("="), G = C.shift().replace(/\+/g, " "), R = C.join("=").replace(/\+/g, " ");
              V.append(decodeURIComponent(G), decodeURIComponent(R));
            }
          }), V;
        }
        function N(h, V) {
          V || (V = {}), this.type = "default", this.status = V.status === void 0 ? 200 : V.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in V ? V.statusText : "OK", this.headers = new Z(V.headers), this.url = V.url || "", this._initBody(h);
        }
        Y.prototype.clone = function() {
          return new Y(this, { body: this._bodyInit });
        }, w.call(Y.prototype), w.call(N.prototype), N.prototype.clone = function() {
          return new N(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new Z(this.headers), url: this.url });
        }, N.error = function() {
          var h = new N(null, { status: 0, statusText: "" });
          return h.type = "error", h;
        };
        var x = [301, 302, 303, 307, 308];
        N.redirect = function(h, V) {
          if (x.indexOf(V) === -1)
            throw new RangeError("Invalid status code");
          return new N(null, { status: V, headers: { location: h } });
        }, l.DOMException = i.DOMException;
        try {
          new l.DOMException();
        } catch (h) {
          l.DOMException = function(V, v) {
            this.message = V, this.name = v;
            var C = Error(V);
            this.stack = C.stack;
          }, l.DOMException.prototype = Object.create(Error.prototype), l.DOMException.prototype.constructor = l.DOMException;
        }
        function k(h, V) {
          return new Promise(function(v, C) {
            var G = new Y(h, V);
            if (G.signal && G.signal.aborted)
              return C(new l.DOMException("Aborted", "AbortError"));
            var R = new XMLHttpRequest();
            function U() {
              R.abort();
            }
            R.onload = function() {
              var q, ee, P = { status: R.status, statusText: R.statusText, headers: (q = R.getAllResponseHeaders() || "", ee = new Z(), q.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(Se) {
                var Ge = Se.split(":"), F = Ge.shift().trim();
                if (F) {
                  var B = Ge.join(":").trim();
                  ee.append(F, B);
                }
              }), ee) };
              P.url = "responseURL" in R ? R.responseURL : P.headers.get("X-Request-URL");
              var M = "response" in R ? R.response : R.responseText;
              v(new N(M, P));
            }, R.onerror = function() {
              C(new TypeError("Network request failed"));
            }, R.ontimeout = function() {
              C(new TypeError("Network request failed"));
            }, R.onabort = function() {
              C(new l.DOMException("Aborted", "AbortError"));
            }, R.open(G.method, G.url, !0), G.credentials === "include" ? R.withCredentials = !0 : G.credentials === "omit" && (R.withCredentials = !1), "responseType" in R && c && (R.responseType = "blob"), G.headers.forEach(function(q, ee) {
              R.setRequestHeader(ee, q);
            }), G.signal && (G.signal.addEventListener("abort", U), R.onreadystatechange = function() {
              R.readyState === 4 && G.signal.removeEventListener("abort", U);
            }), R.send(G._bodyInit === void 0 ? null : G._bodyInit);
          });
        }
        k.polyfill = !0, i.fetch || (i.fetch = k, i.Headers = Z, i.Request = Y, i.Response = N), l.Headers = Z, l.Request = Y, l.Response = N, l.fetch = k, Object.defineProperty(l, "__esModule", { value: !0 });
      }({}), s.fetch.ponyfill = !0, delete s.fetch.polyfill;
      var o = s;
      (e = o.fetch).default = o.fetch, e.fetch = o.fetch, e.Headers = o.Headers, e.Request = o.Request, e.Response = o.Response, t.exports = e;
    })(Bi, Bi.exports);
    var $t = Bi.exports;
    const ei = Ri($t), _l = vo({ __proto__: null, default: ei }, [$t]), lt = (t) => {
      let e = {};
      return t && (typeof Headers != "undefined" && t instanceof Headers || _l && $t.Headers && t instanceof $t.Headers ? e = ((i) => {
        const n = {};
        return i.forEach((s, o) => {
          n[o] = s;
        }), n;
      })(t) : Array.isArray(t) ? t.forEach(([i, n]) => {
        i && n !== void 0 && (e[i] = n);
      }) : e = t), e;
    }, Es = (t) => t.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), ql = (t) => (e) => ue(this, null, function* () {
      var i;
      const { url: n, query: s, variables: o, operationName: l, fetch: a, fetchOptions: r, middleware: c } = e, d = z({}, e.headers);
      let u, p = "";
      t === "POST" ? (u = er(s, o, l, r.jsonSerializer), typeof u == "string" && (d["Content-Type"] = "application/json")) : p = ((W) => {
        if (!Array.isArray(W.query)) {
          const b = W, S = [`query=${encodeURIComponent(Es(b.query))}`];
          return W.variables && S.push(`variables=${encodeURIComponent(b.jsonSerializer.stringify(b.variables))}`), b.operationName && S.push(`operationName=${encodeURIComponent(b.operationName)}`), S.join("&");
        }
        if (W.variables !== void 0 && !Array.isArray(W.variables))
          throw new Error("Cannot create query with given variable type, array expected");
        const Z = W, g = W.query.reduce((b, S, f) => (b.push({ query: Es(S), variables: Z.variables ? Z.jsonSerializer.stringify(Z.variables[f]) : void 0 }), b), []);
        return `query=${encodeURIComponent(Z.jsonSerializer.stringify(g))}`;
      })({ query: s, variables: o, operationName: l, jsonSerializer: (i = r.jsonSerializer) != null ? i : Ki });
      const m = z({ method: t, headers: d, body: u }, r);
      let I = n, y = m;
      if (c) {
        const W = yield Promise.resolve(c(Te(z({}, m), { url: n, operationName: l, variables: o }))), { url: Z } = W;
        I = Z, y = Fe(W, ["url"]);
      }
      return p && (I = `${I}?${p}`), yield a(I, y);
    });
    class $l {
      constructor(e, i = {}) {
        this.url = e, this.requestConfig = i, this.rawRequest = (...n) => ue(this, null, function* () {
          const [s, o, l] = n, a = ((Z, g, b) => Z.query ? Z : { query: Z, variables: g, requestHeaders: b, signal: void 0 })(s, o, l), r = this.requestConfig, { headers: c, fetch: d = ei, method: u = "POST", requestMiddleware: p, responseMiddleware: m } = r, I = Fe(r, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: y } = this;
          a.signal !== void 0 && (I.signal = a.signal);
          const { operationName: W } = zi(a.query);
          return Pi({ url: y, query: a.query, variables: a.variables, headers: z(z({}, lt(Ai(c))), lt(a.requestHeaders)), operationName: W, fetch: d, method: u, fetchOptions: I, middleware: p }).then((Z) => (m && m(Z), Z)).catch((Z) => {
            throw m && m(Z), Z;
          });
        });
      }
      request(e, ...i) {
        return ue(this, null, function* () {
          const [n, s] = i, o = ((W, Z, g) => W.document ? W : { document: W, variables: Z, requestHeaders: g, signal: void 0 })(e, n, s), l = this.requestConfig, { headers: a, fetch: r = ei, method: c = "POST", requestMiddleware: d, responseMiddleware: u } = l, p = Fe(l, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: m } = this;
          o.signal !== void 0 && (p.signal = o.signal);
          const { query: I, operationName: y } = zi(o.document);
          return Pi({ url: m, query: I, variables: o.variables, headers: z(z({}, lt(Ai(a))), lt(o.requestHeaders)), operationName: y, fetch: r, method: c, fetchOptions: p, middleware: d }).then((W) => (u && u(W), W.data)).catch((W) => {
            throw u && u(W), W;
          });
        });
      }
      batchRequests(e, i) {
        var n;
        const s = ((d, u) => d.documents ? d : { documents: d, requestHeaders: u, signal: void 0 })(e, i), o = this.requestConfig, { headers: l } = o, a = Fe(o, ["headers"]);
        s.signal !== void 0 && (a.signal = s.signal);
        const r = s.documents.map(({ document: d }) => zi(d).query), c = s.documents.map(({ variables: d }) => d);
        return Pi({ url: this.url, query: r, variables: c, headers: z(z({}, lt(Ai(l))), lt(s.requestHeaders)), operationName: void 0, fetch: (n = this.requestConfig.fetch) != null ? n : ei, method: this.requestConfig.method || "POST", fetchOptions: a, middleware: this.requestConfig.requestMiddleware }).then((d) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(d), d.data)).catch((d) => {
          throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(d), d;
        });
      }
      setHeaders(e) {
        return this.requestConfig.headers = e, this;
      }
      setHeader(e, i) {
        const { headers: n } = this.requestConfig;
        return n ? n[e] = i : this.requestConfig.headers = { [e]: i }, this;
      }
      setEndpoint(e) {
        return this.url = e, this;
      }
    }
    const Pi = (t) => ue(this, null, function* () {
      var e, i;
      const { query: n, variables: s, fetchOptions: o } = t, l = ql(((e = t.method) != null ? e : "post").toUpperCase()), a = Array.isArray(t.query), r = yield l(t), c = yield tr(r, (i = o.jsonSerializer) != null ? i : Ki), d = Array.isArray(c) ? !c.some(({ data: p }) => !p) : !!c.data, u = Array.isArray(c) || !c.errors || Array.isArray(c.errors) && !c.errors.length || o.errorPolicy === "all" || o.errorPolicy === "ignore";
      if (r.ok && u && d) {
        const p = c, m = Fe(p, ["errors"]), I = o.errorPolicy === "ignore" ? m : c;
        return Te(z({}, a ? { data: I } : I), { headers: r.headers, status: r.status });
      }
      throw new ot(Te(z({}, typeof c == "string" ? { error: c } : c), { status: r.status, headers: r.headers }), { query: n, variables: s });
    }), er = (t, e, i, n) => {
      const s = n != null ? n : Ki;
      if (!Array.isArray(t))
        return s.stringify({ query: t, variables: e, operationName: i });
      if (e !== void 0 && !Array.isArray(e))
        throw new Error("Cannot create request body with given variable type, array expected");
      const o = t.reduce((l, a, r) => (l.push({ query: a, variables: e ? e[r] : void 0 }), l), []);
      return s.stringify(o);
    }, tr = (t, e) => ue(this, null, function* () {
      let i;
      return t.headers.forEach((n, s) => {
        s.toLowerCase() === "content-type" && (i = n);
      }), i && (i.toLowerCase().startsWith("application/json") || i.toLowerCase().startsWith("application/graphql+json") || i.toLowerCase().startsWith("application/graphql-response+json")) ? e.parse(yield t.text()) : t.text();
    }), Ai = (t) => typeof t == "function" ? t() : t;
    var ti = function() {
      return ti = Object.assign || function(t) {
        for (var e, i = 1, n = arguments.length; i < n; i++)
          for (var s in e = arguments[i])
            Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
        return t;
      }, ti.apply(this, arguments);
    }, ii = /* @__PURE__ */ new Map(), Di = /* @__PURE__ */ new Map(), Ms = !0, ni = !1;
    function Os(t) {
      return t.replace(/[\s,]+/g, " ").trim();
    }
    function ir(t) {
      var e = /* @__PURE__ */ new Set(), i = [];
      return t.definitions.forEach(function(n) {
        if (n.kind === "FragmentDefinition") {
          var s = n.name.value, o = Os((a = n.loc).source.body.substring(a.start, a.end)), l = Di.get(s);
          l && !l.has(o) ? Ms && console.warn("Warning: fragment with name " + s + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : l || Di.set(s, l = /* @__PURE__ */ new Set()), l.add(o), e.has(o) || (e.add(o), i.push(n));
        } else
          i.push(n);
        var a;
      }), ti(ti({}, t), { definitions: i });
    }
    function nr(t) {
      var e = Os(t);
      if (!ii.has(e)) {
        var i = Ks(t, { experimentalFragmentVariables: ni, allowLegacyFragmentVariables: ni });
        if (!i || i.kind !== "Document")
          throw new Error("Not a valid GraphQL document.");
        ii.set(e, function(n) {
          var s = new Set(n.definitions);
          s.forEach(function(l) {
            l.loc && delete l.loc, Object.keys(l).forEach(function(a) {
              var r = l[a];
              r && typeof r == "object" && s.add(r);
            });
          });
          var o = n.loc;
          return o && (delete o.startToken, delete o.endToken), n;
        }(ir(i)));
      }
      return ii.get(e);
    }
    function Xe(t) {
      for (var e = [], i = 1; i < arguments.length; i++)
        e[i - 1] = arguments[i];
      typeof t == "string" && (t = [t]);
      var n = t[0];
      return e.forEach(function(s, o) {
        s && s.kind === "Document" ? n += s.loc.source.body : n += s, n += t[o + 1];
      }), nr(n);
    }
    var Wt, sr = Xe, or = function() {
      ii.clear(), Di.clear();
    }, lr = function() {
      Ms = !1;
    }, rr = function() {
      ni = !0;
    }, ar = function() {
      ni = !1;
    };
    (Wt = Xe || (Xe = {})).gql = sr, Wt.resetCaches = or, Wt.disableFragmentWarnings = lr, Wt.enableExperimentalFragmentVariables = rr, Wt.disableExperimentalFragmentVariables = ar, Xe.default = Xe;
    const zs = Xe`
	mutation PushPayload(
		$session_secure_id: String!
		$payload_id: ID!
		$events: ReplayEventsInput!
		$messages: String!
		$resources: String!
		$web_socket_events: String!
		$errors: [ErrorObjectInput]!
		$is_beacon: Boolean
		$has_session_unloaded: Boolean
		$highlight_logs: String
	) {
		pushPayload(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			events: $events
			messages: $messages
			resources: $resources
			web_socket_events: $web_socket_events
			errors: $errors
			is_beacon: $is_beacon
			has_session_unloaded: $has_session_unloaded
			highlight_logs: $highlight_logs
		)
	}
`, cr = Xe`
	mutation PushPayloadCompressed(
		$session_secure_id: String!
		$payload_id: ID!
		$data: String!
	) {
		pushPayloadCompressed(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			data: $data
		)
	}
`, dr = Xe`
	mutation identifySession(
		$session_secure_id: String!
		$user_identifier: String!
		$user_object: Any
	) {
		identifySession(
			session_secure_id: $session_secure_id
			user_identifier: $user_identifier
			user_object: $user_object
		)
	}
`, ur = Xe`
	mutation addSessionProperties(
		$session_secure_id: String!
		$properties_object: Any
	) {
		addSessionProperties(
			session_secure_id: $session_secure_id
			properties_object: $properties_object
		)
	}
`, pr = Xe`
	mutation pushMetrics($metrics: [MetricInput]!) {
		pushMetrics(metrics: $metrics)
	}
`, hr = Xe`
	mutation addSessionFeedback(
		$session_secure_id: String!
		$user_name: String
		$user_email: String
		$verbatim: String!
		$timestamp: Timestamp!
	) {
		addSessionFeedback(
			session_secure_id: $session_secure_id
			user_name: $user_name
			user_email: $user_email
			verbatim: $verbatim
			timestamp: $timestamp
		)
	}
`, mr = Xe`
	mutation initializeSession(
		$session_secure_id: String!
		$organization_verbose_id: String!
		$enable_strict_privacy: Boolean!
		$privacy_setting: String!
		$enable_recording_network_contents: Boolean!
		$clientVersion: String!
		$firstloadVersion: String!
		$clientConfig: String!
		$environment: String!
		$id: String!
		$appVersion: String
		$serviceName: String!
		$client_id: String!
		$network_recording_domains: [String!]
		$disable_session_recording: Boolean
	) {
		initializeSession(
			session_secure_id: $session_secure_id
			organization_verbose_id: $organization_verbose_id
			enable_strict_privacy: $enable_strict_privacy
			enable_recording_network_contents: $enable_recording_network_contents
			clientVersion: $clientVersion
			firstloadVersion: $firstloadVersion
			clientConfig: $clientConfig
			environment: $environment
			appVersion: $appVersion
			serviceName: $serviceName
			fingerprint: $id
			client_id: $client_id
			network_recording_domains: $network_recording_domains
			disable_session_recording: $disable_session_recording
			privacy_setting: $privacy_setting
		) {
			secure_id
			project_id
		}
	}
`, br = Xe`
	query Ignore($id: ID!) {
		ignore(id: $id)
	}
`, Zr = (t, e, i, n) => t(), yr = (t) => {
      t(window.location.href);
      var e = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function(o) {
        setTimeout(() => {
          var l, a;
          try {
            a = JSON.parse((l = o == null ? void 0 : o.toString()) != null ? l : "");
          } catch (r) {
            return;
          }
          a.type !== "track" && a.type !== "identify" || Qi(a) && t(a);
        }, 100), e.call(this, o);
      };
      const i = (o) => {
        if (o.key === "ajs_user_id" || o.key === "ajs_anonymous_id" || o.key === "ajs_user_traits") {
          const { userId: l, userTraits: a } = Bs();
          if (l) {
            let r = {};
            a && (r = JSON.parse(a));
            const c = { type: "identify", userId: l.toString(), traits: r };
            Qi(c) && t(c);
          }
        }
      }, { userId: n, userTraits: s } = Bs();
      if (n) {
        let o = {};
        s && (o = JSON.parse(s));
        const l = { type: "identify", userId: n.toString(), traits: o };
        Qi(l) && t(l);
      }
      return window.addEventListener("storage", i), ml(({ keyName: o }) => {
        i({ key: o });
      }), () => {
        window.removeEventListener("storage", i), XMLHttpRequest.prototype.send = e;
      };
    }, Bs = () => ({ userId: Ie("ajs_user_id"), userTraits: Ie("ajs_user_traits"), anonymousId: Ie("ajs_anonymous_id") }), Qi = (t) => {
      if (!t)
        return !1;
      let e = "";
      try {
        e = JSON.stringify(t);
      } catch (s) {
        return !1;
      }
      const i = gr(e), n = Ie(re.SEGMENT_LAST_SENT_HASH_KEY);
      return (n === void 0 || i !== n) && (ve(re.SEGMENT_LAST_SENT_HASH_KEY, i), !0);
    }, gr = (t) => {
      var e = 0, i = t.length, n = 0;
      if (i > 0)
        for (; n < i; )
          e = (e << 5) - e + t.charCodeAt(n++) | 0;
      return e.toString();
    };
    function Ps(t, e) {
      return Ir(t);
    }
    function As(t) {
      if (t.id.length)
        return `#${t.id}`;
      if (t.classList.length) {
        let e = [];
        for (const i of t.classList)
          e.push(`.${i}`);
        return `${t.nodeName.toLowerCase()}${e.join(",")}`;
      }
      return t.nodeName.toLowerCase();
    }
    const Ir = (t) => {
      let e = "";
      const i = t.getAttribute("class"), n = t.getAttribute("id");
      return n && (e = e.concat(Ds(n, "#"))), i && (e = e.concat(Ds(i, "."))), e === "" && (e = e.concat(t.tagName.toLowerCase())), e;
    }, Ds = (t, e) => `${e}${t.trim().split(" ").join(e)}`, Sr = (t, e) => {
      const i = function(a) {
        typeof a != "string" && (a = "");
        const r = (a = a.replace(/\s/g, "")).split(",");
        let c = r.lastIndexOf("");
        for (; c >= 0; )
          r[c - 1] += ",", r.splice(c, 1), c = r.lastIndexOf("");
        return r;
      }(t);
      let n = [];
      for (let a = 0; a < i.length; a++) {
        let r = i[a].split("+");
        n = [], r.length > 1 && (n = Gr(js, r)), r = r[r.length - 1], r = r === "*" ? "*" : Xr(r), r in we || (we[r] = []), we[r].push({ mods: n, shortcut: i[a], key: i[a], method: e, keyup: !1, keydown: !0, scope: "all", splitKey: "+" });
      }
      var s, o, l;
      s = document, o = "keydown", l = (a) => {
        (function(r) {
          const c = we["*"];
          let d = r.keyCode || r.which || r.charCode;
          if (d !== 93 && d !== 224 || (d = 91), Ze.indexOf(d) === -1 && d !== 229 && Ze.push(d), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((u) => {
            const p = Qs[u];
            r[u] && Ze.indexOf(p) === -1 ? Ze.push(p) : !r[u] && Ze.indexOf(p) > -1 ? Ze.splice(Ze.indexOf(p), 1) : u === "metaKey" && r[u] && Ze.length === 3 && (r.ctrlKey || r.shiftKey || r.altKey || (Ze = Ze.slice(Ze.indexOf(p))));
          }), !(d in ye) || (ye[d] = !0, c)) {
            for (const u in ye)
              Object.prototype.hasOwnProperty.call(ye, u) && (ye[u] = r[Qs[u]]);
            if (r.getModifierState && (!r.altKey || r.ctrlKey) && r.getModifierState("AltGraph") && (Ze.indexOf(17) === -1 && Ze.push(17), Ze.indexOf(18) === -1 && Ze.push(18), ye[17] = !0, ye[18] = !0), d in we) {
              for (let u = 0; u < we[d].length; u++)
                if ((r.type === "keydown" && we[d][u].keydown || r.type === "keyup" && we[d][u].keyup) && we[d][u].key) {
                  const p = we[d][u];
                  Wr(r, p, "all");
                }
            }
          }
        })(a);
      }, s.addEventListener ? s.addEventListener(o, l, !1) : s.attachEvent && s.attachEvent(`on${o}`, () => {
        l(window.event);
      });
    };
    let Ze = [];
    const we = {}, ji = typeof navigator != "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > 0, Vr = { backspace: 8, tab: 9, clear: 12, enter: 13, return: 13, esc: 27, escape: 27, space: 32, left: 37, up: 38, right: 39, down: 40, del: 46, delete: 46, ins: 45, insert: 45, home: 36, end: 35, pageup: 33, pagedown: 34, capslock: 20, num_0: 96, num_1: 97, num_2: 98, num_3: 99, num_4: 100, num_5: 101, num_6: 102, num_7: 103, num_8: 104, num_9: 105, num_multiply: 106, num_add: 107, num_enter: 108, num_subtract: 109, num_decimal: 110, num_divide: 111, "⇪": 20, ",": 188, ".": 190, "/": 191, "`": 192, "-": ji ? 173 : 189, "=": ji ? 61 : 187, ";": ji ? 59 : 186, "'": 222, "[": 219, "]": 221, "\\": 220 }, Qs = { 16: "shiftKey", 18: "altKey", 17: "ctrlKey", 91: "metaKey", shiftKey: 16, ctrlKey: 17, altKey: 18, metaKey: 91 }, ye = { 16: !1, 18: !1, 17: !1, 91: !1 }, js = { "⇧": 16, shift: 16, "⌥": 18, alt: 18, option: 18, "⌃": 17, ctrl: 17, control: 17, "⌘": 91, cmd: 91, command: 91 }, Xr = (t) => Vr[t.toLowerCase()] || js[t.toLowerCase()] || t.toUpperCase().charCodeAt(0);
    function Gr(t, e) {
      const i = e.slice(0, e.length - 1);
      for (let n = 0; n < i.length; n++)
        i[n] = t[i[n].toLowerCase()];
      return i;
    }
    function Wr(t, e, i) {
      let n;
      if (e.scope === i || e.scope === "all") {
        n = e.mods.length > 0;
        for (const s in ye)
          Object.prototype.hasOwnProperty.call(ye, s) && (!ye[s] && e.mods.indexOf(+s) > -1 || ye[s] && e.mods.indexOf(+s) === -1) && (n = !1);
        (e.mods.length !== 0 || ye[16] || ye[18] || ye[17] || ye[91]) && !n && e.shortcut !== "*" || e.method(t, e) === !1 && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation && t.stopPropagation(), t.cancelBubble && (t.cancelBubble = !0));
      }
    }
    var Me, ft, _s, si, _i, qs = -1, De = function(t) {
      addEventListener("pageshow", function(e) {
        e.persisted && (qs = e.timeStamp, t(e));
      }, !0);
    }, qi = function() {
      return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    }, oi = function() {
      var t = qi();
      return t && t.activationStart || 0;
    }, fe = function(t, e) {
      var i = qi(), n = "navigate";
      return qs >= 0 ? n = "back-forward-cache" : i && (document.prerendering || oi() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : i.type && (n = i.type.replace(/_/g, "-"))), { name: t, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
    }, rt = function(t, e, i) {
      try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
          var n = new PerformanceObserver(function(s) {
            Promise.resolve().then(function() {
              e(s.getEntries());
            });
          });
          return n.observe(Object.assign({ type: t, buffered: !0 }, i || {})), n;
        }
      } catch (s) {
      }
    }, Ce = function(t, e, i, n) {
      var s, o;
      return function(l) {
        var a, r;
        e.value >= 0 && (l || n) && ((o = e.value - (s || 0)) || s === void 0) && (s = e.value, e.delta = o, e.rating = (a = e.value) > (r = i)[1] ? "poor" : a > r[0] ? "needs-improvement" : "good", t(e));
      };
    }, $i = function(t) {
      requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
          return t();
        });
      });
    }, li = function(t) {
      var e = function(i) {
        i.type !== "pagehide" && document.visibilityState !== "hidden" || t(i);
      };
      addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0);
    }, en = function(t) {
      var e = !1;
      return function(i) {
        e || (t(i), e = !0);
      };
    }, at = -1, $s = function() {
      return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
    }, ri = function(t) {
      document.visibilityState === "hidden" && at > -1 && (at = t.type === "visibilitychange" ? t.timeStamp : 0, fr());
    }, eo = function() {
      addEventListener("visibilitychange", ri, !0), addEventListener("prerenderingchange", ri, !0);
    }, fr = function() {
      removeEventListener("visibilitychange", ri, !0), removeEventListener("prerenderingchange", ri, !0);
    }, tn = function() {
      return at < 0 && (at = $s(), eo(), De(function() {
        setTimeout(function() {
          at = $s(), eo();
        }, 0);
      })), { get firstHiddenTime() {
        return at;
      } };
    }, Ct = function(t) {
      document.prerendering ? addEventListener("prerenderingchange", function() {
        return t();
      }, !0) : t();
    }, to = [1800, 3e3], io = function(t, e) {
      e = e || {}, Ct(function() {
        var i, n = tn(), s = fe("FCP"), o = rt("paint", function(l) {
          l.forEach(function(a) {
            a.name === "first-contentful-paint" && (o.disconnect(), a.startTime < n.firstHiddenTime && (s.value = Math.max(a.startTime - oi(), 0), s.entries.push(a), i(!0)));
          });
        });
        o && (i = Ce(t, s, to, e.reportAllChanges), De(function(l) {
          s = fe("FCP"), i = Ce(t, s, to, e.reportAllChanges), $i(function() {
            s.value = performance.now() - l.timeStamp, i(!0);
          });
        }));
      });
    }, no = [0.1, 0.25], Rt = { passive: !0, capture: !0 }, Cr = /* @__PURE__ */ new Date(), so = function(t, e) {
      Me || (Me = e, ft = t, _s = /* @__PURE__ */ new Date(), lo(removeEventListener), oo());
    }, oo = function() {
      if (ft >= 0 && ft < _s - Cr) {
        var t = { entryType: "first-input", name: Me.type, target: Me.target, cancelable: Me.cancelable, startTime: Me.timeStamp, processingStart: Me.timeStamp + ft };
        si.forEach(function(e) {
          e(t);
        }), si = [];
      }
    }, Rr = function(t) {
      if (t.cancelable) {
        var e = (t.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - t.timeStamp;
        t.type == "pointerdown" ? (i = e, n = t, s = function() {
          so(i, n), l();
        }, o = function() {
          l();
        }, l = function() {
          removeEventListener("pointerup", s, Rt), removeEventListener("pointercancel", o, Rt);
        }, addEventListener("pointerup", s, Rt), addEventListener("pointercancel", o, Rt)) : so(e, t);
      }
      var i, n, s, o, l;
    }, lo = function(t) {
      ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(e) {
        return t(e, Rr, Rt);
      });
    }, ro = [100, 300], ao = 0, nn = 1 / 0, ai = 0, vr = function(t) {
      t.forEach(function(e) {
        e.interactionId && (nn = Math.min(nn, e.interactionId), ai = Math.max(ai, e.interactionId), ao = ai ? (ai - nn) / 7 + 1 : 0);
      });
    }, co = function() {
      return _i ? ao : performance.interactionCount || 0;
    }, uo = [200, 500], po = 0, ho = function() {
      return co() - po;
    }, Le = [], sn = {}, mo = function(t) {
      var e = Le[Le.length - 1], i = sn[t.interactionId];
      if (i || Le.length < 10 || t.duration > e.latency) {
        if (i)
          i.entries.push(t), i.latency = Math.max(i.latency, t.duration);
        else {
          var n = { id: t.interactionId, latency: t.duration, entries: [t] };
          sn[n.id] = n, Le.push(n);
        }
        Le.sort(function(s, o) {
          return o.latency - s.latency;
        }), Le.splice(10).forEach(function(s) {
          delete sn[s.id];
        });
      }
    }, kr = function(t, e) {
      e = e || {}, Ct(function() {
        var i;
        "interactionCount" in performance || _i || (_i = rt("event", vr, { type: "event", buffered: !0, durationThreshold: 0 }));
        var n, s = fe("INP"), o = function(a) {
          a.forEach(function(d) {
            d.interactionId && mo(d), d.entryType === "first-input" && !Le.some(function(u) {
              return u.entries.some(function(p) {
                return d.duration === p.duration && d.startTime === p.startTime;
              });
            }) && mo(d);
          });
          var r, c = (r = Math.min(Le.length - 1, Math.floor(ho() / 50)), Le[r]);
          c && c.latency !== s.value && (s.value = c.latency, s.entries = c.entries, n());
        }, l = rt("event", o, { durationThreshold: (i = e.durationThreshold) !== null && i !== void 0 ? i : 40 });
        n = Ce(t, s, uo, e.reportAllChanges), l && ("interactionId" in PerformanceEventTiming.prototype && l.observe({ type: "first-input", buffered: !0 }), li(function() {
          o(l.takeRecords()), s.value < 0 && ho() > 0 && (s.value = 0, s.entries = []), n(!0);
        }), De(function() {
          Le = [], po = co(), s = fe("INP"), n = Ce(t, s, uo, e.reportAllChanges);
        }));
      });
    }, bo = [2500, 4e3], on = {}, Zo = [800, 1800], Tr = function t(e) {
      document.prerendering ? Ct(function() {
        return t(e);
      }) : document.readyState !== "complete" ? addEventListener("load", function() {
        return t(e);
      }, !0) : setTimeout(e, 0);
    }, Nr = function(t, e) {
      e = e || {};
      var i = fe("TTFB"), n = Ce(t, i, Zo, e.reportAllChanges);
      Tr(function() {
        var s = qi();
        if (s) {
          var o = s.responseStart;
          if (o <= 0 || o > performance.now())
            return;
          i.value = Math.max(o - oi(), 0), i.entries = [s], n(!0), De(function() {
            i = fe("TTFB", 0), (n = Ce(t, i, Zo, e.reportAllChanges))(!0);
          });
        }
      });
    };
    const wr = (t) => {
      var e, i, n, s;
      return e = t, i = i || {}, io(en(function() {
        var o, l = fe("CLS", 0), a = 0, r = [], c = function(u) {
          u.forEach(function(p) {
            if (!p.hadRecentInput) {
              var m = r[0], I = r[r.length - 1];
              a && p.startTime - I.startTime < 1e3 && p.startTime - m.startTime < 5e3 ? (a += p.value, r.push(p)) : (a = p.value, r = [p]);
            }
          }), a > l.value && (l.value = a, l.entries = r, o());
        }, d = rt("layout-shift", c);
        d && (o = Ce(e, l, no, i.reportAllChanges), li(function() {
          c(d.takeRecords()), o(!0);
        }), De(function() {
          a = 0, l = fe("CLS", 0), o = Ce(e, l, no, i.reportAllChanges), $i(function() {
            return o();
          });
        }), setTimeout(o, 0));
      })), io(t), n = t, s = s || {}, Ct(function() {
        var o, l = tn(), a = fe("FID"), r = function(u) {
          u.startTime < l.firstHiddenTime && (a.value = u.processingStart - u.startTime, a.entries.push(u), o(!0));
        }, c = function(u) {
          u.forEach(r);
        }, d = rt("first-input", c);
        o = Ce(n, a, ro, s.reportAllChanges), d && li(en(function() {
          c(d.takeRecords()), d.disconnect();
        })), d && De(function() {
          var u;
          a = fe("FID"), o = Ce(n, a, ro, s.reportAllChanges), si = [], ft = -1, Me = null, lo(addEventListener), u = r, si.push(u), oo();
        });
      }), function(o, l) {
        l = l || {}, Ct(function() {
          var a, r = tn(), c = fe("LCP"), d = function(m) {
            var I = m[m.length - 1];
            I && I.startTime < r.firstHiddenTime && (c.value = Math.max(I.startTime - oi(), 0), c.entries = [I], a());
          }, u = rt("largest-contentful-paint", d);
          if (u) {
            a = Ce(o, c, bo, l.reportAllChanges);
            var p = en(function() {
              on[c.id] || (d(u.takeRecords()), u.disconnect(), on[c.id] = !0, a(!0));
            });
            ["keydown", "click"].forEach(function(m) {
              addEventListener(m, function() {
                return setTimeout(p, 0);
              }, !0);
            }), li(p), De(function(m) {
              c = fe("LCP"), a = Ce(o, c, bo, l.reportAllChanges), $i(function() {
                c.value = performance.now() - m.timeStamp, on[c.id] = !0, a(!0);
              });
            });
          }
        });
      }(t), Nr(t), kr(t), () => {
      };
    }, ln = (t) => t / Math.pow(1e3, 2), Lr = (t) => 1024 * t, yo = typeof window != "undefined" && "performance" in window && "memory" in performance ? performance : { memory: {} }, vt = "highlightLogs", xr = (t) => {
      if (!t)
        return;
      let e = Ie(vt) || "";
      e && (e.startsWith(t) ? (e = e.slice(t.length), ve(vt, e)) : ((i) => {
        let n = Ie(vt) || "";
        n = n + "[" + (/* @__PURE__ */ new Date()).getTime() + "] " + i + `
`, ve(vt, n);
      })("Unable to clear logs " + t.replace(`
`, " ") + " from " + e.replace(`
`, " ")));
    }, ci = () => {
      var t;
      const e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var i = "";
      const n = typeof window != "undefined" && ((t = window.crypto) == null ? void 0 : t.getRandomValues), s = new Uint32Array(28);
      n && window.crypto.getRandomValues(s);
      for (let o = 0; o < 28; o++)
        i += e.charAt(n ? s[o] % 62 : Math.floor(62 * Math.random()));
      return i;
    }, go = "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", Io = typeof window != "undefined" && window.Blob && new Blob([((t) => Uint8Array.from(atob(t), (e) => e.charCodeAt(0)))(go)], { type: "text/javascript;charset=utf-8" });
    function Jr(t) {
      let e;
      try {
        if (e = Io && (window.URL || window.webkitURL).createObjectURL(Io), !e)
          throw "";
        const i = new Worker(e, { name: t == null ? void 0 : t.name });
        return i.addEventListener("error", () => {
          (window.URL || window.webkitURL).revokeObjectURL(e);
        }), i;
      } catch (i) {
        return new Worker("data:text/javascript;base64," + go, { name: t == null ? void 0 : t.name });
      } finally {
        e && (window.URL || window.webkitURL).revokeObjectURL(e);
      }
    }
    var So = ((t) => (t.BillingQuotaExceeded = "BillingQuotaExceeded", t))(So || {});
    const Kr = [So.BillingQuotaExceeded.toString()], Yr = (t) => {
      const e = (i, n, s, o, l = 0) => ue(this, null, function* () {
        try {
          return yield i();
        } catch (a) {
          if (a instanceof ot && !((r) => {
            var c;
            return ((c = r.response.errors) == null ? void 0 : c.find((d) => Kr.includes(d.message))) === void 0;
          })(a))
            throw a;
          if (l < 10)
            return yield new Promise((r) => setTimeout(r, 1e3 + 500 * Math.pow(2, l))), yield e(i, n, s, o, l + 1);
          throw console.error(`highlight.io: [${t || t}] data request failed after ${l} retries`), a;
        }
      });
      return e;
    };
    var Ye = ((t) => (t[t.Initialize = 0] = "Initialize", t[t.AsyncEvents = 1] = "AsyncEvents", t[t.Identify = 2] = "Identify", t[t.Properties = 3] = "Properties", t[t.Metrics = 4] = "Metrics", t[t.Feedback = 5] = "Feedback", t[t.CustomEvent = 6] = "CustomEvent", t))(Ye || {});
    class Ur {
      constructor(e, i) {
        T(this, "debug"), T(this, "name"), this.debug = e, this.name = i;
      }
      log(...e) {
        if (this.debug) {
          let i = `[${Date.now()}]`;
          this.name && (i += ` - ${this.name}`), console.log.apply(console, [i, ...e]);
        }
      }
    }
    const Fr = () => ue(this, null, function* () {
      const t = [];
      for (let e = 0; e < 30; e++)
        t.push(yield new Promise((i) => requestAnimationFrame((n) => requestAnimationFrame((s) => i(s - n)))));
      return t.reduce((e, i) => e + i, 0) / t.length;
    }), Vo = "iframe parent ready", Xo = "iframe ok", kt = (t, e) => {
      console.warn(`Highlight Warning: (${t}): `, { output: e });
    }, Go = "app.highlight.run";
    class rn {
      constructor(e, i) {
        var n, s, o, l, a, r;
        T(this, "options"), T(this, "isRunningOnHighlight"), T(this, "organizationID"), T(this, "graphqlSDK"), T(this, "events"), T(this, "sessionData"), T(this, "ready"), T(this, "manualStopped"), T(this, "state"), T(this, "logger"), T(this, "enableSegmentIntegration"), T(this, "privacySetting"), T(this, "enableCanvasRecording"), T(this, "enablePerformanceRecording"), T(this, "samplingStrategy"), T(this, "inlineImages"), T(this, "inlineStylesheet"), T(this, "debugOptions"), T(this, "listeners"), T(this, "firstloadVersion"), T(this, "environment"), T(this, "sessionShortcut"), T(this, "appVersion"), T(this, "serviceName"), T(this, "_worker"), T(this, "_optionsInternal"), T(this, "_backendUrl"), T(this, "_recordingStartTime"), T(this, "_isOnLocalHost"), T(this, "_onToggleFeedbackFormVisibility"), T(this, "_firstLoadListeners"), T(this, "_isCrossOriginIframe"), T(this, "_eventBytesSinceSnapshot"), T(this, "_lastSnapshotTime"), T(this, "_lastVisibilityChangeTime"), T(this, "pushPayloadTimerId"), T(this, "hasSessionUnloaded"), T(this, "hasPushedData"), T(this, "reloaded"), T(this, "_hasPreviouslyInitialized"), T(this, "_payloadId"), T(this, "_recordStop"), e.sessionSecureID || (e.sessionSecureID = ci()), this.options = e, typeof ((n = this.options) == null ? void 0 : n.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (o = (s = this.options) == null ? void 0 : s.debug) != null ? o : {}, this.logger = new Ur(this.debugOptions.clientInteractions), e.storageMode && (this.logger.log(`initializing in ${e.storageMode} session mode`), r = e.storageMode, Ti = r), this._worker = new Jr(), this._worker.onmessage = (d) => {
          var u, p;
          ((u = d.data.response) == null ? void 0 : u.type) === Ye.AsyncEvents ? (this._eventBytesSinceSnapshot += d.data.response.eventsSize, this.logger.log(`Web worker sent payloadID ${d.data.response.id} size ${d.data.response.eventsSize} bytes, compression ratio ${d.data.response.eventsSize / d.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`)) : ((p = d.data.response) == null ? void 0 : p.type) === Ye.CustomEvent && this.addCustomEvent(d.data.response.tag, d.data.response.payload);
        };
        let c = bs();
        if (this.reloaded = !1, !((l = this.sessionData) != null && l.sessionSecureID) && (c == null ? void 0 : c.sessionSecureID))
          this.sessionData = c, this.options.sessionSecureID = c.sessionSecureID, this.reloaded = !0, this.logger.log(`Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`);
        else {
          for (const d of Object.values(re))
            wi(d);
          this.sessionData = { sessionSecureID: this.options.sessionSecureID, projectID: 0, sessionStartTime: Date.now() };
        }
        this._hasPreviouslyInitialized = !1, this._firstLoadListeners = i || new Ke(this.options);
        try {
          window.parent.document && (this._isCrossOriginIframe = !1);
        } catch (d) {
          this._isCrossOriginIframe = (a = this.options.recordCrossOriginIframe) == null || a;
        }
        this._initMembers(this.options);
      }
      static create(e) {
        return new rn(e);
      }
      _reset(e) {
        return ue(this, arguments, function* ({ forceNew: i }) {
          let n, s;
          if (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), !i)
            try {
              n = Ie(re.USER_IDENTIFIER);
              const o = Ie(re.USER_OBJECT);
              o && (s = JSON.parse(o));
            } catch (o) {
            }
          for (const o of Object.values(re))
            wi(o);
          this.sessionData.sessionSecureID = ci(), this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._payloadId = 0, this.stopRecording(), this._firstLoadListeners = new Ke(this.options), yield this.initialize(), n && s && this.identify(n, s);
        });
      }
      _initMembers(e) {
        var i, n, s, o, l, a, r, c, d, u, p, m;
        this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!e.enableSegmentIntegration, this.privacySetting = (i = e.privacySetting) != null ? i : "default", this.enableCanvasRecording = (n = e.enableCanvasRecording) != null && n, this.enablePerformanceRecording = (s = e.enablePerformanceRecording) == null || s, this.inlineImages = (o = e.inlineImages) != null ? o : this._isOnLocalHost, this.inlineStylesheet = (l = e.inlineStylesheet) == null || l, this.samplingStrategy = z({ canvasFactor: 0.5, canvasMaxSnapshotDimension: 360, canvasClearWebGLBuffer: !0 }, (a = e.samplingStrategy) != null ? a : { canvas: 2 }), this._backendUrl = (r = e == null ? void 0 : e.backendUrl) != null ? r : "https://pub.highlight.io", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
        const I = new $l(`${this._backendUrl}`, { headers: {} });
        this.graphqlSDK = /* @__PURE__ */ function(Z, g = Zr) {
          return { PushPayload: (b, S) => g((f) => Z.request(zs, b, z(z({}, S), f)), "PushPayload", "mutation", b), PushPayloadCompressed: (b, S) => g((f) => Z.request(cr, b, z(z({}, S), f)), "PushPayloadCompressed", "mutation", b), identifySession: (b, S) => g((f) => Z.request(dr, b, z(z({}, S), f)), "identifySession", "mutation", b), addSessionProperties: (b, S) => g((f) => Z.request(ur, b, z(z({}, S), f)), "addSessionProperties", "mutation", b), pushMetrics: (b, S) => g((f) => Z.request(pr, b, z(z({}, S), f)), "pushMetrics", "mutation", b), addSessionFeedback: (b, S) => g((f) => Z.request(hr, b, z(z({}, S), f)), "addSessionFeedback", "mutation", b), initializeSession: (b, S) => g((f) => Z.request(mr, b, z(z({}, S), f)), "initializeSession", "mutation", b), Ignore: (b, S) => g((f) => Z.request(br, b, z(z({}, S), f)), "Ignore", "query", b) };
        }(I, Yr(((c = this.sessionData) == null ? void 0 : c.sessionSecureID) || ((d = this.options) == null ? void 0 : d.sessionSecureID))), this.environment = (u = e.environment) != null ? u : "production", this.appVersion = e.appVersion, this.serviceName = (p = e.serviceName) != null ? p : "", typeof e.organizationID == "string" ? this.organizationID = e.organizationID : this.organizationID = e.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = e.firstloadVersion || "unknown", this.sessionShortcut = e.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
        };
        const y = e, W = Fe(y, ["firstloadVersion"]);
        this._optionsInternal = W, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
          window.Intercom("update", { highlightSessionURL: this.getCurrentSessionURLWithTimestamp() }), this.addProperties({ event: "Intercom onShow" });
        }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this._payloadId = (m = Number(Ie(re.PAYLOAD_ID))) != null ? m : 1, ve(re.PAYLOAD_ID, this._payloadId.toString());
      }
      identify(e, i = {}, n) {
        e && e !== "" ? (this.sessionData.userIdentifier = e.toString(), this.sessionData.userObject = i, ve(re.USER_IDENTIFIER, e.toString()), ve(re.USER_OBJECT, JSON.stringify(i)), this._worker.postMessage({ message: { type: Ye.Identify, userIdentifier: e, userObject: i, source: n } })) : console.warn("Highlight's identify() call was passed an empty identifier.", { user_identifier: e, user_object: i });
      }
      pushCustomError(e, i) {
        return this.consumeCustomError(new Error(e), void 0, i);
      }
      consumeCustomError(e, i, n) {
        let s = {};
        if (n)
          try {
            s = z(z({}, JSON.parse(n)), s);
          } catch (o) {
          }
        return this.consumeError(e, { message: i, payload: s });
      }
      consumeError(e, { message: i, payload: n, source: s, type: o }) {
        var l, a, r, c;
        e.cause && (n = Te(z({}, n), { "exception.cause": e.cause }));
        let d = i ? i + ":" + e.message : e.message;
        o === "React.ErrorBoundary" && (d = "ErrorBoundary: " + d);
        const u = St.parse(e);
        this._firstLoadListeners.errors.push({ event: d, type: o != null ? o : "custom", url: window.location.href, source: s != null ? s : "", lineNumber: (l = u[0]) != null && l.lineNumber ? (a = u[0]) == null ? void 0 : a.lineNumber : 0, columnNumber: (r = u[0]) != null && r.columnNumber ? (c = u[0]) == null ? void 0 : c.columnNumber : 0, stackTrace: u, timestamp: (/* @__PURE__ */ new Date()).toISOString(), payload: JSON.stringify(n) });
      }
      addProperties(e = {}, i) {
        const n = z({}, e);
        Object.entries(n).forEach(([s, o]) => {
          try {
            structuredClone(o);
          } catch (l) {
            delete n[s];
          }
        }), this._worker.postMessage({ message: { type: Ye.Properties, propertiesObject: n, propertyType: i } });
      }
      initialize(e) {
        return ue(this, null, function* () {
          var i, n, s, o, l, a;
          if (this.logger.log("Initializing...", e, this.sessionData, this.options), (navigator == null ? void 0 : navigator.webdriver) && !window.Cypress || ((i = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : i.includes("Googlebot")) || ((n = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : n.includes("AdsBot")))
            (s = this._firstLoadListeners) == null || s.stopListening();
          else
            try {
              if (e != null && e.forceNew)
                return void (yield this._reset(e));
              const r = Ie(re.RECORDING_START_TIME);
              r ? this._recordingStartTime = parseInt(r, 10) : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), ve(re.RECORDING_START_TIME, this._recordingStartTime.toString()));
              let c, d = Ie("highlightClientID");
              d || (d = ci(), ve("highlightClientID", d)), Li(null), c = !this.options.disableSessionRecording && this.options.disableNetworkRecording === void 0 && typeof this.options.networkRecording != "boolean" && (((o = this.options.networkRecording) == null ? void 0 : o.recordHeadersAndBody) || !1);
              let u = [];
              if (typeof this.options.networkRecording == "object" && ((l = this.options.networkRecording.destinationDomains) != null && l.length) && (u = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
                yield this._setupCrossOriginIframe();
              else {
                const Z = yield this.graphqlSDK.initializeSession({ organization_verbose_id: this.organizationID, enable_strict_privacy: this.privacySetting === "strict", privacy_setting: this.privacySetting, enable_recording_network_contents: c, clientVersion: this.firstloadVersion, firstloadVersion: this.firstloadVersion, clientConfig: JSON.stringify(this._optionsInternal), environment: this.environment, id: d, appVersion: this.appVersion, serviceName: this.serviceName, session_secure_id: this.sessionData.sessionSecureID, client_id: d, network_recording_domains: u, disable_session_recording: this.options.disableSessionRecording });
                if (Z.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(`Unexpected secure id returned by initializeSession: ${Z.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`), this.sessionData.sessionSecureID = Z.initializeSession.secure_id, this.sessionData.projectID = parseInt(((a = Z == null ? void 0 : Z.initializeSession) == null ? void 0 : a.project_id) || "0"), !this.sessionData.projectID || !this.sessionData.sessionSecureID)
                  return void console.error("Failed to initialize Highlight; an error occurred on our end.", this.sessionData);
              }
              if (this.logger.log(`Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({ message: { type: Ye.Initialize, sessionSecureID: this.sessionData.sessionSecureID, backend: this._backendUrl, debug: !!this.debugOptions.clientInteractions, recordingStartTime: this._recordingStartTime } }), Zs(this.sessionData.sessionSecureID), this.sessionData.userIdentifier && this.identify(this.sessionData.userIdentifier, this.sessionData.userObject), this._firstLoadListeners.isListening() ? this._firstLoadListeners.hasNetworkRecording || Ke.setupNetworkListener(this._firstLoadListeners, this.options) : this._firstLoadListeners.startListening(), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
                this._save();
              }, 1e3)), this.options.disableSessionRecording)
                return this.logger.log("Highlight is NOT RECORDING a session replay per H.init setting."), this.ready = !0, this.state = "Recording", void (this.manualStopped = !1);
              const { getDeviceDetails: p } = (() => {
                if (!("performance" in window) || !("memory" in performance))
                  return { getDeviceDetails: void 0, getCurrentDeviceDetails: void 0 };
                const Z = window.performance;
                return { getDeviceDetails: () => ({ deviceMemory: Lr(navigator.deviceMemory || 0) }), getCurrentDeviceDetails: () => ({ jsHeapSizeLimit: ln(Z.memory.jsHeapSizeLimit), totalJSHeapSize: ln(Z.memory.totalJSHeapSize), usedJSHeapSize: ln(Z.memory.usedJSHeapSize) }) };
              })();
              p && this.recordMetric([{ name: Vt.DeviceMemory, value: p().deviceMemory, category: Ne.Device, group: window.location.href }]);
              const m = (Z) => {
                this.events.push(Z);
              };
              m.bind(this), this._recordStop && (this._recordStop(), this._recordStop = void 0);
              const [I, y] = ((Z) => {
                switch (Z) {
                  case "strict":
                  case "default":
                    return [!0, void 0];
                  case "none":
                    return [!1, { password: !0 }];
                }
              })(this.privacySetting);
              this._recordStop = Je({ ignoreClass: "highlight-ignore", blockClass: "highlight-block", emit: m, recordCrossOriginIframes: this.options.recordCrossOriginIframe, privacySetting: this.privacySetting, maskAllInputs: I, maskInputOptions: y, recordCanvas: this.enableCanvasRecording, sampling: { canvas: { fps: this.samplingStrategy.canvas, fpsManual: this.samplingStrategy.canvasManualSnapshot, resizeFactor: this.samplingStrategy.canvasFactor, clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer, initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay, dataURLOptions: { type: "image/webp", quality: 0.9 }, maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension } }, keepIframeSrcFn: (Z) => !this.options.recordCrossOriginIframe, inlineImages: this.inlineImages, inlineStylesheet: this.inlineStylesheet, plugins: [il()], logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? { debug: this.logger.log, warn: kt } : void 0 });
              const W = { height: window.innerHeight, width: window.innerWidth };
              this.addCustomEvent("Viewport", W), this.submitViewportMetrics(W), this._recordStop || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties({ referrer: document.referrer }, { type: "session" }))), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
            } catch (r) {
              this._isOnLocalHost && (console.error(r), kt("initializeSession", r));
            }
        });
      }
      _visibilityHandler(e) {
        return ue(this, null, function* () {
          this.manualStopped ? this.logger.log("Ignoring visibility event due to manual stop.") : (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < 100 || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${e ? "hidden" : "visible"}.`), e ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stopRecording()) : (this.options.disableBackgroundRecording && (yield this.initialize()), this.addCustomEvent("TabHidden", !1)));
        });
      }
      _setupCrossOriginIframe() {
        return ue(this, null, function* () {
          this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((e) => {
            const i = (n) => {
              if (n.data.highlight === Vo) {
                const s = n.data;
                this.logger.log("highlight got window message ", s), this.sessionData.projectID = s.projectID, this.sessionData.sessionSecureID = s.sessionSecureID, window.parent.postMessage({ highlight: Xo }, "*"), window.removeEventListener("message", i), e();
              }
            };
            window.addEventListener("message", i);
          });
        });
      }
      _setupCrossOriginIframeParent() {
        this.logger.log("highlight setting up cross origin iframe parent notification"), setInterval(() => {
          window.document.querySelectorAll("iframe").forEach((e) => {
            var i;
            (i = e.contentWindow) == null || i.postMessage({ highlight: Vo, projectID: this.sessionData.projectID, sessionSecureID: this.sessionData.sessionSecureID }, "*");
          });
        }, 1e3), window.addEventListener("message", (e) => {
          e.data.highlight === Xo && this.logger.log("highlight got response from initialized iframe");
        });
      }
      _setupWindowListeners() {
        var e;
        try {
          const n = this;
          this.enableSegmentIntegration && this.listeners.push(yr((o) => {
            if (o.type === "track") {
              const l = {};
              l["segment-event"] = o.event, n.addProperties(l, { type: "track", source: "segment" });
            } else if (o.type === "identify") {
              const l = o.userId.replace(/^"(.*)"$/, "$1");
              n.identify(l, o.traits, "segment");
            }
          })), this.listeners.push(Wl((o) => {
            this.reloaded ? (this.addCustomEvent("Reload", o), this.reloaded = !1, n.addProperties({ reload: !0 }, { type: "session" })) : this.addCustomEvent("Navigate", o), n.addProperties({ "visited-url": o }, { type: "session" });
          })), this.listeners.push(((o) => {
            let l;
            const a = () => {
              clearTimeout(l), l = setTimeout(() => {
                o({ height: window.innerHeight, width: window.innerWidth });
              }, 500);
            };
            return window.addEventListener("resize", a), () => window.removeEventListener("resize", a);
          })((o) => {
            this.addCustomEvent("Viewport", o), this.submitViewportMetrics(o);
          })), this.listeners.push(((o) => {
            const l = (a) => {
              if (a.target) {
                const r = Ps(a.target);
                o(r, a);
              }
            };
            return window.addEventListener("click", l), () => window.removeEventListener("click", l);
          })((o, l) => {
            o && this.addCustomEvent("Click", o);
            let a = null, r = null;
            if (l && l.target) {
              const c = l.target;
              a = As(c), r = c.textContent, r && r.length > 2e3 && (r = r.substring(0, 2e3));
            }
            n.addProperties({ clickTextContent: r, clickSelector: a }, { type: "session" });
          })), this.listeners.push(((o) => {
            const l = (a) => {
              if (a.target) {
                const r = Ps(a.target);
                o(r);
              }
            };
            return window.addEventListener("focusin", l), () => window.removeEventListener("focusin", l);
          })((o) => {
            o && this.addCustomEvent("Focus", o);
          })), this.listeners.push(wr((o) => {
            const { name: l, value: a } = o;
            this.recordMetric([{ name: l, value: a, group: window.location.href, category: Ne.WebVital }]);
          })), this.sessionShortcut && Sr(this.sessionShortcut, () => {
            window.open(this.getCurrentSessionURLWithTimestamp(), "_blank");
          }), this.enablePerformanceRecording && (this.listeners.push(((o, l) => {
            let a = 0, r = 0;
            const c = () => {
              const I = ((/* @__PURE__ */ new Date()).getTime() - l) / 1e3, y = yo.memory.jsHeapSizeLimit || 0, W = yo.memory.usedJSHeapSize || 0;
              o({ jsHeapSizeLimit: y, usedJSHeapSize: W, relativeTimestamp: I, fps: a });
            };
            let d;
            c(), d = setInterval(() => {
              c();
            }, 5e3);
            let u = 0, p = Date.now();
            const m = function() {
              var I = Date.now();
              u++, I > 1e3 + p && (a = Math.round(1e3 * u / (I - p)), u = 0, p = I), r = requestAnimationFrame(m);
            };
            return m(), () => {
              clearInterval(d), cancelAnimationFrame(r);
            };
          })((o) => {
            this.addCustomEvent("Performance", Be(o)), this.recordMetric(Object.entries(o).map(([l, a]) => a ? { name: l, value: a, category: Ne.Performance, group: window.location.href } : void 0).filter((l) => l));
          }, this._recordingStartTime)), this.listeners.push(((o, l) => {
            let a = {}, r = 16.666666666666668;
            Fr().then((m) => r = m);
            const c = (m) => {
              var I;
              a != null && a.event || (a = { event: m, location: window.location.href, timerStart: (I = window.performance) == null ? void 0 : I.now() }, window.requestAnimationFrame(d));
            }, d = () => {
              if (!(a != null && a.timerStart))
                return;
              const m = window.performance.now() - a.timerStart - r;
              u(m), a = {};
            }, u = (m) => {
              const I = ((/* @__PURE__ */ new Date()).getTime() - l) / 1e3;
              o({ relativeTimestamp: I, jankAmount: m, querySelector: p(), newLocation: window.location.href != a.location ? window.location.href : void 0 });
            }, p = () => {
              var m;
              return (m = a == null ? void 0 : a.event) != null && m.target ? As(a.event.target) : "";
            };
            return window.addEventListener("click", c, !0), window.addEventListener("keydown", c, !0), () => {
              window.removeEventListener("keydown", c, !0), window.removeEventListener("click", c, !0);
            };
          })((o) => {
            this.addCustomEvent("Jank", Be(o)), this.recordMetric([{ name: "Jank", value: o.jankAmount, category: Ne.WebVital, group: o.querySelector }]);
          }, this._recordingStartTime))), this._hasPreviouslyInitialized || ((e = window.electron) != null && e.ipcRenderer ? (window.electron.ipcRenderer.on("highlight.run", ({ visible: o }) => {
            this._visibilityHandler(!o);
          }), this.logger.log("Set up Electron highlight.run events.")) : (((o) => {
            let l, a;
            if (document.hidden !== void 0 ? (l = "hidden", a = "visibilitychange") : document.msHidden !== void 0 ? (l = "msHidden", a = "msvisibilitychange") : document.webkitHidden !== void 0 && (l = "webkitHidden", a = "webkitvisibilitychange"), a === void 0)
              return () => {
              };
            if (l === void 0)
              return () => {
              };
            const r = l, c = () => {
              const d = document[r];
              o(!!d);
            };
            document.addEventListener(a, c);
          })((o) => this._visibilityHandler(o)), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
          const s = () => {
            this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
          };
          window.addEventListener("beforeunload", s), this.listeners.push(() => window.removeEventListener("beforeunload", s));
        } catch (n) {
          this._isOnLocalHost && (console.error(n), kt("initializeSession _setupWindowListeners", n));
        }
        const i = () => {
          this.addCustomEvent("Page Unload", ""), Li(this.sessionData);
        };
        if (window.addEventListener("beforeunload", i), this.listeners.push(() => window.removeEventListener("beforeunload", i)), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
          const n = () => {
            this.addCustomEvent("Page Unload", ""), Li(this.sessionData);
          };
          window.addEventListener("pagehide", n), this.listeners.push(() => window.removeEventListener("beforeunload", n));
        }
      }
      submitViewportMetrics({ height: e, width: i }) {
        this.recordMetric([{ name: Vt.ViewportHeight, value: e, category: Ne.Device, group: window.location.href }, { name: Vt.ViewportWidth, value: i, category: Ne.Device, group: window.location.href }, { name: Vt.ViewportArea, value: e * i, category: Ne.Device, group: window.location.href }]);
      }
      recordMetric(e) {
        this._worker.postMessage({ message: { type: Ye.Metrics, metrics: e.map((i) => Te(z({}, i), { tags: i.tags || [], group: i.group || window.location.href, category: i.category || Ne.Frontend, timestamp: /* @__PURE__ */ new Date() })) } });
      }
      stopRecording(e) {
        this.manualStopped = !!e, this.manualStopped && this.addCustomEvent("Stop", "H.stop() was called which stops Highlight from recording."), this.state = "NotRecording", e && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((i) => i()), this.listeners = [];
      }
      getCurrentSessionTimestamp() {
        return this._recordingStartTime;
      }
      getCurrentSessionURLWithTimestamp() {
        const e = (/* @__PURE__ */ new Date()).getTime(), { projectID: i, sessionSecureID: n } = this.sessionData, s = (e - this._recordingStartTime) / 1e3;
        return `https://${Go}/${i}/sessions/${n}?ts=${s}`;
      }
      getCurrentSessionURL() {
        const e = this.sessionData.projectID, i = this.sessionData.sessionSecureID;
        return e && i ? `https://${Go}/${e}/sessions/${i}` : null;
      }
      snapshot(e) {
        return ue(this, null, function* () {
          yield Je.snapshotCanvas(e);
        });
      }
      addSessionFeedback({ timestamp: e, verbatim: i, user_email: n, user_name: s }) {
        var o;
        this._worker.postMessage({ message: { type: Ye.Feedback, verbatim: i, timestamp: e, userName: s || this.sessionData.userIdentifier, userEmail: n || ((o = this.sessionData.userObject) == null ? void 0 : o.name) } });
      }
      _save() {
        return ue(this, null, function* () {
          var e;
          try {
            let i;
            this.state === "Recording" && this.listeners && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > 144e5 && (this.logger.log("Resetting session", { start: this.sessionData.sessionStartTime }), yield this._reset({})), ((e = this.options) == null ? void 0 : e.sendMode) === "local" && (i = (n) => ue(this, null, function* () {
              let s = new Blob([JSON.stringify({ query: Us(zs), variables: n })], { type: "application/json" });
              return yield window.fetch(`${this._backendUrl}`, { method: "POST", body: s }), 0;
            })), yield this._sendPayload({ sendFn: i }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now();
          } catch (i) {
            this._isOnLocalHost && (console.error(i), kt("_save", i));
          }
          this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
            this._save();
          }, 2e3));
        });
      }
      addCustomEvent(e, i) {
        if (this.state === "NotRecording") {
          let n;
          const s = () => {
            clearInterval(n), this.state === "Recording" && this.events.length > 0 ? is(e, i) : n = setTimeout(s, 500);
          };
          n = setTimeout(s, 500);
        } else
          this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && is(e, i);
      }
      _sendPayload(e) {
        return ue(this, arguments, function* ({ sendFn: i }) {
          const n = Ke.getRecordedNetworkResources(this._firstLoadListeners, this._recordingStartTime), s = Ke.getRecordedWebSocketEvents(this._firstLoadListeners), o = [...this.events], l = [...this._firstLoadListeners.messages], a = [...this._firstLoadListeners.errors], { bytes: r, time: c } = this.enableCanvasRecording ? ms.canvas : ms.normal;
          this._eventBytesSinceSnapshot >= r && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= c && this.takeFullSnapshot(), this.logger.log(`Sending: ${o.length} events, ${l.length} messages, ${n.length} network resources, ${a.length} errors 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`);
          const d = Ie(vt) || "";
          i ? yield i({ session_secure_id: this.sessionData.sessionSecureID, payload_id: this._payloadId.toString(), events: { events: o }, messages: Be({ messages: l }), resources: JSON.stringify({ resources: n }), web_socket_events: JSON.stringify({ webSocketEvents: s }), errors: a, is_beacon: !1, has_session_unloaded: this.hasSessionUnloaded }) : this._worker.postMessage({ message: { type: Ye.AsyncEvents, id: this._payloadId, events: o, messages: l, errors: a, resourcesString: JSON.stringify({ resources: n }), webSocketEventsString: JSON.stringify({ webSocketEvents: s }), hasSessionUnloaded: this.hasSessionUnloaded, highlightLogs: d } }), this._payloadId++, ve(re.PAYLOAD_ID, this._payloadId.toString()), Ke.clearRecordedNetworkResources(this._firstLoadListeners), this.events = this.events.slice(o.length), this._firstLoadListeners.messages = this._firstLoadListeners.messages.slice(l.length), this._firstLoadListeners.errors = this._firstLoadListeners.errors.slice(a.length), xr(d);
        });
      }
      takeFullSnapshot() {
        Je.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
      }
    }
    We.FirstLoadListeners = Ke, We.GenerateSecureID = ci, We.Highlight = rn, We.HighlightWarning = kt, We.MetricCategory = Ne, We.getPreviousSessionData = bs, Object.defineProperty(We, Symbol.toStringTag, { value: "Module" });
  });
})(un, un.exports);
var na = un.exports;
const oa = /* @__PURE__ */ ia({
  __proto__: null
}, [na]);
export {
  oa as i
};
//# sourceMappingURL=index-D9pynCqZ.js.map
